<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    :class="`million${num}`"
    id="milestone-million"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 465 476.8"
    role="presentation"
    aria-labelledby="`milliondevsatnetlify${num}`"
  >
    <title id="`milliondevsatnetlify${num}`">Netlify reaches a million developers!</title>
    <defs>
      <clipPath id="clip-path" transform="translate(3.3)">
        <path
          class="cls-1 whitebloop"
          d="M231.8,26s-2,132.8-4.3,132.8S223.2,26,223.2,26a4.3,4.3,0,0,1,8.6,0ZM163.5,185.3c1.6-1.7-90.8-96.9-90.8-96.9a4.4,4.4,0,0,0-6,0h-.1a4.1,4.1,0,0,0,.1,5.9S161.9,187,163.5,185.3Zm-26.5,64C137,246.9,4.3,245,4.3,245H3a4.3,4.3,0,1,0,1.3,8.5S137,251.6,137,249.3Zm26.5,63.9c-1.6-1.5-96.8,90.9-96.8,90.9a4.2,4.2,0,0,0,6,6S165.2,314.9,163.5,313.2Zm64,26.5c-2.3,0-4.3,132.8-4.3,132.8a4.3,4.3,0,0,0,8.6,0S229.8,339.7,227.5,339.7Zm64-26.5c-1.6,1.7,90.8,96.9,90.8,96.9a4.2,4.2,0,0,0,6-6S293.1,311.5,291.5,313.2Zm164.1-64.6a4.3,4.3,0,0,0-4.9-3.6S318,246.9,318,249.3s132.7,4.2,132.7,4.2H452A4.3,4.3,0,0,0,455.6,248.6ZM291.5,185.3c1.7,1.6,96.8-90.9,96.8-90.9h.1a4.1,4.1,0,0,0-.1-5.9,4.3,4.3,0,0,0-6,0S289.8,183.6,291.5,185.3Zm10.1-54.4a3.2,3.2,0,0,0-1.4-4.2l-.4-.2a3.1,3.1,0,0,0-4.3,1.3s-32.4,57.6-30.7,58.5,36.7-55.1,36.5-55ZM192.2,111a3.3,3.3,0,0,0-2.4,4.1s17.8,63.7,19.6,63.2-13-64.8-13-64.9A3.4,3.4,0,0,0,192.2,111ZM164.6,211.9c.9-1.6-55.1-36.6-55-36.5a3.4,3.4,0,0,0-3.5,5.9S163.7,213.6,164.6,211.9ZM90.7,280.6a3.5,3.5,0,1,0,2.8,6.4s63.7-17.9,63.2-19.7-64.9,13-64.9,13A2.3,2.3,0,0,0,90.7,280.6Zm99.5,31.6c-1.7-.9-36.7,55.1-36.5,55l-.3.4a3.2,3.2,0,0,0,1.4,4.2.5.5,0,0,0,.4.2,3.1,3.1,0,0,0,4.3-1.3S191.9,313.1,190.2,312.2Zm55.4,7.9c-1.8.5,13,64.9,13,64.9a3.5,3.5,0,0,0,4.2,2.5,3.4,3.4,0,0,0,2.4-4.2S247.4,319.6,245.6,320.1Zm44.8-33.5c-.9,1.7,55.1,36.6,55,36.5h.2a3.3,3.3,0,0,0,4.5-1.3h0a3.3,3.3,0,0,0-1.2-4.6S291.3,284.9,290.4,286.6ZM365.7,214c0-.1,0-.2-.1-.2a3.3,3.3,0,0,0-4.1-2.2s-63.7,17.8-63.2,19.6,64.9-13,64.9-13A3.6,3.6,0,0,0,365.7,214ZM279.2,67.3v-.2a4,4,0,0,0-3-4.9,4.2,4.2,0,0,0-5,3s-23.7,98.3-21.5,98.8S279.2,67.3,279.2,67.3ZM182.9,173.2c2-1.2-47.6-89.3-47.6-89.4a4.2,4.2,0,1,0-7.1,4.3S181,174.4,182.9,173.2ZM43.4,205.6s98.3,23.6,98.8,21.4-96.7-29.5-96.7-29.5a4.2,4.2,0,0,0-2.1,8.1Zm108,88.2c-1.1-1.9-89.3,47.6-89.4,47.6a4.1,4.1,0,0,0-1.4,5.4,4.2,4.2,0,0,0,5.7,1.8S152.6,295.8,151.4,293.8Zm24.4,137.5v.2a3.9,3.9,0,0,0,2.9,4.8,4.2,4.2,0,0,0,5.1-3s23.7-98.2,21.5-98.8S175.8,431.3,175.8,431.3Zm96.3-106c-2,1.2,47.6,89.3,47.6,89.4a4.1,4.1,0,1,0,7.1-4.2S274,324.1,272.1,325.3Zm139.5-32.4s-98.3-23.6-98.8-21.4S409.5,301,409.5,301a4.2,4.2,0,0,0,2.1-8.1ZM303.5,204.7c1.2,1.9,89.4-47.6,89.5-47.6a4.1,4.1,0,0,0,1.4-5.4,4.2,4.2,0,0,0-5.7-1.8S302.4,202.7,303.5,204.7Z"
        />
      </clipPath>
      <clipPath id="clip-path-2" transform="translate(3.3)">
        <path
          id="dev-clip"
          class="cls-1"
          d="M305.5,314.4v-.3c-.1-.7-.1-1.2-.2-1.8a5.1,5.1,0,0,0-.2-1.3,4.3,4.3,0,0,0-.2-1.1v-.5a38.1,38.1,0,0,0-2.4-6.7c2.1-1.8,2.6-4.7,2.4-7.3a2.8,2.8,0,0,1-.1-.9c-.1-.1-.1-.2-.1-.4a1.7,1.7,0,0,0-.1-.7.7.7,0,0,0-.1-.5c0-.2.1-.6-.1-.7V292a4.3,4.3,0,0,1-.2-1.1c-.1-.1-.1-.1-.1-.2l-.3-1c0-.3-.4-1.2-.3-1.5l-.3-1h-.1a3.6,3.6,0,0,0-.4-1.1c0-.1-.1-.1-.1-.2l-.5-1.1a4.7,4.7,0,0,1-.5-1c-.1-.3-.4-.7-.6-1.2s0-.1-.1-.2a4.1,4.1,0,0,0-.5-.9h-.1a5.6,5.6,0,0,0-.5-.8v-.2l-.5-.8h-.1a.5.5,0,0,0-.2-.4,24.8,24.8,0,0,0-1.9-2.6h-.1l-.7-.8c0-.1-.1-.1-.1-.2l-.2-.3h-.1l-1.5-1.7h-.1a9.4,9.4,0,0,0-1-1l-1.2-1.1h-.1l-1.5-1.3-2.3-1.8h-.2a.2.2,0,0,0-.2-.2l-1.2-.9h-.1l-.4-.3h-.3l-.9-.6h-.2l-1.1-.7h-.1l-2.5-1.5h-.3l-.8-.4a6.7,6.7,0,0,0-1.2-.6h-.2l-1-.5h-.3a14.6,14.6,0,0,0-1.9-.7,11.1,11.1,0,0,1-2.5-.5c-.6-.3-7.2-.2-8-.2.3-6.3-16.6-12.4-20.4-15.5a7.9,7.9,0,0,0-8.5.6c-.8-2.9-1.4-6.6-4.4-8l-16.6-9.7-.9-.4-.9-.6-33.3-22.4c-2.5-1.7-5.6-1.3-8.1.2l-.6-.7h-.1l-.7-.9v-.2l-.7-.7v-.2l-1.1-1.2h-.1a12.9,12.9,0,0,0-1.6-1.7l-.9-.9h-.1l-2.5-2.2H163l-1.1-.9h-.2l-1.1-.8h-.2l-.6-.4h-.2l-.4-.3h-.3l-1-.7h-.3l-1.1-.7h-.2l-.3-.3-1.3-.7L135,179.4c-2.5-.8-5.4-1.1-7.7.3L90.8,200.9a7.6,7.6,0,0,0-3.7,6.5l-.2,47.9a7.6,7.6,0,0,0,3.8,6.6c11.5,5.6,27.2,19.5,41,16.3-.3,3.5.3,7.6,3.7,9.5L168.8,307c3.6,2.3,7.8.1,11-2,1.2,3.5,1.7,10.3,5.5,12.1l16.7,9.6c4.5,3.1,10.2-1.7,14-3.8,5.7,15.8,21.3,29.1,38.3,30.6a14.7,14.7,0,0,0,7.6-2l36.4-21.2.8-.5h.1l.2-.2a7,7,0,0,0,1.6-1.4q.2,0,.3-.3a1.9,1.9,0,0,0,.6-.7,2,2,0,0,1,.6-.7c.1-.2.3-.4.3-.5a8.7,8.7,0,0,0,1-1.9.4.4,0,0,0,.1-.3c.1,0,.1-.1.1-.2l.3-.7a.6.6,0,0,0,.1-.4l.3-.8v-.3a5.3,5.3,0,0,0,.3-1.2.4.4,0,0,0,.1-.3c.1-.4,0-.8.2-1.1v-.7a.6.6,0,0,0,.1-.4C305.4,316.9,305.5,315.3,305.5,314.4Zm-79.4,12.3v.2l-.2-.2Z"
        />
      </clipPath>
      <clipPath id="clip-path-3" transform="translate(3.3)">
        <path
          id="logo-clip"
          class="cls-1"
          d="M179.3,168.7c-3.1-9.5-10.7-19.2-15.2-28.2s-12.5-28.8-24-19.8c-13.8,7.5-43.4,25.1-57.5,33.2-12.5,7.8,1.5,21.7,5.6,30.6,6.7,8.2,13.9,37.3,29,27.5,13.8-7.3,43.5-24.9,57.5-32.8C178.4,177.3,179.6,172.7,179.3,168.7Z"
        />
      </clipPath>
      <clipPath id="clip-path-4" transform="translate(3.3)">
        <path
          id="one-clip"
          class="cls-1"
          d="M270.2,189.4,252.3,179a7.9,7.9,0,0,0-7.6,0l-3.9,2.3-4.5-9.9a8.5,8.5,0,0,0-3.1-3.4l-18-10.4-.7-.4a12.5,12.5,0,0,0-1.9-1.5l-15.2-8.8a7.5,7.5,0,0,0-3.8-1,6.6,6.6,0,0,0-3.7,1l-36.6,21.2-.3.2-19.3,12.5a7.5,7.5,0,0,0-2.7,9.8l9.1,17.7a6.9,6.9,0,0,0,4.5,3.8l1.4.3v15.4a7.3,7.3,0,0,0,3.7,6.6l18.6,10.7,1.4.6,1.3,1,18.4,10.6a7.9,7.9,0,0,0,3.7,1,8.6,8.6,0,0,0,3.8-1l7-4.1v8.1a7,7,0,0,0,3.7,6.5l18.3,10.6a7.9,7.9,0,0,0,7.6,0L270,257.2a8.1,8.1,0,0,0,3.8-6.5V195.9A7.7,7.7,0,0,0,270.2,189.4Z"
        />
      </clipPath>
    </defs>
    <g>
      <g class="cls-2">
        <ellipse id="back-circle" class="cls-3" cx="232.5" cy="246.6" rx="232.5" ry="230.2" />
      </g>
      <g id="Left_Bolt" data-name="Left Bolt">
        <polygon class="cls-3" points="90.4 113.4 121.3 64.4 112.6 59.2 81.7 108.2 90.4 113.4" />
        <polygon
          class="cls-3"
          points="83.9 154.9 97.4 123.5 83 131.8 82.9 131.9 75.3 149.8 83.9 154.9"
        />
        <polygon class="cls-3" points="111.1 101.3 124.9 93.4 116.7 88.4 111.1 101.3" />
        <polygon class="cls-3" points="82.9 157.2 74.3 152.1 66.8 169.5 75.4 174.8 82.9 157.2" />
        <polygon class="cls-3" points="113.9 57.2 122.6 62.4 127.1 55.2 118.5 49.9 113.9 57.2" />
        <polygon class="cls-3" points="89.1 115.5 80.4 110.3 71.9 123.8 80.6 128.9 89.1 115.5" />
        <path
          class="cls-4"
          d="M127.4,56v-.7a2,2,0,0,0-.9-1.3h-.2l-10.5-6.6h-1.1a2.4,2.4,0,0,0-1.5,1.1L66.4,122.9c-.3.4-.8,1.2-.3,1.9l.3.6,10.5,6.1.2.3-15.9,37a1.9,1.9,0,0,0,.6,2.6L72,177.6l.5.4.8.2a2.5,2.5,0,0,0,1.9-1.2l50-81.6a2.1,2.1,0,0,0-.1-2.6l-.7-.4h-.2l-9.8-6.1,12.8-29.6A1.9,1.9,0,0,0,127.4,56Zm-18.1,3.2,8.7,5.2L87.1,113.5l-8.7-5.2ZM79.6,132h.1l14.4-8.3L80.6,155.1,72,149.9Zm39.7-69.6-8.7-5.2,4.6-7.3,8.6,5.3Zm-42.2,48,8.7,5.2-8.5,13.3-8.7-5.1ZM71,152.1l8.6,5.2-7.5,17.5-8.6-5.2Zm36.8-50.7,5.6-13,8.2,5Z"
          transform="translate(3.3)"
        />
        <rect
          class="cls-4"
          x="78"
          y="62"
          width="32.9"
          height="2.49"
          transform="translate(-6.4 108.9) rotate(-57.5)"
        />
        <rect
          class="cls-4"
          x="75.4"
          y="83.7"
          width="10.3"
          height="2.49"
          transform="translate(-31.1 107.4) rotate(-57.6)"
        />
        <rect
          class="cls-4"
          x="75.3"
          y="162.1"
          width="32.9"
          height="2.49"
          transform="translate(-92.1 152.9) rotate(-57.5)"
        />
        <polygon
          class="cls-4"
          points="84.9 181.7 82.8 180.3 77.3 189 79.3 190.3 79.4 190.3 84.9 181.7"
        />
      </g>
      <g id="Base">
        <path
          class="cls-3"
          d="M376.2,291.9a60.2,60.2,0,0,0,1.9-11.9,58.7,58.7,0,0,1-8.9,18.1c-7.5,10.8-18.6,20.5-32.9,28.7-29.3,17-67.9,25.4-106.5,25.4h-.9c-43.3.3-82.9-9.8-112.6-29.4-11.6-7.5-29.4-22-35.8-42.8v.2c1.1,44.7,54.5,66.8,77.4,74.2,42.6,13.2,88.4,14.6,129,3.9C354.2,341,371.7,309.3,376.2,291.9Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-4"
          d="M380.6,266c-.1-2.2-.1-4.4-.1-6.5v-2.3a1.2,1.2,0,0,0-1-1.2c-3.5-20.5-18.8-39.4-44.1-54h-.1c-28.9-16.4-66.8-25.4-106.8-25.4s-77.8,9-106.2,25.4c-14.3,8.3-25.4,17.9-32.9,28.8s-11,21.5-11,32.9a.9.9,0,0,0-.3.7c0,4,0,5.9-.1,6.9a2.2,2.2,0,0,0-.3,1.6c.1.5.1,1.3.2,2.7l.2,4.7c1.2,46.2,55.7,68.8,79.1,76.3a249.1,249.1,0,0,0,73.3,11.2,223.8,223.8,0,0,0,57-7.2c29.4-7.5,80.3-26.4,91-68.1C380.9,283.6,380.7,274.6,380.6,266ZM157.9,354.4C135,347,81.6,324.9,80.5,280.2V280c6.4,20.8,24.2,35.3,35.8,42.8,29.7,19.6,69.3,29.7,112.6,29.4h.9c38.6,0,77.2-8.4,106.5-25.4,14.3-8.2,25.4-17.9,32.9-28.7a58.7,58.7,0,0,0,8.9-18.1,60.2,60.2,0,0,1-1.9,11.9c-4.5,17.4-22,49.1-89.3,66.4C246.3,369,200.5,367.6,157.9,354.4Zm220-89.4c0,22.7-15.2,43.9-42.7,59.8-58.1,33.5-152.6,33.5-210.7,0-28.2-16.3-43.8-37.9-43.8-60.9s15.2-44,42.8-59.8,65.3-25.1,105-25.1,77.1,8.9,105.7,25.1,43.7,37.8,43.7,60.9Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-5"
          d="M334.2,204.1C305.6,187.9,268.1,179,228.5,179s-77,8.9-105,25.1-42.8,37.1-42.8,59.8,15.6,44.6,43.8,60.9c58.1,33.5,152.6,33.5,210.7,0,27.5-15.9,42.7-37.1,42.7-59.8S362.4,220.3,334.2,204.1Z"
          transform="translate(3.3)"
        />
      </g>
      <g id="_1MDV" data-name=" 1MDV">
        <g id="Devs">
          <g class="cls-6">
            <path
              class="cls-4"
              d="M337.4,296.2v-.3c-.1-.7-.1-1.2-.2-1.8a5.9,5.9,0,0,0-.2-1.3,4.3,4.3,0,0,0-.2-1.1v-.5a38.1,38.1,0,0,0-2.4-6.7c2.1-1.8,2.6-4.6,2.4-7.3a2.8,2.8,0,0,1-.1-.9c-.1-.1-.1-.2-.1-.4a1.7,1.7,0,0,0-.1-.7.9.9,0,0,0-.1-.5c0-.2.1-.5-.1-.7v-.2a4.3,4.3,0,0,1-.2-1.1c-.1-.1-.1-.1-.1-.2l-.3-1c0-.3-.3-1.2-.3-1.5l-.3-1H335a4.9,4.9,0,0,0-.4-1.1c0-.1-.1-.1-.1-.2a5.4,5.4,0,0,0-.5-1.1l-.5-1-.6-1.2v-.2a4.1,4.1,0,0,0-.5-.9h-.1a3.5,3.5,0,0,0-.5-.8c0-.1,0-.1-.1-.2l-.5-.8H331a.5.5,0,0,0-.2-.4,24.8,24.8,0,0,0-1.9-2.6h-.1l-.7-.8c0-.1-.1-.1-.1-.2l-.2-.3h-.1l-1.5-1.7h-.1l-1-1-1.2-1.1h-.1l-1.5-1.3-2.3-1.8h-.2a.2.2,0,0,0-.2-.2l-1.2-.9h-.1l-.4-.3h-.3l-.9-.6h-.2l-1.1-.7h-.1l-2.5-1.5h-.3l-.8-.4-1.2-.6h-.2l-1-.5H309a14.6,14.6,0,0,0-1.9-.7,11.1,11.1,0,0,1-2.5-.5c-.6-.3-7.2-.2-8-.2.4-6.3-16.6-12.4-20.4-15.5a7.9,7.9,0,0,0-8.5.6c-.7-2.9-1.4-6.6-4.4-8l-16.6-9.7-.9-.4-.9-.6-33.3-22.4c-2.5-1.7-5.6-1.3-8.1.2l-.6-.7h-.1l-.7-.9v-.2l-.7-.7v-.2l-1.1-1.2h-.1a12.9,12.9,0,0,0-1.6-1.7l-.9-.9h-.1l-2.5-2.2h-.2l-1.1-.9h-.2l-1.1-.8h-.2l-.6-.4h-.2l-.4-.3h-.3l-1-.7h-.3l-1.1-.7h-.2l-.3-.3-1.3-.7-19.7-12.7c-2.5-.8-5.4-1.1-7.7.3l-36.5,21.2a7.6,7.6,0,0,0-3.7,6.5l-.2,47.9a7.6,7.6,0,0,0,3.8,6.6c11.5,5.6,27.3,19.5,41,16.3-.3,3.5.3,7.6,3.7,9.5l33.4,19.3c3.7,2.3,7.8.1,11-2,1.2,3.5,1.7,10.3,5.5,12.1l16.7,9.6c4.5,3.1,10.2-1.7,14-3.8,5.7,15.8,21.3,29.1,38.3,30.6a14.4,14.4,0,0,0,7.6-2l36.4-21.2.8-.5h.1c.1-.1.2-.1.2-.2a7,7,0,0,0,1.6-1.4q.2,0,.3-.3a1.3,1.3,0,0,0,.6-.7l.6-.7.3-.5a6.9,6.9,0,0,0,1-1.9.4.4,0,0,0,.1-.3c.1,0,.1-.1.1-.2l.3-.7a.6.6,0,0,0,.1-.4l.3-.8v-.3a5.3,5.3,0,0,0,.3-1.2.4.4,0,0,0,.1-.3c.1-.4,0-.8.2-1.1v-.7a.6.6,0,0,0,.1-.4C337.3,298.7,337.4,297.1,337.4,296.2ZM258,308.6h0a.3.3,0,0,1-.1-.2Z"
              transform="translate(3.3)"
            />
            <path
              class="cls-3"
              d="M126.3,237.1l19.5,11.2a38.5,38.5,0,0,0,7.1,3.4,19.1,19.1,0,0,0,6.3,1.3,8.5,8.5,0,0,0,8.8-6.2,26.1,26.1,0,0,0,1.3-8.8,40.1,40.1,0,0,0-1.9-12.4,37.6,37.6,0,0,0-5.3-10.6,57.7,57.7,0,0,0-7.4-8.2,50.3,50.3,0,0,0-8.8-6.3l-19.5-11.3Zm16.3-23.9,3.2,1.9a12.6,12.6,0,0,1,5.3,5.9,17.2,17.2,0,0,1,1.9,7.7c0,2.5-.6,4.3-1.9,5.4a3.7,3.7,0,0,1-2.9.6l-.8-.2-.3-.2a3.1,3.1,0,0,1-1.3-.6l-3.3-1.9Zm61.8,54.9-17.2-9.9v-3.1l16.5,9.5V251.3l-16.5-9.6v-3.2l17.2,9.9V234.3l-33.3-19.2-.2,47.8,33.4,19.3Zm33.2,33.8,14.8-38V262l-16.6-9.6-3.3,8.8-3.3,15.6-3.1-19.3L222.9,245l-16.6-9.7v1.9l14.6,55.1Zm54.5,22.5a12,12,0,0,0,1.2-5.9,18.1,18.1,0,0,0-.7-5.2,20.4,20.4,0,0,0-1.7-4.7,24.9,24.9,0,0,0-2.9-4.3,28.2,28.2,0,0,0-3.3-3.6,31.7,31.7,0,0,0-3.9-3.4c-1.6-1.3-2.9-2.2-3.9-2.9l-3.9-2.7a4.6,4.6,0,0,1-2.5-4c0-.9.3-1.3,1-1.4a4.4,4.4,0,0,1,2.2.7,7.1,7.1,0,0,1,2.3,1.9,3.7,3.7,0,0,1,1,2.2l15.8,9.1a28.2,28.2,0,0,0-5.5-15.3,44.5,44.5,0,0,0-13.8-12.1c-5.4-3.1-10-4.4-13.8-3.7s-5.6,3.3-5.7,8a20.6,20.6,0,0,0,1.2,7,23.4,23.4,0,0,0,2.8,6,35.8,35.8,0,0,0,4.4,5.1,51.5,51.5,0,0,0,5,4.3c1.5,1.1,3.4,2.5,5.6,3.9a26.1,26.1,0,0,1,3.1,2.7,4,4,0,0,1,.8,2.3c0,1.5-1.1,1.7-3.3.4s-3.7-3.1-3.7-5.1l-16.2-9.3a27.7,27.7,0,0,0,5.6,16.4,43.3,43.3,0,0,0,14,12.6,37.7,37.7,0,0,0,5.7,2.8,19.5,19.5,0,0,0,5.4,1.4,11.9,11.9,0,0,0,4.6-.3A6.7,6.7,0,0,0,292.1,324.4Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
        <g id="Logo">
          <rect
            id="colorboc"
            class="cls-7"
            x="122.5"
            y="129.6"
            width="38.3"
            height="56.49"
            transform="translate(-55.3 87.9) rotate(-28.8)"
          />
          <g id="logo-n">
            <g class="cls-8">
              <path
                class="cls-4"
                d="M211.4,150c-3.1-9.5-10.8-19.2-15.2-28.2S183.7,93,172.2,102c-13.8,7.5-43.4,25.1-57.5,33.2-12.5,7.8,1.5,21.7,5.6,30.6,6.6,8.2,13.9,37.2,29,27.5,13.8-7.3,43.5-24.9,57.5-32.8C210.4,158.6,211.7,154,211.4,150Zm-56.8-.5,4.7,8.3c-1.1-.2-5.5-.3-5.8-1.7Zm-1.4-2.5c-.4.3-.6,9-2.1,7.9h0c-7.1-8.6-12.1-6.9-3-16.5Zm-2.3,11.7c.8,0-1.4,9.4-1.2,9.7a1.5,1.5,0,0,0-1.9.2l-12.9-10.4-.2-.9ZM134,155.3c-.2-.1,5.9-7.1,5.9-7.2s2.1,1.1,2.8.2,8.3,7.7,7.3,8.5Zm5.4-25.5c4.1-3,5.8,3.9,7.6,6.3l-5.4,6.5c-.8-.3-1.7-1.3-2.7-.9s-7-7.5-7.2-7.5Zm-8.8,4.9c1.8,2,5.5,6.4,7.4,8.1a4.5,4.5,0,0,0,.7,3.2c-.2-.2-6,7.3-6.1,7.3s-1.1-.7-1.6-.8-6.3-14.2-6.3-14.4ZM117.2,143c.4-1.2,5.1-3.2,6.2-4.1C133,158.9,129.9,154.6,117.2,143Zm1.8,5.3-1.3-2.3,10.4,8.5C121.6,154.5,122,153.5,119,148.3Zm4.6,7.9c5.1.8,7.8-.6,2.7,4.7ZM143,187.7c-3.8-1.3-13-21.5-15.6-24.7l3.1-3.7c.6.2,1.8,1.2,2.4,1.2S148.5,189.7,143,187.7Zm4-1.9-1.1.6c-.1,0-11.6-26.5-11.8-26.3h.1c.5-.3,13.1,10.6,13.4,10.7C150.1,173.5,147.4,181.2,147,185.8Zm2-1.1c2.3-9.5-1-15,9.5-5.4Zm16.6-9.5c-8,5.5-6.6,1.8-13.3-2.7-1.5-2.1.2-9.5.5-11.9.6.3,1.2,0,1.8-.1S171.2,174.8,165.6,175.2Zm-10.3-15.8v-.3l5.2.5c1.5,2.8,6.1,9.8,7,12.7Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
        </g>
        <g id="_1M" data-name=" 1M">
          <g class="cls-9">
            <path
              class="cls-4"
              d="M303.4,169.4,285.5,159a7.9,7.9,0,0,0-7.6,0l-3.9,2.3-4.5-9.9a7.3,7.3,0,0,0-3.1-3.4l-18-10.4-.7-.4a9,9,0,0,0-1.9-1.5l-15.2-8.8a7.5,7.5,0,0,0-3.8-1,6.9,6.9,0,0,0-3.7,1l-36.6,21.2-.3.2-19.3,12.5a7.6,7.6,0,0,0-2.7,9.8l9.1,17.7a7.1,7.1,0,0,0,4.5,3.8l1.4.3v15.4a7.7,7.7,0,0,0,3.7,6.6l18.6,10.7,1.4.6,1.3,1,18.4,10.6a7.9,7.9,0,0,0,3.7,1,8.6,8.6,0,0,0,3.8-1l7-4.1v8.1a7.4,7.4,0,0,0,3.7,6.5l18.3,10.6a7.9,7.9,0,0,0,7.6,0l36.5-21.2a7.9,7.9,0,0,0,3.8-6.5V175.9A7.3,7.3,0,0,0,303.4,169.4Zm-58.8,59.7,1.3-11.9-7.1,8.5-6.6-3.7-7.1-16.9,1.3,13.5v12.2L208,220.2V165.4l18,10.4,9.5,21.1,9.5-10.1,17.9,10.3v54.8l-18.3-10.6Zm-57.8-37.6.6-10.8-7.4,4.2-9-17.7,19.3-12.5,15.2,8.8-.2,55.1-18.6-10.7Z"
              transform="translate(3.3)"
            />
          </g>
          <polygon
            class="cls-3"
            points="208.8 163.4 193.6 154.6 174.3 167.2 183.3 184.9 190.7 180.6 190.1 191.4 190 207.8 208.6 218.6 208.8 163.4"
          />
          <polygon
            class="cls-3"
            points="266.3 197.1 248.4 186.7 238.9 196.9 229.4 175.7 211.4 165.3 211.3 220.1 229.6 230.7 229.7 218.5 228.4 205.1 235.5 221.9 242.1 225.7 249.2 217.1 247.9 229.1 247.9 241.3 266.2 251.9 266.3 197.1"
          />
        </g>
      </g>
      <g id="Right_Bolt" data-name="Right Bolt">
        <polygon
          class="cls-3"
          points="363.6 230.3 377.1 198.9 362.7 207.2 362.7 207.3 355 225.1 363.6 230.3"
        />
        <polygon
          class="cls-3"
          points="393.6 132.5 402.3 137.7 406.8 130.6 398.2 125.2 393.6 132.5"
        />
        <polygon class="cls-3" points="370.1 188.8 401 139.8 392.3 134.6 361.4 183.6 370.1 188.8" />
        <polygon
          class="cls-3"
          points="368.8 190.9 360.1 185.7 351.6 199.1 360.3 204.3 368.8 190.9"
        />
        <polygon class="cls-3" points="390.9 176.7 404.6 168.8 396.4 163.8 390.9 176.7" />
        <polygon class="cls-3" points="362.7 232.6 354 227.4 346.5 244.9 355.1 250.1 362.7 232.6" />
        <path
          class="cls-4"
          d="M407.1,131.3v-.7a1.6,1.6,0,0,0-.9-1.2h0l-.2-.2-10.5-6.4-.5-.2h-.6a2.6,2.6,0,0,0-1.4,1.1l-46.9,74.5a1.8,1.8,0,0,0-.3,2l.3.5,10.5,6.1.2.3-15.9,37.1a1.7,1.7,0,0,0,.4,2.4h.2l10.2,6.2.5.4.8.2a2.2,2.2,0,0,0,1.9-1.2l50-81.5a2.3,2.3,0,0,0-.1-2.7l-.7-.3-.2-.2-9.8-6L406.9,132A1.9,1.9,0,0,0,407.1,131.3ZM389,134.6l8.7,5.2-30.9,49-8.7-5.2Zm-29.6,72.7h0l14.4-8.3-13.5,31.4-8.6-5.1ZM399,137.8l-8.7-5.2,4.6-7.3,8.6,5.3Zm-42.2,47.9,8.7,5.2L357,204.3l-8.7-5.1Zm-6.1,41.8,8.7,5.1-7.6,17.6-8.6-5.3Zm36.9-50.8,5.5-12.9,8.2,5Z"
          transform="translate(3.3)"
        />
        <rect
          class="cls-4"
          x="357.7"
          y="137.3"
          width="32.9"
          height="2.49"
          transform="translate(59.5 379.7) rotate(-57.5)"
        />
        <rect
          class="cls-4"
          x="354.9"
          y="159"
          width="10.3"
          height="2.49"
          transform="translate(35.1 378.4) rotate(-57.6)"
        />
        <rect
          class="cls-4"
          x="355"
          y="237.4"
          width="32.9"
          height="2.49"
          transform="translate(-26.1 423.8) rotate(-57.5)"
        />
        <polygon
          class="cls-4"
          points="364.6 257 362.5 255.7 357 264.4 359 265.6 359.1 265.6 364.6 257"
        />
      </g>
      <g id="Side_Man" data-name="Side Man">
        <g id="XMLID_2" data-name="XMLID 2">
          <g id="XMLID_179" data-name="XMLID 179">
            <path
              id="XMLID_183"
              data-name="XMLID 183"
              class="cls-3"
              d="M398.3,314.1a8.1,8.1,0,0,0,.4,3.8c.8,1.7-.2,3.3-2.8,2.5l-3-1.6a15.6,15.6,0,0,0,.8-4.8c0-2.6,2.1-2.1,2.1-2.1Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_180"
              data-name="XMLID 180"
              class="cls-4"
              d="M397.1,321.2l-1.4-.2h-.1l-3.4-1.9.2-.4a12.2,12.2,0,0,0,.9-4.6,2.7,2.7,0,0,1,.8-2.2,2.3,2.3,0,0,1,1.8-.4h.1l2.7,2.5v.3a8.3,8.3,0,0,0,.5,3.5,2.4,2.4,0,0,1-.2,2.7A2.3,2.3,0,0,1,397.1,321.2Zm-1-1.2a2.8,2.8,0,0,0,2.2-.3,2.2,2.2,0,0,0,0-1.6,8.2,8.2,0,0,1-.6-3.8l-2.2-1.9a1.1,1.1,0,0,0-.8.2,1.6,1.6,0,0,0-.5,1.4,17.6,17.6,0,0,1-.7,4.5Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_174" data-name="XMLID 174">
            <path
              id="XMLID_178"
              data-name="XMLID 178"
              class="cls-3"
              d="M379.7,326.4a8.3,8.3,0,0,0,.5,3.5c.7,1.6-.3,3.5-2.8,2.8l-2.6-2a16.4,16.4,0,0,0,.9-4.4c0-2.4,1.8-1.9,1.8-1.9Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_175"
              data-name="XMLID 175"
              class="cls-4"
              d="M378.4,333.3l-1.2-.2h-.1l-3-2.2v-.4a12.3,12.3,0,0,0,.7-4.2,2.4,2.4,0,0,1,.9-2.1,1.9,1.9,0,0,1,1.6-.4h.1l2.6,2.3v.3a7.5,7.5,0,0,0,.4,3.3,2.4,2.4,0,0,1-.3,2.7A2,2,0,0,1,378.4,333.3Zm-.8-1.1c.9.2,1.6.1,1.9-.3a1.7,1.7,0,0,0,.2-1.8,10.2,10.2,0,0,1-.5-3.5l-2.1-1.7h-.6a1.6,1.6,0,0,0-.4,1.3,12,12,0,0,1-.8,4.2Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_157" data-name="XMLID 157">
            <g id="XMLID_169" data-name="XMLID 169">
              <path
                id="XMLID_173"
                data-name="XMLID 173"
                class="cls-3"
                d="M397.9,317a1.1,1.1,0,0,1,1.3.6c.6,1,2.2,3.8,4.5,5s1.3,3.4-.2,3.7-2.5-.4-3.7-1a9.7,9.7,0,0,1-2.4-1.5,3.4,3.4,0,0,0-1.9-.9,9.5,9.5,0,0,1-3.5-1.4.7.7,0,0,1-.3-.6c.1-1,.3-3.9.9-4.3s1.2-.5,1.4.8,2.1,1.8,2.3.9S397.1,317.3,397.9,317Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_170"
                data-name="XMLID 170"
                class="cls-4"
                d="M403.2,326.9a9.9,9.9,0,0,1-3.7-1.1,13.2,13.2,0,0,1-2.5-1.6,3.8,3.8,0,0,0-1.7-.8,9.8,9.8,0,0,1-3.7-1.4.9.9,0,0,1-.4-1.1c.2-4.1.7-4.5,1-4.7a1.4,1.4,0,0,1,1.5-.3,1.5,1.5,0,0,1,.7,1.5c0,.3.4.6.7.7a.9.9,0,0,0,.7.1,3.4,3.4,0,0,1,2-1.7,1.6,1.6,0,0,1,1.9.9c.6,1,2.1,3.6,4.3,4.9s2,1.9,1.9,2.6a2.8,2.8,0,0,1-2.2,2Zm-10-10-.4.2a13.2,13.2,0,0,0-.6,3.9,8.5,8.5,0,0,0,3.4,1.4,4.7,4.7,0,0,1,2.2.9,11.9,11.9,0,0,0,2.3,1.6c2.3,1,3.1,1,3.4.9s1.4-.6,1.4-1.1-.4-1.1-1.4-1.6-4.1-4.1-4.7-5.3a.5.5,0,0,0-.6-.2,1.9,1.9,0,0,0-1.4.9,1.1,1.1,0,0,1-1.3.8,2.2,2.2,0,0,1-2-1.8Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_164" data-name="XMLID 164">
              <path
                id="XMLID_168"
                data-name="XMLID 168"
                class="cls-4"
                d="M393.8,317.4a.9.9,0,0,0,.3.6c-.3,1.6.1,3,.6,3.2a10.6,10.6,0,0,1,3.4,1.2c.9.6,3.8,2.5,5.2,2.6s1.6-.4,1.8-.8-.6,1.9-1.6,2.1a6.9,6.9,0,0,1-3.7-1,9.7,9.7,0,0,1-2.4-1.5,3.4,3.4,0,0,0-1.9-.9,9.5,9.5,0,0,1-3.5-1.4.7.7,0,0,1-.3-.6c.1-1,.3-3.9.9-4.3S393.7,316.2,393.8,317.4Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_165"
                data-name="XMLID 165"
                class="cls-4"
                d="M403.2,326.9a9.9,9.9,0,0,1-3.7-1.1,13.2,13.2,0,0,1-2.5-1.6,3.8,3.8,0,0,0-1.7-.8,9.8,9.8,0,0,1-3.7-1.4.9.9,0,0,1-.4-1.1c.2-4.1.8-4.6,1-4.7a1.4,1.4,0,0,1,1.5-.3,1.5,1.5,0,0,1,.7,1.5c0,.1.1.3.2.3v.4c-.3,1.4,0,2.4.3,2.5h.1a14,14,0,0,1,3.4,1.3c2.4,1.6,4.2,2.6,5,2.7a1.2,1.2,0,0,0,1.3-.5c.2-.3.1-.1.1-.2l.5-.9.3,1a2,2,0,0,1,0,1.5,2.7,2.7,0,0,1-1.9,1.4Zm-10-10-.4.2a13.2,13.2,0,0,0-.6,3.9,8.5,8.5,0,0,0,3.4,1.4,4.7,4.7,0,0,1,2.2.9,11.9,11.9,0,0,0,2.3,1.6c2.3,1,3.1,1,3.4.9l.6-.2h-.7c-1-.1-2.9-1-5.5-2.8a11.2,11.2,0,0,0-3.1-1h-.1c-1-.2-1.3-1.9-1-3.6a1.4,1.4,0,0,1-.2-.6Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_162" data-name="XMLID 162">
              <path
                id="XMLID_163"
                data-name="XMLID 163"
                class="cls-4"
                d="M398.1,320.5l-.6-.5a4.4,4.4,0,0,1,2.5-1.4v.8A4.5,4.5,0,0,0,398.1,320.5Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_160" data-name="XMLID 160">
              <path
                id="XMLID_161"
                data-name="XMLID 161"
                class="cls-4"
                d="M398.9,321.5l-.5-.6a5,5,0,0,1,2.5-1.3v.7A8.2,8.2,0,0,0,398.9,321.5Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_158" data-name="XMLID 158">
              <path
                id="XMLID_159"
                data-name="XMLID 159"
                class="cls-5"
                d="M392.6,321.7a6.5,6.5,0,0,1,.1-3.9l.8.3a5.6,5.6,0,0,0-.1,3.4Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_137" data-name="XMLID 137">
            <g id="XMLID_152" data-name="XMLID 152">
              <path
                id="XMLID_156"
                data-name="XMLID 156"
                class="cls-3"
                d="M378.5,329.6c-.9.2-1.2,1.1-1.3,1.9a.5.5,0,0,1-.5.5.5.5,0,0,1-.4-.2c-.6-.7-1.4-1.6-1.2-2l.4-1.5s-.8-.9-1.5.6-.3,3.1-.3,3.9,1.5,1.7,2.8,2.7,2.2,2.8,3.7,4.1,5.7,1,4.1-2.3-2.1-3.6-2.3-4.7-.9-4-2.1-4a2.7,2.7,0,0,0,.5,1.5A1.5,1.5,0,0,0,378.5,329.6Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_153"
                data-name="XMLID 153"
                class="cls-4"
                d="M382.2,340.8a3.8,3.8,0,0,1-2.5-.9l-2-2.2a15.4,15.4,0,0,0-1.7-1.9l-.6-.5c-1.2-.9-2.3-1.7-2.3-2.6v-.6a6.3,6.3,0,0,1,.4-3.6,1.8,1.8,0,0,1,1.2-1.2,1.5,1.5,0,0,1,1.1.4l.2.2v.3l-.4,1.5a4.2,4.2,0,0,0,1.1,1.5c.3-1.2.7-2,1.6-2.3l1-.2v-.9h.4c.4,0,1.7,0,2.6,4.4a7.1,7.1,0,0,0,.8,1.8,15.1,15.1,0,0,1,1.5,2.8c1,2,0,2.9-.4,3.2A2.2,2.2,0,0,1,382.2,340.8Zm-7.4-12.3c-.1,0-.1.1-.4.6a5.1,5.1,0,0,0-.3,3v.7c0,.4,1.2,1.3,1.9,1.7l.6.5,1.9,2.1a9.1,9.1,0,0,0,1.8,2.1,2.9,2.9,0,0,0,3.2.2c.5-.3.6-1,.1-1.9s-1.2-2.2-1.5-2.9a10.8,10.8,0,0,1-.8-1.9,13.1,13.1,0,0,0-.9-2.8l-.8.4c-.1-.1-.3-.6-1.1-.3s-.8.7-1,1.5a1,1,0,0,1-.7.8,1.1,1.1,0,0,1-1.1-.3c-1.3-1.4-1.4-2-1.3-2.4A3.6,3.6,0,0,0,374.8,328.5Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_146" data-name="XMLID 146">
              <path
                id="XMLID_151"
                data-name="XMLID 151"
                class="cls-4"
                d="M375.4,328.2l-.4,1.5h0a.6.6,0,0,0-.1.4,2.2,2.2,0,0,0-.1.8,4,4,0,0,0,1.7,3.2,21.6,21.6,0,0,1,3.9,4.1c1.7,2.6,3.8,1.2,3.8,1.2s-3,1.1-4.1.1-2.6-3.2-3.7-4.1-2.8-1.9-2.8-2.7a8.6,8.6,0,0,1,.3-3.9C374.7,327.3,375.4,328.2,375.4,328.2Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_147"
                data-name="XMLID 147"
                class="cls-4"
                d="M382.2,340.7a3.3,3.3,0,0,1-2.5-.8l-2-2.2a15.4,15.4,0,0,0-1.7-1.9l-.6-.5c-1.2-.9-2.3-1.7-2.3-2.6v-.6a6.3,6.3,0,0,1,.4-3.6,1.8,1.8,0,0,1,1.2-1.2,1.5,1.5,0,0,1,1.1.4l.2.2v.3s-.2.8-.3,1.5v.2c0,.1-.1.2-.1.4s-.1.4-.1.6a3.5,3.5,0,0,0,1.5,2.8,19.9,19.9,0,0,1,4,4.2,2.2,2.2,0,0,0,2,1.3l1-.2.7-.5v.9a1,1,0,0,1-.6.9A3.1,3.1,0,0,1,382.2,340.7Zm-5-5.2,1.4,1.6a9.1,9.1,0,0,0,1.8,2.1c-.2-.1-.3-.3-.5-.6A20,20,0,0,0,377.2,335.5Zm-2.4-7c-.1,0-.1.1-.4.6a5.1,5.1,0,0,0-.3,3v.7c0,.4,1.2,1.3,1.9,1.7l.6.4-.5-.4a4.5,4.5,0,0,1-1.8-3.6,2.8,2.8,0,0,1,.1-.9c0-.1.1-.3.1-.4h0Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_144" data-name="XMLID 144">
              <path
                id="XMLID_145"
                data-name="XMLID 145"
                class="cls-4"
                d="M378.4,333.7l-.5-.7a8.9,8.9,0,0,1,3.9-1.2v.7C381.8,332.6,379.6,332.8,378.4,333.7Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_142" data-name="XMLID 142">
              <path
                id="XMLID_143"
                data-name="XMLID 143"
                class="cls-4"
                d="M379.2,335l-.5-.6a7.1,7.1,0,0,1,3.5-1.3v.8A7.7,7.7,0,0,0,379.2,335Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_140" data-name="XMLID 140">
              <path
                id="XMLID_141"
                data-name="XMLID 141"
                class="cls-4"
                d="M380.5,329.7l-.7.4.5,1.2.7-.3Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_138" data-name="XMLID 138">
              <path
                id="XMLID_139"
                data-name="XMLID 139"
                class="cls-5"
                d="M374.1,333.3a6.2,6.2,0,0,1-.1-3.3h.7a10.1,10.1,0,0,0,.1,3Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_116" data-name="XMLID 116">
            <g id="XMLID_132" data-name="XMLID 132">
              <path
                id="XMLID_136"
                data-name="XMLID 136"
                class="cls-4"
                d="M380.7,326.3a117.5,117.5,0,0,1,.1-15.7c.3-3.4.5-5.8.6-7.5a8,8,0,0,0-1.6-5.2l-5-7.1c-.1-.1,0-.2.1-.2a32.2,32.2,0,0,0,12.9,2.8l4.8.6h.1a11.7,11.7,0,0,0-1,6.4c.5,4.2,1.5,7.6,1.6,13.2a4.2,4.2,0,0,0,5.6-.2s-.2-13.4,0-18.7.1-6.6-4-9.1-13.6-3.6-18-3.6-12.3,2.7-12.3,2.7l-3.1,2.1s-2.8,6.4,5.7,11.6l6.8,5.1c.1,0,.1.1,0,.2s-1.4,2.5-1.4,6.8,1.6,8.8,2,13.9v1.8A5.9,5.9,0,0,0,380.7,326.3Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_133"
                data-name="XMLID 133"
                class="cls-4"
                d="M377.6,327.5a4.6,4.6,0,0,1-3.2-1h-.2v-1.9a42.2,42.2,0,0,0-1-6.2,33.1,33.1,0,0,1-.9-7.7c0-3.7.7-5.9,1.2-6.8l-6.5-5c-8.8-5.2-5.9-11.9-5.9-12h.1l3.4-2.2c.3-.1,7.8-2.8,12.4-2.8h.2c4.8.1,14.2,1.1,18.3,3.6s4.5,4,4.3,9.6,0,18.6,0,18.7v.2l-.2.2a4.6,4.6,0,0,1-6.3.2l-.2-.2V314a51.6,51.6,0,0,0-1-8.7c-.2-1.5-.5-2.9-.6-4.4a13.2,13.2,0,0,1,.8-6.2l-4.3-.5a31.3,31.3,0,0,1-11.7-2.3l4.1,6a8.3,8.3,0,0,1,1.6,5.5c-.1,2.1-.2,4.6-.5,7.4a119,119,0,0,0-.1,15.8v.4l-.3.2A20.7,20.7,0,0,1,377.6,327.5Zm-2.4-1.6a4.8,4.8,0,0,0,4.9.1,114.5,114.5,0,0,1,.1-15.5c.3-2.9.5-5.4.6-7.4a7.5,7.5,0,0,0-1.4-4.8l-5-7.1a.6.6,0,0,1,0-.8.6.6,0,0,1,.7-.2,32.6,32.6,0,0,0,12.7,2.8l4.9.6a.7.7,0,0,1,.5.4.5.5,0,0,1,0,.5,10.6,10.6,0,0,0-.9,6.1l.6,4.3a61.1,61.1,0,0,1,.9,8.6,3.6,3.6,0,0,0,4.7-.2c0-1.8-.2-13.6,0-18.5s0-6.3-3.9-8.6-13.8-3.5-17.8-3.6-11.4,2.5-12.1,2.8l-2.9,2c-.4,1-1.9,6.3,5.5,10.8l6.8,5.3c.3.1.3.5.2.8a14.1,14.1,0,0,0-1.3,6.5,38.6,38.6,0,0,0,1,7.5q.6,3.1.9,6.3Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_130" data-name="XMLID 130">
              <path
                id="XMLID_131"
                data-name="XMLID 131"
                class="cls-5"
                d="M393.3,294.1l-.7-.4a7,7,0,0,1,2-1.8l.3.8A4.3,4.3,0,0,0,393.3,294.1Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_127" data-name="XMLID 127">
              <path
                id="XMLID_129"
                data-name="XMLID 129"
                class="cls-5"
                d="M374.6,303.7l-.6-.4a2.7,2.7,0,0,1,2.5-1.1v.8A2.3,2.3,0,0,0,374.6,303.7Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_125" data-name="XMLID 125">
              <path
                id="XMLID_126"
                data-name="XMLID 126"
                class="cls-5"
                d="M396.1,313.4a6.7,6.7,0,0,1-2.4-.4l.3-.8a6.6,6.6,0,0,0,4.4,0l.2.8A10.9,10.9,0,0,1,396.1,313.4Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_119" data-name="XMLID 119">
              <path
                id="XMLID_120"
                data-name="XMLID 120"
                class="cls-5"
                d="M365.4,296.4l-.3-.7a3.6,3.6,0,0,0,1.6-4.7l.8-.3A4.7,4.7,0,0,1,365.4,296.4Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_117" data-name="XMLID 117">
              <path
                id="XMLID_118"
                data-name="XMLID 118"
                class="cls-5"
                d="M377.5,326a5.9,5.9,0,0,1-2.3-.5l.3-.7a6.4,6.4,0,0,0,4.3,0l.3.7A7.5,7.5,0,0,1,377.5,326Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_105" data-name="XMLID 105">
            <g id="XMLID_111" data-name="XMLID 111">
              <path
                id="XMLID_115"
                data-name="XMLID 115"
                class="cls-3"
                d="M375.2,261.2l.2.7a33.2,33.2,0,0,1,1.8,9.8v.9h.2a15.3,15.3,0,0,1,4,2.1c1.6,1.1,5.9,4.9,5.9,4.9l-5.3,2.3-11.6-6.1-2.1-7.9,3-4.7,2.8-2.7Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_112"
                data-name="XMLID 112"
                class="cls-4"
                d="M381.9,282.6,370,276.4l-2.3-8.3,3.2-4.9,3-2.9,1.7.6v.2l.2.7a33.9,33.9,0,0,1,1.8,10v.7a12,12,0,0,1,3.9,2c1.6,1.1,5.7,4.9,5.9,5.1l.6.5Zm-11.1-7,11.2,5.9,4.4-1.8c-1.7-1.6-3.5-3.1-5.3-4.5a19.3,19.3,0,0,0-3.8-1.9.8.8,0,0,1-.5-.7v-.8a35.5,35.5,0,0,0-1.9-9.7.6.6,0,0,1-.1-.4l-.6-.3-2.5,2.5-2.9,4.4Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_106" data-name="XMLID 106">
              <path
                id="XMLID_110"
                data-name="XMLID 110"
                class="cls-3"
                d="M372.2,263.3c.1.2,2-1,3.4-2.6,0,0-2.6-8-6.5-8.3s-1.5,3.9-1.5,3.9Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_107"
                data-name="XMLID 107"
                class="cls-4"
                d="M372.2,263.8h-.4l-4.6-7c-.2-.3-1.4-2.4-.6-3.8s1.2-1,2.5-1c4.2.3,6.9,8.4,7,8.8v.2l-.2.2C376,261.1,373.3,263.8,372.2,263.8Zm-3.4-10.9c-.5,0-1.1.1-1.2.5a6,6,0,0,0,.5,2.6l4.3,6.8a13.9,13.9,0,0,0,2.7-2.1c-.7-2.4-3.1-7.6-5.9-7.7Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_50" data-name="XMLID 50">
            <g id="XMLID_100" data-name="XMLID 100">
              <path
                id="XMLID_104"
                data-name="XMLID 104"
                class="cls-5"
                d="M368.7,252.7s3.1,1,3.7,6.5,3.3,17.2,5.9,21.1c0,0,1.4,2.2-2.5,3.6s-6.5,1.6-10.3,4.7-5.7,4.2-6.4.5a104,104,0,0,0-4.9-16.2c-1.6-3.3-2.4-15.2-2.4-15.2s2-3.1,7.5-5.2C362.9,251,368.7,252.7,368.7,252.7Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_101"
                data-name="XMLID 101"
                class="cls-4"
                d="M360.9,291.8h-.6c-.9-.2-1.4-1.1-1.7-2.6a90.6,90.6,0,0,0-4.9-16.1c-1.6-3.4-2.4-14.9-2.4-15.4v-.5c.1-.1,2.2-3.3,7.7-5.4,3.7-1.5,9.4.2,9.7.3s3.5,1.2,4.1,6.9,3.2,17,5.8,20.9a3,3,0,0,1,.2,2.1,5,5,0,0,1-3,2.3l-2.2.6a19.7,19.7,0,0,0-7.9,4C363.6,290.8,362.2,291.8,360.9,291.8Zm-8.5-34c.1,1.5.9,11.8,2.3,14.8a102.3,102.3,0,0,1,5,16.3c.2,1.1.5,1.7.9,1.9s2.9-1.2,4.6-2.7a20.2,20.2,0,0,1,8.3-4.1l2.2-.7a3.5,3.5,0,0,0,2.3-1.6,1.7,1.7,0,0,0-.1-1.2c-2.8-4-5.3-15.8-5.9-21.3s-3.3-6-3.4-6-5.7-1.7-8.9-.3A18.1,18.1,0,0,0,352.4,257.8Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_67" data-name="XMLID 67">
              <g id="XMLID_95" data-name="XMLID 95">
                <path
                  id="XMLID_99"
                  data-name="XMLID 99"
                  class="cls-3"
                  d="M363.1,252.2a7.6,7.6,0,0,0,5.1,1.2,1.6,1.6,0,0,0,1.3-.8,14.9,14.9,0,0,0,1.1-11.5l-8.1-.9-1.9,2.7a3.6,3.6,0,0,0-.4,2.5,5.5,5.5,0,0,1-.9,4.1c-2.8,5.3-1.4,6.4,2.3,9.4s7.3.5,4.3-5.7Z"
                  transform="translate(3.3)"
                />
                <path
                  id="XMLID_96"
                  data-name="XMLID 96"
                  class="cls-4"
                  d="M364.2,260.4a4.8,4.8,0,0,1-2.8-1c-3.8-3-5.6-4.4-2.5-10.1a4.5,4.5,0,0,0,.8-3.7,4,4,0,0,1,.6-3l2-2.9,8.8.9v.3a15.4,15.4,0,0,1-1.2,11.9,1.9,1.9,0,0,1-1.7,1h-1.4c1.4,3.7.1,5.3-.6,5.9A3.7,3.7,0,0,1,364.2,260.4Zm-1.4-19.6-1.7,2.4a2.6,2.6,0,0,0-.4,2.1,6.7,6.7,0,0,1-.8,4.4c-2.7,4.9-1.6,5.8,2.2,8.7a2.6,2.6,0,0,0,3.5.3c1.2-.8,1.2-2.7,0-5.1a7,7,0,0,1-2.8-1.2l.6-.9a7.3,7.3,0,0,0,4.8,1.1,1,1,0,0,0,.8-.5,14.3,14.3,0,0,0,1.2-10.7Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_90" data-name="XMLID 90">
                <path
                  id="XMLID_94"
                  data-name="XMLID 94"
                  class="cls-4"
                  d="M359.5,237.2c3.3-2.8,8.5-.3,9.6-.9a1.6,1.6,0,0,0,.4-2c0-.1,0-.1.1-.1a4.6,4.6,0,0,1,4.2,4,4.7,4.7,0,0,1-2.6,5.2,6.8,6.8,0,0,1-4,.6,4.7,4.7,0,0,0-1.7.3,2.8,2.8,0,0,0-1.1,1.5,1,1,0,0,1-.9.7h-1.3l-1.4-.4a1.6,1.6,0,0,0-.3.9v1.5a6.5,6.5,0,0,1-3.2-5.8A6.4,6.4,0,0,1,359.5,237.2Z"
                  transform="translate(3.3)"
                />
                <path
                  id="XMLID_91"
                  data-name="XMLID 91"
                  class="cls-4"
                  d="M361,249l-.7-.3a6.6,6.6,0,0,1-3.4-6.3,6.1,6.1,0,0,1,2.3-5.6c2.5-2.2,5.8-1.6,7.9-1.3l1.7.2c.6-.3.3-1.1.2-1.4V234l.2-.3a.4.4,0,0,1,.5-.2h.1a5.3,5.3,0,0,1,4.7,4.5,5.5,5.5,0,0,1-2.9,5.8,10.4,10.4,0,0,1-4.3.6,3.2,3.2,0,0,0-1.4.3,2,2,0,0,0-.8,1.2,1.3,1.3,0,0,1-1.5.9h-1.4l-1-.2c-.1.1-.1.1-.1.2Zm2.9-12.7a5.8,5.8,0,0,0-4,1.3,5,5,0,0,0-1.9,4.8,5.7,5.7,0,0,0,2.1,4.8v-.4a5.6,5.6,0,0,1,.4-1.2l.2-.3,1.7.5h1.2c.2,0,.3-.1.4-.3a2.7,2.7,0,0,1,1.3-1.7,4.6,4.6,0,0,1,2-.5,6.3,6.3,0,0,0,3.8-.6,3.9,3.9,0,0,0,2.3-4.6,4.2,4.2,0,0,0-3.2-3.6,2.3,2.3,0,0,1-.7,2.1,3.3,3.3,0,0,1-2.4,0,17.3,17.3,0,0,0-3.2-.3Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_88" data-name="XMLID 88">
                <path
                  id="XMLID_89"
                  data-name="XMLID 89"
                  class="cls-5"
                  d="M367.4,243.5s-2.9-2-5.9-.8l-.3-.8a7.1,7.1,0,0,1,6.6.9Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_86" data-name="XMLID 86">
                <path
                  id="XMLID_87"
                  data-name="XMLID 87"
                  class="cls-5"
                  d="M359.9,245.5a2.3,2.3,0,0,1,.4-2.8l.5.5a1.9,1.9,0,0,0-.3,1.9Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_84" data-name="XMLID 84">
                <path
                  id="XMLID_85"
                  data-name="XMLID 85"
                  class="cls-5"
                  d="M359.7,242.1l-.7-.4c1.5-2.8,5.2-2.5,5.4-2.5v.7C364.2,239.9,360.9,239.7,359.7,242.1Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_82" data-name="XMLID 82">
                <path
                  id="XMLID_83"
                  data-name="XMLID 83"
                  class="cls-5"
                  d="M366.9,240.5l-1.7-.5v-.7a6.5,6.5,0,0,1,2,.5l-.4.7.2-.4Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_79" data-name="XMLID 79">
                <path
                  id="XMLID_81"
                  data-name="XMLID 81"
                  class="cls-3"
                  d="M362.5,249.2a2.5,2.5,0,0,1-1.9-1.2,3.3,3.3,0,0,1-.4-1.7c.2-1.3,1.4-1,2-.2l.5.6Z"
                  transform="translate(3.3)"
                />
                <path
                  id="XMLID_80"
                  data-name="XMLID 80"
                  class="cls-4"
                  d="M362.4,249.8a3.7,3.7,0,0,1-2.2-1.4,3.2,3.2,0,0,1-.6-2.1,1.4,1.4,0,0,1,1-1.3,1.8,1.8,0,0,1,1.9.9l.4.6-.8.6-.5-.6a1.4,1.4,0,0,0-.8-.5c-.1,0-.2.2-.3.4a2.8,2.8,0,0,0,.4,1.3,3.3,3.3,0,0,0,1.5,1.1Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_77" data-name="XMLID 77">
                <path
                  id="XMLID_78"
                  data-name="XMLID 78"
                  class="cls-4"
                  d="M369.2,250.2H369a3.4,3.4,0,0,1-1.4-.5l.3-.7.8.3a10.9,10.9,0,0,0-.1-1.8h.8a8.9,8.9,0,0,1,0,2.3v.2Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_75" data-name="XMLID 75">
                <path
                  id="XMLID_76"
                  data-name="XMLID 76"
                  class="cls-4"
                  d="M366.7,246.8c0,.6.2,1.1.6,1.1s.6-.4.7-1-.2-1-.5-1A.9.9,0,0,0,366.7,246.8Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_73" data-name="XMLID 73">
                <path
                  id="XMLID_74"
                  data-name="XMLID 74"
                  class="cls-4"
                  d="M370,247c0,.6.2,1.1.6,1.1s.7-.4.8-1-.2-1-.6-1A.9.9,0,0,0,370,247Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_71" data-name="XMLID 71">
                <path
                  id="XMLID_72"
                  data-name="XMLID 72"
                  class="cls-4"
                  d="M368.1,251.7a2.1,2.1,0,0,1-1.3-.5l.5-.5a1.4,1.4,0,0,0,.9.3l.2.7Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_68" data-name="XMLID 68">
                <g id="XMLID_69" data-name="XMLID 69">
                  <path
                    id="XMLID_70"
                    data-name="XMLID 70"
                    class="cls-5"
                    d="M372,237.6a2.4,2.4,0,0,0-2-1.6v-.8a3,3,0,0,1,2.6,2.1Z"
                    transform="translate(3.3)"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_62" data-name="XMLID 62">
              <path
                id="XMLID_66"
                data-name="XMLID 66"
                class="cls-3"
                d="M363.5,259.8l-1.1,1.9c-.1.1-.3.2-.4.1a12.7,12.7,0,0,1-4.5-3.8c-1.8-2.4-2.4-5.6.8-7.4a9,9,0,0,0,.9,4.6A23.5,23.5,0,0,0,363.5,259.8Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_63"
                data-name="XMLID 63"
                class="cls-4"
                d="M362.1,262.5h-.4a12.6,12.6,0,0,1-4.6-4,6.1,6.1,0,0,1-1.4-5,4.7,4.7,0,0,1,2.4-3.1l.9-.5v1a7.6,7.6,0,0,0,.9,4.2c1,1.9,4.1,4.3,4.1,4.4l.4.3-1.5,2.3A.9.9,0,0,1,362.1,262.5Zm-4.2-10.8a2.8,2.8,0,0,0-1.2,1.9c-.3,1.2.2,2.6,1.3,4.2a11.5,11.5,0,0,0,4.1,3.5l.8-1.4a27.9,27.9,0,0,1-4-4.4,7.5,7.5,0,0,1-1-3.8Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_57" data-name="XMLID 57">
              <path
                id="XMLID_61"
                data-name="XMLID 61"
                class="cls-3"
                d="M368.4,259l-1.7-.7s.7-3.1-1-5.1a9.9,9.9,0,0,0,2.4.3,7.3,7.3,0,0,1,.6,5.4Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_58"
                data-name="XMLID 58"
                class="cls-4"
                d="M368.5,259.5h-.3a3.9,3.9,0,0,0-1.5-.6h-.6v-.7s.6-3-.9-4.7l-.9-1.3,1.5.4a8.2,8.2,0,0,0,2.2.2h.3l.2.3a7.8,7.8,0,0,1,.6,5.8,1,1,0,0,1-.4.5Zm-1.2-1.5,1,.3a6.7,6.7,0,0,0-.5-4.4h-1A8.2,8.2,0,0,1,367.3,258Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_55" data-name="XMLID 55">
              <path
                id="XMLID_56"
                data-name="XMLID 56"
                class="cls-4"
                d="M367.2,265.3a26.1,26.1,0,0,0-1.6-6.1l1-.4a35,35,0,0,1,1.5,6.4Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_53" data-name="XMLID 53">
              <path
                id="XMLID_54"
                data-name="XMLID 54"
                class="cls-4"
                d="M364.7,262.4a.6.6,0,1,0,.6-.6h-.1A.6.6,0,0,0,364.7,262.4Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_51" data-name="XMLID 51">
              <path
                id="XMLID_52"
                data-name="XMLID 52"
                class="cls-4"
                d="M365,264.3a.6.6,0,0,0,.5.6.6.6,0,0,0,0-1.2A.6.6,0,0,0,365,264.3Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_42" data-name="XMLID 42">
            <g id="XMLID_45" data-name="XMLID 45">
              <path
                id="XMLID_49"
                data-name="XMLID 49"
                class="cls-3"
                d="M390.5,282.9,373,293h-.1l-12-7.2c-.1,0-.1-.2,0-.2l17.4-10.3h.1l12.2,7.3Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_46"
                data-name="XMLID 46"
                class="cls-4"
                d="M372.9,293.6h-.3l-12-7.2a1,1,0,0,1,0-1.2L378,275h.7l12.2,7.2a.7.7,0,0,1,.3.6.9.9,0,0,1-.3.6l-17.5,10.1Zm-11.2-7.8,11.2,6.7,16.7-9.6-11.3-6.8Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_43" data-name="XMLID 43">
              <path
                id="XMLID_44"
                data-name="XMLID 44"
                class="cls-4"
                d="M371.7,289.9l-6.3-3.7c-.2-.1-.2-.4-.2-.6s0-.5.3-.6l4.1-2.4.4.9-3.5,2.1,5.8,3.5Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_27" data-name="XMLID 27">
            <g id="XMLID_37" data-name="XMLID 37">
              <path
                id="XMLID_41"
                data-name="XMLID 41"
                class="cls-3"
                d="M356.6,269.4a28.5,28.5,0,0,1,1.2,5.8c.3,3,.3,5.6.3,5.6a17,17,0,0,1,7.1.3,21.7,21.7,0,0,0,7.6.5s2.3-1.8,3.3-1.7.5,1.1.5,1.1,4.7,1.6,2.9,3.1-6.7.4-6.7.4-11.7,1.3-17.9.4a.7.7,0,0,1-.6-.4c-.7-1.3-3.3-6.1-3.9-14.7-.9-10.4,6.2-1.8,6.2-1.8Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_38"
                data-name="XMLID 38"
                class="cls-4"
                d="M360.7,286a54.4,54.4,0,0,1-5.7-.3,1.4,1.4,0,0,1-1-.7,38.4,38.4,0,0,1-4-14.9c-.3-3.3.2-5,1.4-5.6s5.1,2.7,5.8,3.4v1.5a22.9,22.9,0,0,1,1.1,5.8,43.6,43.6,0,0,1,.3,5.1,16.9,16.9,0,0,1,6.7.4,20.4,20.4,0,0,0,7.4.5c.6-.4,2.5-1.7,3.6-1.6s.8.2.9.5a.9.9,0,0,1,.1.7c1,.4,3,1.3,3.3,2.5a1.2,1.2,0,0,1-.6,1.3c-1.8,1.6-6.3.8-7.1.7S366.2,286,360.7,286ZM352,265.4h-.3c-.4,0-1,.8-.7,4.5a34.8,34.8,0,0,0,3.9,14.5h.3c6,.9,17.6-.3,17.8-.3h.2c1.4.2,5.1.6,6.3-.4s.2-.3.2-.4a14.1,14.1,0,0,0-2.9-1.9l-.6-.2.3-.6c0-.1.1-.2.1-.3h-.2c-.5-.1-1.9.8-2.9,1.5h-.2a26.8,26.8,0,0,1-8-.6,15.6,15.6,0,0,0-6.8-.3h-.6v-.7s0-2.6-.3-5.5a29,29,0,0,0-1.2-5.7h0v-.8c-1.4-1.2-3.3-2.8-4.4-2.8Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_32" data-name="XMLID 32">
              <path
                id="XMLID_36"
                data-name="XMLID 36"
                class="cls-3"
                d="M357.3,269.4a2.7,2.7,0,0,0,.6-1.7c-.1-2.4-.6-9.8-3.7-11.2s-4.9,9.4-4.7,12.2,6.4,1.5,7.2,1.3Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_33_3"
                data-name="XMLID 33 3"
                class="cls-4"
                d="M352.8,270.9a5,5,0,0,1-2.9-.7,2,2,0,0,1-1-1.5c-.1-2,.6-10.5,3.3-12.5a2.2,2.2,0,0,1,2.1-.2c3.3,1.5,3.8,8.6,3.9,11.7a3.2,3.2,0,0,1-.6,2.1,2.4,2.4,0,0,1-.9.6A26,26,0,0,1,352.8,270.9Zm.6-14.1-.6.2c-2.1,1.4-3,9.2-2.9,11.5a1,1,0,0,0,.5.8c1.3.9,5.2.3,6,0l.4-.3a2.4,2.4,0,0,0,.5-1.4c-.2-4.5-1.2-9.7-3.4-10.7Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_30_3" data-name="XMLID 30 3">
              <path
                id="XMLID_31"
                data-name="XMLID 31"
                class="cls-4"
                d="M356.5,284.1a1.6,1.6,0,0,1-.9-.3,1.8,1.8,0,0,1-.8-1.1l.9-.3c0,.2.1.3.3.4h.7l.3,1C357,284,356.8,284.1,356.5,284.1Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_28_3" data-name="XMLID 28 3">
              <path
                id="XMLID_29_3"
                data-name="XMLID 29 3"
                class="cls-4"
                d="M353.2,268.5a7.4,7.4,0,0,1-4.1-1l.6-.9c1.9,1.3,5.5.7,5.5.7l.2,1Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_16_3" data-name="XMLID 16 3">
            <g id="XMLID_22_3" data-name="XMLID 22 3">
              <path
                id="XMLID_26"
                data-name="XMLID 26"
                class="cls-5"
                d="M372.9,292.9l6-13.6,17.9-10.7h.1l-6.3,14.1-17.7,10.1C373,293,372.9,293,372.9,292.9Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_23_3"
                data-name="XMLID 23 3"
                class="cls-4"
                d="M373,293.6l-.4-.3a.6.6,0,0,1-.1-.7l6.1-13.7h.2L397.1,268l.4.3a.5.5,0,0,1,.1.7h0l-6.4,14.2h-.3Zm6.4-13.9-5.3,12.1,16.2-9.4,5.7-12.6Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_17_3" data-name="XMLID 17 3">
              <path
                id="XMLID_21_3"
                data-name="XMLID 21 3"
                class="cls-3"
                d="M386,281.8c-.8.9-1.8,1.4-2.1,1.1s-.2-1.3.5-2.3,1.8-1.4,2.2-1.1S386.7,280.8,386,281.8Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_18_3"
                data-name="XMLID 18 3"
                class="cls-4"
                d="M384.2,283.5l-.7-.2c-.7-.6-.5-1.8.5-3.1s2.2-1.7,2.8-1.1a1.2,1.2,0,0,1,.4,1.4,3.5,3.5,0,0,1-.8,1.6A3.7,3.7,0,0,1,384.2,283.5Zm2-3.8a2.6,2.6,0,0,0-1.4,1.1c-.6.9-.7,1.5-.6,1.6a3.3,3.3,0,0,0,1.4-1A2.2,2.2,0,0,0,386.2,279.7Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_6_3" data-name="XMLID 6 3">
            <g id="XMLID_14_3" data-name="XMLID 14 3">
              <path
                id="XMLID_15_3"
                data-name="XMLID 15 3"
                class="cls-5"
                d="M372.3,311.9a27.9,27.9,0,0,1,.2-5l.8.2a25.7,25.7,0,0,0-.2,4.8Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_10_3" data-name="XMLID 10 3">
              <path
                id="XMLID_11_3"
                data-name="XMLID 11 3"
                class="cls-5"
                d="M391.5,301a17.1,17.1,0,0,1,.4-5.5l.8.2a15.3,15.3,0,0,0-.4,5.2Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Side_Girl" data-name="Side Girl">
        <g id="side-bubbles">
          <g id="XMLID_1255" data-name="XMLID 1255">
            <path
              id="XMLID_1259"
              data-name="XMLID 1259"
              class="cls-5"
              d="M343.6,302.4,328.4,311a2.8,2.8,0,0,1-2.5-.1l-4.2-2.4c-.8-.4-.8-1.1-.1-1.4l15.2-8.7a3.1,3.1,0,0,1,2.5.2l4.2,2.4C344.2,301.4,344.2,302,343.6,302.4Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1256"
              data-name="XMLID 1256"
              class="cls-3"
              d="M327.5,311.7a4.2,4.2,0,0,1-1.6-.4l-4.2-2.5a1.2,1.2,0,0,1-.8-1.1,1.2,1.2,0,0,1,.7-1l15.2-8.8a3.4,3.4,0,0,1,2.8.2l4.3,2.4a1.4,1.4,0,0,1,.7,1.2,1.3,1.3,0,0,1-.6,1l-15.3,8.6A1.4,1.4,0,0,1,327.5,311.7Zm10.3-13.1h-.9l-15.2,8.7s-.3.2-.3.3l.4.4,4.3,2.4a2,2,0,0,0,2,.1l15.3-8.6.2-.2c0-.1-.1-.3-.4-.4l-4.2-2.4A1.7,1.7,0,0,0,337.8,298.6Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1222" data-name="XMLID 1222">
            <g id="XMLID_1234" data-name="XMLID 1234">
              <path
                id="XMLID_1238"
                data-name="XMLID 1238"
                class="cls-10"
                d="M335.8,270.8h0L319,280.4a3.5,3.5,0,0,0-1.5,3.3v14.2a2,2,0,0,0,.6,1.5,1.4,1.4,0,0,0,1.5,0h.1l3.4-2.1h0l2.8-1.8,10.4-6a3.4,3.4,0,0,0,1.2-1.2,4.1,4.1,0,0,0,.5-1.8V272.3a1.7,1.7,0,0,0-.7-1.5A1.4,1.4,0,0,0,335.8,270.8Z"
                transform="translate(3.3)"
              />
              <path
                id="Vector_54"
                data-name="Vector 54"
                class="cls-3"
                d="M331.6,278a1.5,1.5,0,0,1,.2.9v2h0c0,.3.1.6.4.6a1.8,1.8,0,0,0,1-.4v1.3a4.3,4.3,0,0,0-1,.9,1.5,1.5,0,0,0-.4,1.1v1.9a5,5,0,0,1-.2,1.2,3.6,3.6,0,0,1-.7,1l-1.4,1v-1.3a2.7,2.7,0,0,0,.8-.7,1.9,1.9,0,0,0,.2-.7v-1.9h0a2.2,2.2,0,0,1,1.3-2h0c-.9.3-1.2.1-1.3-.7v-2c0-.3-.1-.5-.2-.5a1.7,1.7,0,0,0-.8.2v-1.3l1.4-.6C331.2,277.8,331.4,277.8,331.6,278Z"
                transform="translate(3.3)"
              />
              <path
                id="Vector_55"
                data-name="Vector 55"
                class="cls-3"
                d="M323.7,286.5a2.1,2.1,0,0,0,.4-1.1h0v-2a2.6,2.6,0,0,1,.5-1.7,6.2,6.2,0,0,1,1.8-1.4v1.3c-.3.1-.5.4-.7.6a1.1,1.1,0,0,0-.2.8v1.9a2.8,2.8,0,0,1-1.3,2.1h0a1.4,1.4,0,0,1,.9-.1c.2.1.3.4.3.8h0v1.9c0,.3.1.5.2.5a1.7,1.7,0,0,0,.8-.2v1.3c-.9.4-1.5.7-1.9.6s-.5-.5-.5-1.1v-2c0-.3-.1-.6-.4-.6a1.7,1.7,0,0,0-1,.3v-1.3A2.4,2.4,0,0,0,323.7,286.5Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_1256_2" data-name="XMLID 1256 2">
            <g id="XMLID_1234_2" data-name="XMLID 1234 2">
              <path
                id="XMLID_1238_2"
                data-name="XMLID 1238 2"
                class="cls-10"
                d="M319,258.4h0l-13.9,7.9a2.8,2.8,0,0,0-1.3,2.9V281a1.6,1.6,0,0,0,.6,1.3,1.5,1.5,0,0,0,1.3,0h0l2.9-1.7h0l2.3-1.5,8.6-5a1.8,1.8,0,0,0,1-1.1,2.6,2.6,0,0,0,.4-1.5V259.7a1.1,1.1,0,0,0-.5-1.2A1.4,1.4,0,0,0,319,258.4Z"
                transform="translate(3.3)"
              />
              <g id="Group_65" data-name="Group 65">
                <path
                  id="Vector_56"
                  data-name="Vector 56"
                  class="cls-3"
                  d="M319.2,267.1l-4.3,4.7v-1.1l2.9-3.2-2.9.2v-1.3h4.3Z"
                  transform="translate(3.3)"
                />
                <path
                  id="Vector_57"
                  data-name="Vector 57"
                  class="cls-3"
                  d="M314.4,273.1l-1.2.8-2.4-6,1.2-.8Z"
                  transform="translate(3.3)"
                />
                <path
                  id="Vector_58"
                  data-name="Vector 58"
                  class="cls-3"
                  d="M310.4,269v1.2l-3,3.4,3-.4v1.3l-4.4.3V274Z"
                  transform="translate(3.3)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_1203" data-name="XMLID 1203">
          <g id="XMLID_1216" data-name="XMLID 1216">
            <path
              id="XMLID_1220"
              data-name="XMLID 1220"
              class="cls-4"
              d="M349.5,360.3l-3.7.9-4-1.5.5-.9,1.3-.4s1.7-.3,1.9-1.2,2.7,0,2.7,0l1.7,1.5Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1211" data-name="XMLID 1211">
            <path
              id="XMLID_1215"
              data-name="XMLID 1215"
              class="cls-3"
              d="M362.3,339.3s-7.4-2.5-9.5-4.3c0,0,1.3,2.7-.2,7.2s-1.8,11.7-2.2,14.7a1.7,1.7,0,0,1-1.4,1.4h-.7c-.7,0-2.4-.6-2.4-1.5-.1-6.1-.6-26.5.8-28.4s7-4.4,9.7-3.9l10.7,1.8Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1212"
              data-name="XMLID 1212"
              class="cls-4"
              d="M348.2,358.8a3.9,3.9,0,0,1-2.3-.9,1.4,1.4,0,0,1-.6-1.2c-.3-9.9-.5-26.8.9-28.6s7.4-4.6,10.2-4.1l10.7,1.8h.6l-5,14.1h-.5a50.3,50.3,0,0,1-8.3-3.5,14,14,0,0,1-.7,6.1c-.9,2.5-1.5,8.1-1.9,11.7-.1,1.1-.3,2.1-.4,2.9a1.9,1.9,0,0,1-1.9,1.8h-.8Zm7.2-33.8c-2.7,0-7.1,1.8-8.5,3.7s-1,12.1-.6,28c0,.2.1.3.3.4a2.4,2.4,0,0,0,1.6.7l.7-.2a.9.9,0,0,0,.9-.9c.1-.6.2-1.6.3-2.8.4-3.8.9-9.2,2-11.9a12.4,12.4,0,0,0,.2-6.7l-1.1-2.4,2,1.8c1.7,1.4,7.1,3.3,8.9,3.9l4.2-11.8c-1.9-.2-7.8-1.3-10-1.6a1.5,1.5,0,0,0-.9-.2Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1206" data-name="XMLID 1206">
            <path
              id="XMLID_1210"
              data-name="XMLID 1210"
              class="cls-4"
              d="M341,358.8a2.1,2.1,0,0,1,2.5-.5h-.1c-.6.4,0,1,.7,1.4s3.6.7,4.6-.8l.2-.2v-.3c.2-.4.7-.7,1.1-1.1a.5.5,0,0,1,.8,0,.2.2,0,0,1,.2.2,5,5,0,0,1-.1,3.8l-.2,2.9-.3.5h-.1c-.2.2-.7,0-.8,0l-1-.2c-.2,0-.3-.3-.3-.4v-1.4q0-.4-.3-.3l-.4.3a2.8,2.8,0,0,1-1.3.4,1.7,1.7,0,0,1-1.4-.3C342.7,361.7,340.2,360.2,341,358.8Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1207"
              data-name="XMLID 1207"
              class="cls-4"
              d="M349.9,365.2h-.7l-1-.3a.7.7,0,0,1-.5-.8v-1h-.1a2.5,2.5,0,0,1-1.4.6l-1.7-.3c-2.6-1.3-3.7-2.3-4.1-3.3a2,2,0,0,1,.1-1.3c.4-.7,1.2-1.2,3-.7l.9.3-.8.5c-.1,0-.1,0-.1.1h0c0,.2.1.4.7.8s3.3.5,4-.6v-.5l.2-.2,1.1-1.1a.8.8,0,0,1,.9-.3,1,1,0,0,1,.8.7,5.8,5.8,0,0,1-.1,3.9l-.3,2.9a1,1,0,0,1-.4.7c-.1.2-.1.2-.2.2S350,365.2,349.9,365.2ZM348,362h.3c.3.2.4.4.3.7v1.5l.9.2h.1c.1,0,.3.2.4,0s.1-.1.1-.2l.4-3a4.5,4.5,0,0,0,.1-3.4c0-.2-.1-.2-.1-.2h-.1l-1.1,1.1v.6a4,4,0,0,1-5.1.9c-.4-.3-1.2-.6-1.3-1.3v-.2a1.7,1.7,0,0,0-1.4.3,1.7,1.7,0,0,0-.1.7c.2.8,1.4,1.7,3.6,2.8a2,2,0,0,0,1.1.3,1.3,1.3,0,0,0,1-.4l.4-.3Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_4-2"
              data-name="Vector 4-2"
              class="cls-4"
              d="M344,363.1a15.2,15.2,0,0,0,4.2,1.6,12.2,12.2,0,0,0,0-2.7C348.1,361.2,343.1,362.3,344,363.1Z"
              transform="translate(3.3)"
            />
            <ellipse
              id="Ellipse_1"
              data-name="Ellipse 1"
              class="cls-3"
              cx="350.2"
              cy="360.9"
              rx="1"
              ry="1.4"
            />
          </g>
        </g>
        <g id="XMLID_1182" data-name="XMLID 1182">
          <g id="XMLID_1198" data-name="XMLID 1198">
            <path
              id="XMLID_1202"
              data-name="XMLID 1202"
              class="cls-5"
              d="M390.5,362.5V336.6s0-.2-.1-.2l-12.3,1.2-1.2-6.8h-.1l-25.4,14.5h-.1l-2.2-.6c-.1,0-.1,0-.1.1v25.9a.9.9,0,0,0,.6.9l11.4,6.7a3.4,3.4,0,0,0,3.1,0l25.6-14.6A1.3,1.3,0,0,0,390.5,362.5Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1199"
              data-name="XMLID 1199"
              class="cls-4"
              d="M362.8,379.2a2.9,2.9,0,0,1-1.8-.5L349.6,372a2.4,2.4,0,0,1-.9-1.3V344.8a.5.5,0,0,1,.3-.5c.1-.2.4-.2.5-.2l1.9.6,25.3-14.4a.6.6,0,0,1,.6,0h.3l1,6.6,11.9-1.1h.1c.3.2.5.4.5.7v26a1.4,1.4,0,0,1-.9,1.4l-25.6,14.7A2.8,2.8,0,0,1,362.8,379.2Zm-13-33.8v25.3a.5.5,0,0,0,.3.5l11.4,6.7a2.4,2.4,0,0,0,2.6,0l25.6-14.6c.3-.2.4-.4.4-.5h0V337.2l-11.9,1h-.5l-1-6.3-25,14.2h-.3Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1193" data-name="XMLID 1193">
            <path
              id="XMLID_1197"
              data-name="XMLID 1197"
              class="cls-4"
              d="M390.5,336.4l-12.3,1.2-15.5,12.2v28.9a3.3,3.3,0,0,0,1.7-.4L390,363.7a1.4,1.4,0,0,0,.6-1.1c-.1-.1-.1-25.6-.1-26.2Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1194"
              data-name="XMLID 1194"
              class="cls-4"
              d="M362.8,379.2h-.6V349.5l16-12.5h.1l12.2-1.2h.1c.3.2.5.4.5.7v26a1.3,1.3,0,0,1-.9,1.4l-25.6,14.7A2.8,2.8,0,0,1,362.8,379.2Zm.4-29.1V378l.9-.2,25.6-14.7c.2,0,.4-.3.4-.5V337.1l-11.6,1Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1188" data-name="XMLID 1188">
            <path
              id="XMLID_1192"
              data-name="XMLID 1192"
              class="cls-4"
              d="M351,346.2l.4-1-2-.5c-.2,0-.2,0-.2.1v25.9a1,1,0,0,0,.7.9l1.1.7Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1189"
              data-name="XMLID 1189"
              class="cls-4"
              d="M351.6,373.2l-2-1.2a2.4,2.4,0,0,1-.9-1.3V344.8a.5.5,0,0,1,.3-.5c.1-.2.4-.2.5-.2l2.6.8-.3.5a3.6,3.6,0,0,1-.4,1.1Zm-1.8-27.9v25.3a.5.5,0,0,0,.3.5l.4.3V346.2h0a.8.8,0,0,0,.2-.5Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1183" data-name="XMLID 1183">
            <path
              id="XMLID_1187"
              data-name="XMLID 1187"
              class="cls-3"
              d="M361.3,352.2l-11.4-6.6a1.2,1.2,0,0,1-.5-1.6l.5-.5,25.6-14.6a3.4,3.4,0,0,1,3.1,0l11.4,6.6a1.2,1.2,0,0,1,.5,1.6l-.5.5-25.6,14.6A2.6,2.6,0,0,1,361.3,352.2Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1184"
              data-name="XMLID 1184"
              class="cls-4"
              d="M362.8,353.3a3.7,3.7,0,0,1-1.8-.5l-11.4-6.7a1.7,1.7,0,0,1-.9-1.6,2.1,2.1,0,0,1,.9-1.5l25.7-14.6a3.2,3.2,0,0,1,3.5,0l11.4,6.6a1.7,1.7,0,0,1,.9,1.6,1.9,1.9,0,0,1-.9,1.5l-25.6,14.7A6.1,6.1,0,0,1,362.8,353.3ZM377,329a1.7,1.7,0,0,0-1.2.4L350.1,344c-.2.1-.3.5-.3.7a.7.7,0,0,0,.3.6l11.4,6.7a2.8,2.8,0,0,0,2.5,0l25.6-14.7a.7.7,0,0,0,.4-.6.5.5,0,0,0-.4-.6l-11.4-6.7a1.7,1.7,0,0,0-1.2-.4Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
        <g id="side-arm-r">
          <g id="XMLID_1177" data-name="XMLID 1177">
            <path
              id="XMLID_1181"
              data-name="XMLID 1181"
              class="cls-11"
              d="M344.5,304.4l-2.2-1.5a4.3,4.3,0,0,0-2.7-.6,3.3,3.3,0,0,0-2.7,1.5v.6l2.2.7v.4l-.6.4s.6,2.3,4.5,1.7S344.5,304.4,344.5,304.4Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1178"
              data-name="XMLID 1178"
              class="cls-4"
              d="M341.7,308.1c-3.2,0-3.9-2.1-3.9-2.2v-.4h.3l-1.7-.7v-1.1a3.5,3.5,0,0,1,3.1-1.8,4.8,4.8,0,0,1,3.1.8l2.3,1.5a2.4,2.4,0,0,1,.5,2.4A2.7,2.7,0,0,1,343,308Zm-2.6-2.2c.4.5,1.4,1.3,3.7.9a2.1,2.1,0,0,0,1.7-.8,1.5,1.5,0,0,0-.3-1.3l-2-1.4a4.6,4.6,0,0,0-2.3-.6c-1,.1-1.7.2-2.2,1.1l2.1.7.2,1Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1172" data-name="XMLID 1172">
            <path
              id="XMLID_1176"
              data-name="XMLID 1176"
              class="cls-4"
              d="M346.6,305.1l-1.3-.7a.5.5,0,0,0-.7,0,5.1,5.1,0,0,0-1.5,2.3.7.7,0,0,0,.2.7h.1l1.4.7a.4.4,0,0,0,.5-.1v-.2l1.2-1.9C346.9,305.8,346.8,305.3,346.6,305.1Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1173"
              data-name="XMLID 1173"
              class="cls-4"
              d="M345.1,308.7h-.5l-1.4-.7a1.2,1.2,0,0,1-.6-1.4,13.2,13.2,0,0,1,1.6-2.5,1.3,1.3,0,0,1,1.3-.2l1.3.8a.9.9,0,0,1,.5.8c.2.2,0,.6-.1.9l-1.2,1.9A1.1,1.1,0,0,1,345.1,308.7Zm-.1-3.8a4.1,4.1,0,0,0-1.4,2v.2l1.4.6,1.2-1.9v-.2Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1167" data-name="XMLID 1167">
            <path
              id="XMLID_1171"
              data-name="XMLID 1171"
              class="cls-11"
              d="M361.2,303.7c-.4.9.3-1.3,0,0-1.3,3.4-2.9,7.1-2.9,7.1-2-1-4.1-1.9-6.2-2.7a18.7,18.7,0,0,1-4.8-2.6h-.1a3.1,3.1,0,0,0-2.1,2.7c0,.1,0,.1.2.3s9.2,8.3,15.3,9.7a21.7,21.7,0,0,0,5.4-9.4C367.6,302.6,361.8,301.4,361.2,303.7Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1168"
              data-name="XMLID 1168"
              class="cls-4"
              d="M360.6,318.6h-.2c-6.3-1.4-14.7-9-15.6-9.9a.7.7,0,0,1-.3-.6,3.6,3.6,0,0,1,2.4-3.2.6.6,0,0,1,.7.1,20.9,20.9,0,0,0,4.6,2.6c2,.7,4.7,1.9,5.9,2.4l2.5-6.4h.2l.2-.6a2.8,2.8,0,0,1,3-.6c2,.6,3.6,3,2.4,6.7a22.6,22.6,0,0,1-5.5,9.6Zm-15.1-10.7c1.3,1.2,9,8,14.8,9.5a22.7,22.7,0,0,0,5-8.8c.9-3.2-.4-4.9-1.8-5.3s-1.6-.1-1.8.4l-.3.5-2.7,6.7-.2.5-.5-.2c-2-1-4.2-1.9-6.3-2.7a22.3,22.3,0,0,1-4.8-2.6c-.2.3-1.2.8-1.4,2Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
        <g id="XMLID_1146" data-name="XMLID 1146">
          <g id="XMLID_1161" data-name="XMLID 1161">
            <path
              id="XMLID_1165"
              data-name="XMLID 1165"
              class="cls-4"
              d="M333.6,357a3.2,3.2,0,0,1-2.4,1.1,3,3,0,0,0-2.3,1.3l1.9,2.5,4-.2,2.1-1.5.7-2.6-2.4-1.1Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1156" data-name="XMLID 1156">
            <path
              id="XMLID_1160"
              data-name="XMLID 1160"
              class="cls-3"
              d="M375.1,337.6s-9.5,16.2-33.2-1.9c-.1-.2-.2,0-.2.1a11.4,11.4,0,0,1-.5,7.5c-1.6,3.3-3,10.7-3.6,13.6a1.4,1.4,0,0,1-1.4,1.2h-.7c-.7,0-1.9-.7-1.9-1.6.3-6.1,1.2-26.5,2.6-28.1s7.5-2.5,10.2-1.8l17.8,5Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1157"
              data-name="XMLID 1157"
              class="cls-4"
              d="M335.5,358.7a3.4,3.4,0,0,1-1.9-.9,1.7,1.7,0,0,1-.5-1.5v-.2c.8-18.2,1.5-26.8,2.7-28.1s7.9-2.7,10.8-2,17.6,4.9,17.8,5.1h.1l11.3,6.2-.3.6a15.2,15.2,0,0,1-10,6.5c-6.6,1.3-14.5-1.3-23.2-7.7a11.8,11.8,0,0,1-.7,6.7c-1.4,3.1-2.7,9.6-3.4,12.8v.7a2,2,0,0,1-1.9,1.6Zm7.1-32c-2.3,0-4.8.5-6,2s-1.6,6.1-2.5,27.5v.3c0,.2.2.4.3.6a1.6,1.6,0,0,0,1.1.5h.7c.5,0,.7-.4.9-.7v-.7c.6-3.2,2.1-9.9,3.5-13.1a10.5,10.5,0,0,0,.3-7c-.1-.4,0-.7.3-.8a1.1,1.1,0,0,1,.8,0c8.8,6.7,16.5,9.4,23.2,8.1a14.1,14.1,0,0,0,8.9-5.7L363.9,332l-17.8-4.9a13.4,13.4,0,0,0-3.5-.4Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1151" data-name="XMLID 1151">
            <path
              id="XMLID_1155"
              data-name="XMLID 1155"
              class="cls-4"
              d="M327.6,359.6c.4-1.5,1.7-1.7,3.5-1.5a2,2,0,0,0-1.2.8c-.5.5,0,1,1,1.4a3.8,3.8,0,0,0,4.8-1.3l.2-.2.3-.4h.1a6.4,6.4,0,0,1,1-1.3c.4-.4,1.1-.3,1.2.1a5.2,5.2,0,0,1,.1,3.9v3a1.4,1.4,0,0,1-.2.6H338a3.3,3.3,0,0,1-1.4-.1c-.2,0-.3-.3-.4-.4v-1.6a.2.2,0,0,0-.3-.1h0l-.3.3-.9.6a2.6,2.6,0,0,1-2.1,0C330.2,362.8,327.2,361.5,327.6,359.6Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_3-2"
              data-name="Vector 3-2"
              class="cls-4"
              d="M331,362.9a51.5,51.5,0,0,0,5.6,1.6v-1.6c0-.7-.2-2.1-.4-2.1h-3.5C331.7,361.3,330.5,362.6,331,362.9Z"
              transform="translate(3.3)"
            />
            <ellipse
              id="Ellipse_1_2"
              data-name="Ellipse 1 2"
              class="cls-3"
              cx="337.7"
              cy="361.1"
              rx="1.1"
              ry="1.5"
            />
          </g>
          <g id="XMLID_1147" data-name="XMLID 1147">
            <path
              id="XMLID_1148"
              data-name="XMLID 1148"
              class="cls-4"
              d="M341.2,335.9a4,4,0,0,0-1.2-2.1l.7-.9a5.1,5.1,0,0,1,1.5,2.8l-1,.2Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
        <g id="XMLID_1138" data-name="XMLID 1138">
          <g id="XMLID_1141" data-name="XMLID 1141">
            <path
              id="XMLID_1145"
              data-name="XMLID 1145"
              class="cls-4"
              d="M376.4,311.3s2.1,13.1,3.1,20.1-8.1,11-14,11.6-12-2.4-13.9-5.5a12.2,12.2,0,0,0-4.8-4.5s7.6-5.3,9.6-18.8,9.6-15.6,10.1-15.5S376.4,311.3,376.4,311.3Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_1142"
              data-name="XMLID 1142"
              class="cls-4"
              d="M363.8,343.8c-5.5,0-10.8-3-12.6-5.9a13.5,13.5,0,0,0-4.5-4.4l-.8-.4.8-.5c.1,0,7.3-5.3,9.5-18.4s10.5-16,10.6-16,.6,0,10.2,12.7h.2v.2s2,13.1,3,20.1a7.4,7.4,0,0,1-1.5,5.9c-2.7,3.6-8.4,5.8-12.9,6.3A4.5,4.5,0,0,1,363.8,343.8Zm-16-10.8a13.3,13.3,0,0,1,4.3,4.2c1.6,2.7,7.5,6.1,13.4,5.3,4.2-.5,9.8-2.6,12.2-5.9a7.5,7.5,0,0,0,1.4-5.2c-1-6.6-2.8-18.6-3.1-20-3.2-4.3-8.4-11-9.5-12.2-1,.3-7.4,2.8-9.3,15.2s-7.4,17-9.4,18.6Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_1139" data-name="XMLID 1139">
            <path
              id="XMLID_1140"
              data-name="XMLID 1140"
              class="cls-5"
              d="M349.6,334.1l-.5-.6c6-4,8.9-13.2,9-13.4l.8.3C358.7,320.8,355.8,330,349.6,334.1Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
        <g id="side-arm-l">
          <g id="XMLID_1119" data-name="XMLID 1119">
            <g id="LeftArm">
              <g id="XMLID_1133" data-name="XMLID 1133">
                <path
                  id="XMLID_1137"
                  data-name="XMLID 1137"
                  class="cls-11"
                  d="M336.2,308.1a9.2,9.2,0,0,0-1.8-3c-.8-.6-1.3,0-1.6.4h-.3l-2.2-1.2a.5.5,0,0,0-.7,0h-.1a2.6,2.6,0,0,0-.1,2.9c.9,2.3,4.7,3.1,4.7,3.1Z"
                  transform="translate(3.3)"
                />
                <path
                  id="XMLID_1134"
                  data-name="XMLID 1134"
                  class="cls-4"
                  d="M334.3,311.2l-.4-.2c-.2,0-4.1-.9-5.2-3.4a3.6,3.6,0,0,1,.3-3.5,1.1,1.1,0,0,1,1.4-.4l2.1,1.2a1.4,1.4,0,0,1,1-.7,1.5,1.5,0,0,1,1.1.4c1.1.9,1.8,3,2,3.2v.3Zm-4.3-6.3c-.4.4-.6,1.1-.1,2.4s2.8,2.4,4,2.7l1.6-2.1a6.1,6.1,0,0,0-1.5-2.4h-.3c-.1,0-.3.1-.5.4a.7.7,0,0,1-.8.4l-.2-.2Z"
                  transform="translate(3.3)"
                />
              </g>
              <path
                id="Vector_5-2"
                data-name="Vector 5-2"
                class="cls-12"
                d="M334.1,309.9l.7.5,1,1.2-.6.3-1.3-1.4.2-.6"
                transform="translate(3.3)"
              />
              <path
                id="Vector_6-2"
                data-name="Vector 6-2"
                class="cls-4"
                d="M336.8,309.6l-.7-.9c-.2-.3.3-.9.6-.6l1.8,1.5Z"
                transform="translate(3.3)"
              />
              <g id="XMLID_1123" data-name="XMLID 1123">
                <path
                  id="XMLID_1127"
                  data-name="XMLID 1127"
                  class="cls-11"
                  d="M360.4,305.5a1.8,1.8,0,0,0-1.8-.8,2.4,2.4,0,0,0-.9.6,27.9,27.9,0,0,0-3.5,4.2c-2,3.2-6.5,9-6.5,9s-3.2-2.8-5.5-4.6a25.9,25.9,0,0,1-4.1-4v-.2a2.8,2.8,0,0,0-2.7,2.1v.3c.6,1,6.5,10.4,12.2,13.9a.8.8,0,0,0,1.1-.1c1.8-1.5,7.2-6.5,9.9-11S361.2,306.8,360.4,305.5Z"
                  transform="translate(3.3)"
                />
                <path
                  id="XMLID_1124"
                  data-name="XMLID 1124"
                  class="cls-4"
                  d="M348,326.7a1.1,1.1,0,0,1-.8-.3c-5.7-3.6-11.7-13.1-12.3-14.1a1.3,1.3,0,0,1-.1-.6,3.3,3.3,0,0,1,3.2-2.5c.2,0,.4.3.5.4a18.1,18.1,0,0,0,4.1,3.7c1.9,1.5,4.2,3.5,5.1,4.3,1.1-1.4,4.5-5.9,6.1-8.5a23.7,23.7,0,0,1,3.5-4.2l1.2-.7a2.5,2.5,0,0,1,2.4,1.1c1.3,2.1.6,5.3-1.9,9.7s-8.4,9.8-10,11.2A1.2,1.2,0,0,1,348,326.7Zm-12.2-14.9c.9,1.4,6.5,10.3,11.9,13.7.1.1.3.2.4.1h.1c1.7-1.4,7.1-6.4,9.7-10.9s3-6.9,2-8.7l.4-.3-.6.3a1.1,1.1,0,0,0-1.2-.5.7.7,0,0,0-.7.4,18.6,18.6,0,0,0-3.3,4.1c-2.1,3.2-6.5,9-6.5,9.1l-.4.5-.4-.4s-3.2-2.8-5.5-4.6a19.4,19.4,0,0,1-4.1-4C337.3,310.3,336.3,310.5,335.8,311.8Z"
                  transform="translate(3.3)"
                />
                <path
                  id="Vector_1"
                  data-name="Vector 1"
                  class="cls-11"
                  d="M338.1,311.3l-2.9-3.8c-2-1.8-2.4,2-1.6,2.3a12.8,12.8,0,0,1,2.8,2.9Z"
                  transform="translate(3.3)"
                />
              </g>
            </g>
            <g id="XMLID_1120" data-name="XMLID 1120">
              <path
                id="XMLID_1121"
                data-name="XMLID 1121"
                class="cls-4"
                d="M347.1,321a6.2,6.2,0,0,1,.1-2.7l1,.3a4.4,4.4,0,0,0-.1,2.3Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_1113" data-name="XMLID 1113">
          <path
            id="XMLID_1117"
            data-name="XMLID 1117"
            class="cls-5"
            d="M361.4,297s1,3.2.1,4.8,3.1,1.1,3.1,1.1l4-2.8a7.7,7.7,0,0,1-1.2-3.6c.2-1.6.3-1.8-.1-1.6Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_1114"
            data-name="XMLID 1114"
            class="cls-4"
            d="M363.6,303.5c-.9,0-2.1-.2-2.4-.8a.9.9,0,0,1,0-1.2c.6-1.1.1-3.4-.2-4.3v-.5l.5-.2,6-2.3a.9.9,0,0,1,.7.1,1.4,1.4,0,0,1,.2,1.1,4.1,4.1,0,0,1-.1,1.1,7.9,7.9,0,0,0,1,3.4l.3.3-4.5,3.3h-1.5Zm-1.5-6.2c.2,1,.6,3.3,0,4.7v.2a6.5,6.5,0,0,0,2.4.2l3.4-2.5a7.2,7.2,0,0,1-.8-3.5,3.4,3.4,0,0,1,.1-1Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_1108" data-name="XMLID 1108">
          <path
            id="XMLID_1112"
            data-name="XMLID 1112"
            class="cls-3"
            d="M361.8,281.2s-4.9-.2-6.5,4a7.4,7.4,0,0,0,1.6,7.5s4.3-1.3,4.9-3.2S361.8,281.2,361.8,281.2Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_1109"
            data-name="XMLID 1109"
            class="cls-4"
            d="M356.8,293.3l-.3-.2c-.1-.2-3.4-3.5-1.7-8.1s7-4.4,7-4.4h.5v.5c0,.3.8,6.4,0,8.5s-4.7,3.5-5.2,3.6Zm4.5-11.5c-1.2.1-4.4.5-5.5,3.7a6.8,6.8,0,0,0,1.3,6.7c1.2-.4,3.7-1.6,4.2-2.9S361.5,283.7,361.3,281.8Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_1103" data-name="XMLID 1103">
          <path
            id="XMLID_1107"
            data-name="XMLID 1107"
            class="cls-11"
            d="M364.6,281.8s3.5-2.9,4.8,4.2c.9,5-1.1,8-4.8,10.8a3.9,3.9,0,0,1-3.6.6,5,5,0,0,1-3-3.6,17.9,17.9,0,0,1-.6-8.6c-.6-2.9,1.3-2.5,4.8-3.4Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_1104"
            data-name="XMLID 1104"
            class="cls-4"
            d="M362.2,298.3l-1.3-.2a6.1,6.1,0,0,1-3.5-4,18.3,18.3,0,0,1-.5-8.7,3.4,3.4,0,0,1,.2-2.2c.5-.8,1.5-1.1,2.9-1.3l2.1-.5h.1l2.3-.2a2.7,2.7,0,0,1,2.6-.3c1.4.5,2.3,2.1,2.9,5.1.9,4.7-.5,8-4.9,11.3A6.3,6.3,0,0,1,362.2,298.3Zm.1-15.9-2,.5c-1.2.3-2.1.4-2.3.9a2.2,2.2,0,0,0,0,1.6h0a15.2,15.2,0,0,0,.5,8.2,4.2,4.2,0,0,0,2.7,3.2,2.8,2.8,0,0,0,3-.6c3.4-2.6,5.4-5.4,4.5-10.3-.6-3.1-1.5-4.1-2.2-4.3a1.8,1.8,0,0,0-1.6.3l-.2.2Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_1098" data-name="XMLID 1098">
          <path
            id="XMLID_1102"
            data-name="XMLID 1102"
            class="cls-5"
            d="M362.3,305.3c-1.5.2-4.1-1.8-2.8-2.9h.1c1-.6,4.2.3,6.2-1s1.5-2,1.4-2.5a1,1,0,0,1,.2-.9l.9-.2a1.8,1.8,0,0,1,1.6,2.1,1.4,1.4,0,0,1-.2.7,7.5,7.5,0,0,1-4.1,3.9A9.4,9.4,0,0,1,362.3,305.3Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_1099"
            data-name="XMLID 1099"
            class="cls-4"
            d="M362.1,305.9a3.9,3.9,0,0,1-3.4-2.1,1.7,1.7,0,0,1,.4-1.8h.3a4,4,0,0,1,2.4-.4,7.8,7.8,0,0,0,3.7-.6c1.3-.8,1.3-1.6,1.2-1.8a1.1,1.1,0,0,1,.5-1.4,2,2,0,0,1,1.3-.4,1.8,1.8,0,0,1,1.6,1,2.7,2.7,0,0,1,.3,2.6,7.9,7.9,0,0,1-4.4,4.2,18.9,18.9,0,0,1-3.4.9C362.5,305.9,362.3,305.9,362.1,305.9Zm-.7-3.3h-1.7a.4.4,0,0,0-.1.5,2.7,2.7,0,0,0,2.6,1.4,19.4,19.4,0,0,0,3.3-.7,6.7,6.7,0,0,0,3.7-3.5,1.6,1.6,0,0,0-.1-1.5c-.3-.3-.5-.6-.8-.6s-.4,0-.5.2a.6.6,0,0,0-.1.4,3.2,3.2,0,0,1-1.7,2.9c-1.8,1.1-2.9.8-4.2.8Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_1024" data-name="XMLID 1024">
          <path
            id="XMLID_1028"
            data-name="XMLID 1028"
            class="cls-3"
            d="M363.3,278.9c-2.7.4-5.9,2.6-6.4,4.4s-.4,3.5,2,3.2c.8-.1,1.6,2.3,1.9,3.2a1.6,1.6,0,0,0,1.3.8c.7-.1,1.6.9,1.7,1.9a2.5,2.5,0,0,1-.7,2.3c1.5,3.6-5.7,7.6,1.4,10.4.1.2-4.9,7.1,1.7,10.9s16.4,2.1,18.9-4.2c4.2-10.9-10.7-13-11.4-22.3C373.1,282.4,367.7,278.4,363.3,278.9Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_1025"
            data-name="XMLID 1025"
            class="cls-4"
            d="M373.5,318.5a16.7,16.7,0,0,1-7.6-1.8c-2.7-1.7-5.4-4.9-2.2-11.2a5.1,5.1,0,0,1-2.8-2.4c-.5-1.4.1-2.9.8-4.3s1.3-2.5.7-3.7v-.4l.4-.2a2.4,2.4,0,0,0,.5-1.8,1.6,1.6,0,0,0-.6-1.3l-.5-.3a1.7,1.7,0,0,1-1.8-1.1c0-.2-.2-.3-.2-.5-.6-2-1-2.5-1.2-2.5a2.4,2.4,0,0,1-2.4-.6c-.5-.7-.5-1.7-.1-3.4s4-4.3,6.9-4.7a8.8,8.8,0,0,1,6.4,2,12.8,12.8,0,0,1,4.5,9.3c.3,3.8,3.2,6.4,6,9s7.9,7,5.3,13.5c-.9,2.4-3.1,4.2-6.2,5.3A13.5,13.5,0,0,1,373.5,318.5Zm-9.8-23.4a5.2,5.2,0,0,1-.9,4.2c-.6,1.3-1.1,2.5-.7,3.4s1.1,1.4,2.6,2l.3.2v.2c.2.3,0,.4-.2.9-2.5,4.5-1.8,7.7,1.6,9.8s8.5,2.2,12.6.7c1.9-.6,4.5-2,5.5-4.7,2.3-5.8-1.3-9-5-12.3s-6.1-5.4-6.4-9.8a12.5,12.5,0,0,0-4.1-8.5,7.1,7.1,0,0,0-5.6-1.7c-2.5.2-5.5,2.3-6.1,3.9a3.1,3.1,0,0,0-.1,2.3,1.4,1.4,0,0,0,1.4.3c1.2-.1,1.9,1.8,2.5,3.1s.1.3.1.4a1,1,0,0,0,.8.5,1.7,1.7,0,0,1,1.2.5,2.8,2.8,0,0,1,1.2,2,4.8,4.8,0,0,1-.7,2.6Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_1021" data-name="XMLID 1021">
          <path
            id="XMLID_1022"
            data-name="XMLID 1022"
            class="cls-4"
            d="M358.2,286.6a4.3,4.3,0,0,1,2.2-4.7l.4,1c-.2,0-1.9.9-1.6,3.6Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_1019" data-name="XMLID 1019">
          <path
            id="XMLID_1020"
            data-name="XMLID 1020"
            class="cls-4"
            d="M365,305.5l-1-.4a9.2,9.2,0,0,1,1.6-3.1l.8.8A8.7,8.7,0,0,0,365,305.5Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_1017" data-name="XMLID 1017">
          <path
            id="XMLID_1018"
            data-name="XMLID 1018"
            class="cls-4"
            d="M370.6,289.5a9,9,0,0,0-2.3-5.6l.8-.7a9.3,9.3,0,0,1,2.7,6.1Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_1015" data-name="XMLID 1015">
          <path
            id="XMLID_1016"
            data-name="XMLID 1016"
            class="cls-4"
            d="M379.3,314.4l-.5-.9a5.7,5.7,0,0,0,2.9-4.3h1A6.6,6.6,0,0,1,379.3,314.4Z"
            transform="translate(3.3)"
          />
        </g>
      </g>
      <g id="Front_Guy" data-name="Front Guy">
        <g id="XMLID_8251" data-name="XMLID 8251">
          <g id="XMLID_8377" data-name="XMLID 8377">
            <g id="XMLID_8380" data-name="XMLID 8380">
              <g id="XMLID_8383" data-name="XMLID 8383">
                <path
                  id="XMLID_8387"
                  data-name="XMLID 8387"
                  class="cls-3"
                  d="M105.5,324.6s1-.5,1.8,1.5,1.2,2.9.9,3.9-3.7,1-3.7,1-5.2,2.7-9.4,2.7-1.7-2.4-1.5-2.7,5.2-2.2,6-4,.7-1.7.7-1.7Z"
                  transform="translate(3.3)"
                />
                <path
                  id="XMLID_8384"
                  data-name="XMLID 8384"
                  class="cls-4"
                  d="M95.1,334.5c3.7,0,8.7-2.5,9.4-2.7s4-.3,4.2-1.5a4.1,4.1,0,0,0-.5-2.8,5.8,5.8,0,0,0-.5-1.4,2.8,2.8,0,0,0-1.2-2c-.5-.3-.7-.3-1,0l-5.4,1c-.5,0-.5.2-1.3,1.9s-2,2-4.9,3.5c-.5.3-.5.3-.8.3a2.1,2.1,0,0,0-.7,2.4C92.9,334.2,93.6,334.5,95.1,334.5Zm10.7-9.4h0c.2,0,.5.2.7,1.2a4.8,4.8,0,0,1,.5,1.7,6.5,6.5,0,0,1,.5,2c-.2.3-1.7.5-3.2.8H104s-5.2,2.7-9.1,2.7c-1.3,0-1.8-.3-1.8-.5a3.1,3.1,0,0,1,.5-1.2.5.5,0,0,0,.5-.3c2.5-1.2,5.2-2.5,5.7-4.2l.5-1.2Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_8381" data-name="XMLID 8381">
                <path
                  id="XMLID_8382"
                  data-name="XMLID 8382"
                  class="cls-4"
                  d="M102.1,330.3a11.5,11.5,0,0,1,5.2-2.5l.7-.3a4.3,4.3,0,0,1,.5,2.5c-.3,1-3.7,1-3.7,1s-5.2,2.7-9.4,2.7c-2.5,0-2.5-1-2.3-1.7C97.6,334.2,102.1,330.3,102.1,330.3Z"
                  transform="translate(3.3)"
                />
              </g>
            </g>
            <g id="XMLID_8378" data-name="XMLID 8378">
              <path
                id="XMLID_8379"
                data-name="XMLID 8379"
                class="cls-4"
                d="M101.3,328.8h.3l-.3-1a6.5,6.5,0,0,1-2-.5l-.5,1C100.1,328.5,100.8,328.8,101.3,328.8Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_8364" data-name="XMLID 8364">
            <g id="XMLID_8369" data-name="XMLID 8369">
              <g id="XMLID_8372" data-name="XMLID 8372">
                <path
                  id="XMLID_8376"
                  data-name="XMLID 8376"
                  class="cls-3"
                  d="M95.9,318.1a30.2,30.2,0,0,0-6.7,4.5c-2.5,2.2-4.7-2.7-.5-6.5s6.9-4.2,6.9-4.2l1.5,2.3Z"
                  transform="translate(3.3)"
                />
                <path
                  id="XMLID_8373"
                  data-name="XMLID 8373"
                  class="cls-4"
                  d="M87.9,323.6a3.7,3.7,0,0,0,1.8-.8,26,26,0,0,1,6.7-4.2h.2l1-4.9-2-2.8h-.2s-3,.5-7.2,4.5-3,5.9-1.8,7.4A1.8,1.8,0,0,0,87.9,323.6Zm7.5-6a37.4,37.4,0,0,0-6.7,4.5c-.5.2-1,.7-1.5.2s-.8-3.4,1.7-5.9a17.9,17.9,0,0,1,6.2-4l1.3,1.8Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_8370" data-name="XMLID 8370">
                <path
                  id="XMLID_8371"
                  data-name="XMLID 8371"
                  class="cls-4"
                  d="M93.6,315.4s-5.4,2-6.9,5a10.8,10.8,0,0,1,2-4.5c4.2-3.7,6.4-4.2,6.4-4.2l1.5,2.2Z"
                  transform="translate(3.3)"
                />
              </g>
            </g>
            <g id="XMLID_8367" data-name="XMLID 8367">
              <path
                id="XMLID_8368"
                data-name="XMLID 8368"
                class="cls-4"
                d="M93.2,317l1,1.8-.8.5-1-1.8Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8365" data-name="XMLID 8365">
              <path
                id="XMLID_8366"
                data-name="XMLID 8366"
                class="cls-4"
                d="M91.6,318.7l.8,1.2-.9.5-.7-1.2Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_8337" data-name="XMLID 8337">
            <g id="XMLID_8359" data-name="XMLID 8359">
              <path
                id="XMLID_8363"
                data-name="XMLID 8363"
                class="cls-4"
                d="M105,322.3l.8,1.8a1.2,1.2,0,0,1-.5,1.5,17.6,17.6,0,0,1-4,.7c-.5,0-.7-.2-1-.7l-.7-2Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_8360"
                data-name="XMLID 8360"
                class="cls-4"
                d="M101.6,326.8a9.4,9.4,0,0,0,3.7-.7,3.9,3.9,0,0,0,1-.8,1.3,1.3,0,0,0,0-1.2l-1-2-6.7,1.2,1,2.8a1.6,1.6,0,0,0,1.5.9C101.3,326.8,101.3,326.8,101.6,326.8Zm2.9-3.7.5,1.2v.5l-.2.3a9.2,9.2,0,0,1-3.7.5c-.3,0-.3-.3-.5-.3l-.5-1.5Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8353" data-name="XMLID 8353">
              <path
                id="XMLID_8358"
                data-name="XMLID 8358"
                class="cls-13"
                d="M95.2,301.5h0v-.3l.3-.3H96l4.8,1.5,4.2,1.3,5,1.7a13.7,13.7,0,0,1,3.2,1.6l3.4,2.2,3.4,2.3,1.5,1,1,.9h.1c0,.1.1.2.1.3a.9.9,0,0,1-.1.5h-.9l-.6-.2h-.4a8.7,8.7,0,0,0-4.8-.5h-1.3a17.2,17.2,0,0,1-3.9.4,52.9,52.9,0,0,1-8-.8l1.7,5.2,3.8.9h0l4.1,1c4.4,1.2,14,2.2,17,2.5H131a5.3,5.3,0,0,0,4.1-3.4h0a12.3,12.3,0,0,0,.7-5.7h0l-1.2-10.1h-.1v-5.6l-4.4-2.1h-.5l-1.6-.4-5-1.2-5.4-.9-2.2-.2h-1.3l-.9.2H109l-4.1-.4-8-.5a48.7,48.7,0,0,0-5.4-.1H89.6l-1.2.3a6.7,6.7,0,0,0-3.7,4.2c-.6,1.8-.3,4.1,1.8,6.8h.1c3.1,4.2,8.3,13,10.8,17.3l1.1,1.8h0c.1.3.2.4.3.4h.3a8.8,8.8,0,0,0,4.8-.7h0a1,1,0,0,0,.5-.4,1.7,1.7,0,0,0-.1-.7c-.9-2.5-3.2-8.2-4.2-12.2a13.8,13.8,0,0,0-4.8-7.2v-.4Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_8354"
                data-name="XMLID 8354"
                class="cls-4"
                d="M130.3,324.3h1.2a7.3,7.3,0,0,0,5-3.9,13.1,13.1,0,0,0,.7-6.2L136,304v-6.2l-5-2.5c-1.4-.5-13.8-3.7-16.6-2.7a12.4,12.4,0,0,1-4.7,0,36.6,36.6,0,0,1-5.7-.5c-6.4-.5-13.3-1-15.3,0a7.4,7.4,0,0,0-4.2,5.2c-.5,1.7-.3,4.2,2.2,7.2,4,4.7,10.6,16.6,11.9,18.8.2.5.7.8,1.5,1a10.2,10.2,0,0,0,5.2-.7,2.4,2.4,0,0,0,1-1,2,2,0,0,0,0-1.5c0-.3-.3-.5-.5-1l7.2,1.7c4.4,1.3,14.3,2.3,17.3,2.5C130,324.3,129.8,324.1,130.3,324.3Zm4.2-26.2v5.7l1.2,10.1a11.1,11.1,0,0,1-.7,5.7,6.1,6.1,0,0,1-4,3.5h-1.4c-3-.3-12.7-1.3-17.1-2.5l-8-2c-.5-1.5-1.2-3.4-2-5.4a42.5,42.5,0,0,0,8,.7l3.9-.2a12.2,12.2,0,0,1,6,.2h.2c.8.3,1.5.5,1.8,0s0-1-5.5-4.7a27,27,0,0,1-3.9-2.7c-1.8-1.3-8.5-3.5-13.7-5a22.9,22.9,0,0,1-3.7-1.2,1.8,1.8,0,0,0-1,.2.8.8,0,0,0,.3,1,13.4,13.4,0,0,1,4.9,7.2,86.6,86.6,0,0,0,4.2,12.1v.5c0,.3-.2.3-.5.5a8.4,8.4,0,0,1-4.7.5l-.5-.2c-1.2-2.2-8.1-14.1-11.9-19.1-1.7-2.2-2.4-4.2-1.9-6.4a6.5,6.5,0,0,1,3.7-4.5c1.7-.7,8.9-.2,14.8,0,2,.3,4,.3,5.7.5a12,12,0,0,0,5-.2c2.2-.8,12.1,1.7,15.9,2.7Zm-17.1,14.3c-1,0-2,.3-3,.3a10.3,10.3,0,0,1-3.9.2,48.1,48.1,0,0,1-8.4-1,19.1,19.1,0,0,1-1-3.4,13.7,13.7,0,0,0-4-6.5l2.2.8c4.7,1.5,11.7,3.4,13.2,4.7a27,27,0,0,0,3.9,2.7,28,28,0,0,1,3.5,2.5c-.5,0-1.5-.3-2.5-.3Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8351" data-name="XMLID 8351">
              <path
                id="XMLID_8352"
                data-name="XMLID 8352"
                class="cls-4"
                d="M95.4,301.8l.7-1a6.3,6.3,0,0,0-3.2-1v1A5.5,5.5,0,0,1,95.4,301.8Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8349" data-name="XMLID 8349">
              <path
                id="XMLID_8350"
                data-name="XMLID 8350"
                class="cls-4"
                d="M108,320.4l1-.5a4.1,4.1,0,0,1,.2-4l-.7-.7A5.7,5.7,0,0,0,108,320.4Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8347" data-name="XMLID 8347">
              <path
                id="XMLID_8348"
                data-name="XMLID 8348"
                class="cls-4"
                d="M97.6,317.9a5,5,0,0,0,3.5-1l-.8-.8.3.5-.3-.5s-1.5,1.3-5.2.5l-.2,1A12.4,12.4,0,0,0,97.6,317.9Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8345" data-name="XMLID 8345">
              <path
                id="XMLID_8346"
                data-name="XMLID 8346"
                class="cls-4"
                d="M129.8,322.1c2.2,0,3.5-1.3,3.7-2.2l-1-.5.5.2-.5-.2s-.7,1.7-3.4,1.4l-2-.2-.3,1,2,.2A1.7,1.7,0,0,0,129.8,322.1Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8342" data-name="XMLID 8342">
              <path
                id="XMLID_8344"
                data-name="XMLID 8344"
                class="cls-3"
                d="M103,295.1a30,30,0,0,0-9.9-.8Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_8343"
                data-name="XMLID 8343"
                class="cls-4"
                d="M102.8,295.6l.2-1a34.2,34.2,0,0,0-10.1-.8v1A32.9,32.9,0,0,1,102.8,295.6Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8340" data-name="XMLID 8340">
              <path
                id="XMLID_8341"
                data-name="XMLID 8341"
                class="cls-4"
                d="M118.7,311.7l.7-.8s-4.7-3.7-6.7-6.6l-1,.4A29.1,29.1,0,0,0,118.7,311.7Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8338" data-name="XMLID 8338">
              <path
                id="XMLID_8339"
                data-name="XMLID 8339"
                class="cls-4"
                d="M114.9,305.7l.8-.7a12.5,12.5,0,0,1-3-4.2l-1,.5A14.3,14.3,0,0,0,114.9,305.7Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_8328" data-name="XMLID 8328">
            <g id="XMLID_8335" data-name="XMLID 8335">
              <path
                id="XMLID_8336"
                data-name="XMLID 8336"
                class="cls-14"
                d="M111,275s-7,4.5-11.2,7c0,0,0,1.9-3,5.2a29.2,29.2,0,0,1-5.2,4.7s.8,4.7-.4,5.4-1-.5-1-1.2-.3-.3-.3,0l-.7,2c-.5.9-1.5,2.4-2.8,2.2l-.7-.5a8.7,8.7,0,0,1,1.7-8.9s5.7-7.5,7-9.4,11.1-11.9,11.1-11.9l7.5.5Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8333" data-name="XMLID 8333">
              <path
                id="XMLID_8334"
                data-name="XMLID 8334"
                class="cls-4"
                d="M96.8,282.7a5.4,5.4,0,0,1,2.5-.3v-.7a6.3,6.3,0,0,0-2.7.3Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8331" data-name="XMLID 8331">
              <path
                id="XMLID_8332"
                data-name="XMLID 8332"
                class="cls-5"
                d="M87.4,291.4a24.3,24.3,0,0,1,2-2.5l-.5-.5a15.7,15.7,0,0,0-2,2.5Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8329" data-name="XMLID 8329">
              <path
                id="XMLID_8330"
                data-name="XMLID 8330"
                class="cls-5"
                d="M89.7,293.4h.7v1.7h-.7Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_8292" data-name="XMLID 8292">
            <g id="XMLID_8323" data-name="XMLID 8323">
              <path
                id="XMLID_8327"
                data-name="XMLID 8327"
                class="cls-3"
                d="M130,277.7a16.9,16.9,0,0,0,.8,5c3.2,2.2,6.7-.3,7.7-1a.8.8,0,0,0,.2-.7,27,27,0,0,0-2.7-9.7c-1.5-2.5-4-5.2-6-6.2s-3.4-2.2-5.7-2.5l-3.7-.5s-5.4-.2-8.9,1.5-5.7,5.2-6.4,6v.2a6.1,6.1,0,0,1,4.4,5.5c0,.2.3.2.3.2a11.3,11.3,0,0,0,2.7-2.2h.3c-.3,2.2-1,12.9-1,16.8s-.5,6.2,2.7,8.7,9.9,5.5,13.9,5c2.2-.3,3.2-1.5,4.9-2.8,3.5-2.7.5-13.6.5-13.6l-.2-3.5Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_8324"
                data-name="XMLID 8324"
                class="cls-4"
                d="M128.3,304.5h.5a7.2,7.2,0,0,0,4.2-2l1-.7c3.7-2.8.8-13.4.5-14.1l-.2-3.3a8.2,8.2,0,0,0,4.7-2.2,1.8,1.8,0,0,0,.5-1.2,1.7,1.7,0,0,0-.3-1,24.5,24.5,0,0,0-2.7-8.7c-1.5-2.7-4-5.5-6.2-6.4a13.7,13.7,0,0,1-2-1.3,12,12,0,0,0-3.7-1.5l-3.7-.5c-.3,0-5.7-.2-9.4,1.5a16.9,16.9,0,0,0-6.5,6.2,1.1,1.1,0,0,0-.2.8.5.5,0,0,0,.5.5,5.8,5.8,0,0,1,4.2,4.9c0,.3.2.5.5.8h.7a9.5,9.5,0,0,0,2-1.5c-.2,3.9-1,12.4-1,15.8v1.3c0,3.7,0,5.4,2.7,7.9S123.9,304.5,128.3,304.5Zm5-20.3.2,3.5c.8,2.9,2.5,11.1-.2,13.1l-1,.7a4.8,4.8,0,0,1-3.5,1.8c-4,.2-11.4-3.3-13.6-5s-2.5-3.5-2.5-7.2v-1.2c0-3.7.7-13.6,1-16.9,0-.2-.3-.5-.5-.7a.8.8,0,0,0-.7.2,6.8,6.8,0,0,1-2.3,1.8,7,7,0,0,0-4.4-5.2,20.6,20.6,0,0,1,5.9-5.5c3.2-1.7,8.7-1.5,8.7-1.5l3.7.5a15.4,15.4,0,0,1,3.5,1.5l2,1.3c1.9.9,4.4,3.7,5.6,5.9a27.2,27.2,0,0,1,2.5,8.4c0,.5.3.8.3,1v.3c-1.3,1-4,2.9-7,1.2a14.9,14.9,0,0,1-.7-4.7h-1a29.6,29.6,0,0,0,.7,5.2v.2h.3A4.3,4.3,0,0,0,133.3,284.2Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8321" data-name="XMLID 8321">
              <path
                id="XMLID_8322"
                data-name="XMLID 8322"
                class="cls-4"
                d="M113.7,273.5a5.5,5.5,0,0,0,1-2.2l-1-.2a4.4,4.4,0,0,1-1,1.9Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8311" data-name="XMLID 8311">
              <path
                id="XMLID_8312"
                data-name="XMLID 8312"
                class="cls-4"
                d="M120.6,273.3h1.3l-.3-1h-1.5l-.2,1Zm2-.5c.5-.3,1.3-.3,1.7-.8l-.4-.9a4.2,4.2,0,0,1-1.5.4Zm-3.7,0,.5-1-1.2-.7-.8.7Zm6.2-1,1.5-1-.8-.7a5.8,5.8,0,0,1-1.2,1Zm-8.4-.7,1-.5a2.7,2.7,0,0,1-.5-1.5l-1,.2a3.7,3.7,0,0,0,.5,1.8Zm10.4-1c.5-.5.7-1,1-1.3l-1-.7-1,1.2Zm-9.9-1.8v-1.2l-1-.3c0,.5-.3,1-.3,1.5Zm11.4-.2.7-1.5-1-.5-.7,1.5Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8304" data-name="XMLID 8304">
              <g id="XMLID_8309" data-name="XMLID 8309">
                <path
                  id="XMLID_8310"
                  data-name="XMLID 8310"
                  class="cls-4"
                  d="M117.9,296.1c7.2,0,8.7-5.5,8.7-5.7l-1-.3c0,.3-1.5,4.7-7.7,4.7Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_8307" data-name="XMLID 8307">
                <path
                  id="XMLID_8308"
                  data-name="XMLID 8308"
                  class="cls-4"
                  d="M122.1,292.9c5.5-4.5,4.2-9.2,4.2-9.5l-1,.3c0,.2,1,4.2-3.7,8.2Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_8305" data-name="XMLID 8305">
                <path
                  id="XMLID_8306"
                  data-name="XMLID 8306"
                  class="cls-4"
                  d="M127.3,292.9c1.5-.8,2-2.8,2.3-2.8l-1-.2a4.3,4.3,0,0,1-1.5,2Z"
                  transform="translate(3.3)"
                />
              </g>
            </g>
            <g id="XMLID_8293" data-name="XMLID 8293">
              <g id="XMLID_8299" data-name="XMLID 8299">
                <path
                  id="XMLID_8303"
                  data-name="XMLID 8303"
                  class="cls-3"
                  d="M116.7,282c.2.9.7,1.9,1.5,1.7a1.8,1.8,0,0,0,1.2-2c0-1-.7-2-1.5-1.7S116.4,280.7,116.7,282Z"
                  transform="translate(3.3)"
                />
                <path
                  id="XMLID_8300"
                  data-name="XMLID 8300"
                  class="cls-4"
                  d="M118.2,284.2a2.1,2.1,0,0,0,1.7-2.6h0a2.3,2.3,0,0,0-.8-1.8,1.7,1.7,0,0,0-1.4-.7,2.1,2.1,0,0,0-1.5,2.5v.2A2.4,2.4,0,0,0,118.2,284.2Zm-.3-4a.5.5,0,0,1,.5.3,1.2,1.2,0,0,1,.5,1c0,.7-.2,1.4-.7,1.4a1.1,1.1,0,0,1-1-1.2h0c0-.7.2-1.5.7-1.5Z"
                  transform="translate(3.3)"
                />
              </g>
              <g id="XMLID_8294" data-name="XMLID 8294">
                <path
                  id="XMLID_8298"
                  data-name="XMLID 8298"
                  class="cls-5"
                  d="M115.9,279.5c.3,1,.8,2,1.5,1.7a2.1,2.1,0,0,0,1.3-2c0-1-.8-2-1.5-1.7S115.7,278.2,115.9,279.5Z"
                  transform="translate(3.3)"
                />
                <path
                  id="XMLID_8295"
                  data-name="XMLID 8295"
                  class="cls-4"
                  d="M117.4,281.7a1.5,1.5,0,0,0,1.5-1,4.7,4.7,0,0,0,.2-1.7,2.4,2.4,0,0,0-.7-1.8,2.6,2.6,0,0,0-1.5-.7,1.5,1.5,0,0,0-1.2,1,1.7,1.7,0,0,0-.3,1.7A2.4,2.4,0,0,0,117.4,281.7Zm-.2-4c.2,0,.5.3.5.3a1.9,1.9,0,0,1,.5,1c0,.5,0,.7-.3,1a.5.5,0,0,1-.5.5c-.5,0-1-.5-1-1.3s0-.7.3-1a.5.5,0,0,1,.5-.5Z"
                  transform="translate(3.3)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_8261" data-name="XMLID 8261">
            <g id="XMLID_8287" data-name="XMLID 8287">
              <path
                id="XMLID_8291"
                data-name="XMLID 8291"
                class="cls-14"
                d="M119.9,264.4s-3.2,5.9,1.2,5.7,6.2-5.7,6.2-5.7a19.1,19.1,0,0,1-.5-9.2l-.5-1.5-10.6-5.2-.8,5a28,28,0,0,0,.5,10.4,1.7,1.7,0,0,0,1.8,1,20.4,20.4,0,0,0,6.2-2.8Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_9315"
                data-name="XMLID 9315"
                class="cls-4"
                d="M118.6,257c0,.5.2.9.4.9a.7.7,0,0,0,.7-.6c0-.5-.2-.9-.4-.9S118.6,256.4,118.6,257Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_9316"
                data-name="XMLID 9316"
                class="cls-4"
                d="M114.8,256.4c0,.4.2.8.4.8s.7-.2.7-.6-.3-.9-.5-.9S114.8,255.7,114.8,256.4Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_8288"
                data-name="XMLID 8288"
                class="cls-4"
                d="M120.9,270.6h.2c4.2-.3,6.7-5.7,6.7-6v-.5a17.9,17.9,0,0,1-.5-8.9v-.3l-.5-1.9-11.4-5.7-.7,5.7a27.1,27.1,0,0,0,.5,10.6,1.7,1.7,0,0,0,2,1.5h.2l1.5-.2c-.5,1.2-1,3.2-.2,4.2A2,2,0,0,0,120.9,270.6Zm5.9-6.2c-.5,1-2.5,4.9-5.7,5.2a2.7,2.7,0,0,1-1.5-.5c-.7-1,.3-3.2.8-4.2a9.4,9.4,0,0,0,3.5-2l-.8-1a14.6,14.6,0,0,1-5.9,2.5.9.9,0,0,1-1-.8h0a24.6,24.6,0,0,1-.5-10.1l.7-4.2,9.7,4.7.2,1.2a25.8,25.8,0,0,0,.5,9.2Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8282" data-name="XMLID 8282">
              <path
                id="XMLID_8286"
                data-name="XMLID 8286"
                class="cls-4"
                d="M130.3,255.7l-.3,1a2.8,2.8,0,0,1-1.2,2l-.7.7a5.1,5.1,0,0,1-2,1.2l-1-.4s1.7-1.8,1.5-3.5-1.8-1.8-2.5-.3-.2.3-.5.5l-1.2.3s1.5-2.3.2-4.2-6.9-2.3-7.4.7l-.3,2.2s-2.9-4.2-.2-8.1,7.9-5.5,11.9-2.8l1.2.8A10.3,10.3,0,0,1,130.3,255.7Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_8283"
                data-name="XMLID 8283"
                class="cls-4"
                d="M126.3,261.1a4.8,4.8,0,0,0,2.5-1.4l.8-.8a9.4,9.4,0,0,0,1.2-2.2l.2-1c1-4,0-7.9-2.9-10.4-.5-.3-.8-.8-1.3-1-4.2-2.7-9.6-1.2-12.6,3s.2,8.6.2,8.6l.8,1.3.5-3.7a2.3,2.3,0,0,1,2.2-1.8c1.7-.2,3.7.3,4,1.3a11.7,11.7,0,0,1-.3,3.7l-.5,1,2.5-.5c.5,0,.7-.3,1-.8s.7-.7,1-.5.5.3.5.8a5.7,5.7,0,0,1-1.5,3l-.5.5Zm3.5-5.7-.2,1a4,4,0,0,1-1,1.8l-.8.7a4,4,0,0,1-1.5,1h-.2a6,6,0,0,0,1.2-3.2,1.8,1.8,0,0,0-1.2-1.8,2.3,2.3,0,0,0-2.2,1,.3.3,0,0,1-.3.3h-.2a4.8,4.8,0,0,0-.3-3.7c-.7-1.5-3.2-2-5.2-1.8a3.5,3.5,0,0,0-3.2,2.8v.7a6.5,6.5,0,0,1,.5-5.9c2.7-3.8,7.4-5,11.1-2.8.3.3.8.5,1,.8a8.8,8.8,0,0,1,2.5,9.1Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8276" data-name="XMLID 8276">
              <path
                id="XMLID_8277"
                data-name="XMLID 8277"
                class="cls-4"
                d="M116.9,259.7c.3,0,.8,0,1-.3l-.2-.5a1.1,1.1,0,0,1-1.3,0l.8-2.7-.5-.3a11.1,11.1,0,0,0-.8,3v.3h.3C115.7,259.4,116.2,259.7,116.9,259.7Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8274" data-name="XMLID 8274">
              <path
                id="XMLID_8275"
                data-name="XMLID 8275"
                class="cls-4"
                d="M120.4,257.4l.5-.2a2.9,2.9,0,0,0-2.7-1.3l.2.5A1.8,1.8,0,0,1,120.4,257.4Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8272" data-name="XMLID 8272">
              <path
                id="XMLID_8273"
                data-name="XMLID 8273"
                class="cls-4"
                d="M115.4,255.7l.5-.5a3.1,3.1,0,0,0-1.2-.5v.7A.9.9,0,0,1,115.4,255.7Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8268" data-name="XMLID 8268">
              <path
                id="XMLID_8269"
                data-name="XMLID 8269"
                class="cls-4"
                d="M115.4,260.3l-.2.5a10.2,10.2,0,0,0,3.9.5v-.7A11.6,11.6,0,0,1,115.4,260.3Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8264" data-name="XMLID 8264">
              <path
                id="XMLID_8265"
                data-name="XMLID 8265"
                class="cls-4"
                d="M116.2,250.2a5.7,5.7,0,0,1,3.4-3.4l-.2-.8a7.5,7.5,0,0,0-4.2,4Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8262" data-name="XMLID 8262">
              <path
                id="XMLID_8263"
                data-name="XMLID 8263"
                class="cls-4"
                d="M129.3,254.9a7,7,0,0,0,.3-2.9h-.8a5,5,0,0,1-.2,2.7Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_8252" data-name="XMLID 8252">
            <g id="XMLID_8259" data-name="XMLID 8259">
              <path
                id="XMLID_8260"
                data-name="XMLID 8260"
                class="cls-14"
                d="M125.1,314.2c.7-1,.5-1,0-.8s-.8,0-1-.5a2.4,2.4,0,0,1,1-2.7c2-1,2.2-1,4.5-4s3.7-7.9,4.4-9.6c0,0-2.7-10.2-2.7-13.7a6.7,6.7,0,0,0,6.4-1.2c0,.5,2,8.4,2.5,15.6a23.9,23.9,0,0,1-4.5,7.9,36.4,36.4,0,0,0-4.7,7.5,5.7,5.7,0,0,1-4.7,5.2C121.9,318.9,123.9,315.9,125.1,314.2Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8255" data-name="XMLID 8255">
              <path
                id="XMLID_8256"
                data-name="XMLID 8256"
                class="cls-4"
                d="M126.1,312.9l1.7-1.7-.2-.5-2,1.7Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_8253" data-name="XMLID 8253">
              <path
                id="XMLID_8254"
                data-name="XMLID 8254"
                class="cls-4"
                d="M132.3,309l.5-.3c-1.3-2-2.5-2-2.5-2v.8S131.3,307.5,132.3,309Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_12075" data-name="XMLID 12075">
          <g id="XMLID_12078" data-name="XMLID 12078">
            <path
              id="XMLID_12082"
              data-name="XMLID 12082"
              class="cls-3"
              d="M88.6,302.4,112.4,316h.3l16.3-9.8v-.3L105.3,292H105L88.6,302.4Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_12079"
              data-name="XMLID 12079"
              class="cls-4"
              d="M112.7,316.9h.3l16.3-9.8c.3,0,.3-.3.3-.6a.9.9,0,0,0-.3-.6L105.5,292c-.2-.3-.5-.3-.8,0L88,302.1c-.3,0-.3.3-.3.6a.9.9,0,0,0,.3.6l23.8,13.6Zm15.4-10.7-15.4,9.2L89.8,302.1l15.7-9.5Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_12076" data-name="XMLID 12076">
            <path
              id="XMLID_12077"
              data-name="XMLID 12077"
              class="cls-4"
              d="M114.2,311.9l8.6-5.1a1.4,1.4,0,0,0,.3-.9c0-.3-.3-.6-.3-.9l-5.7-3.2-.6,1.2,5.1,2.9-8,4.8Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
        <g id="XMLID_12049" data-name="XMLID 12049">
          <g id="XMLID_12055" data-name="XMLID 12055">
            <path
              id="XMLID_12059"
              data-name="XMLID 12059"
              class="cls-5"
              d="M112.4,316l-8-18.7L79.7,282.7l8.6,19.4L112.4,316Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_12056"
              data-name="XMLID 12056"
              class="cls-4"
              d="M112.4,316.9l.3-.3a1.4,1.4,0,0,0,.3-.9L104.7,297h-.3l-25-14.8-.3.2a1.4,1.4,0,0,0-.3.9L87.7,303H88Zm-8.6-19,7.4,16.9L88.9,302.1l-7.7-17.6Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_12050" data-name="XMLID 12050">
            <path
              id="XMLID_12054"
              data-name="XMLID 12054"
              class="cls-3"
              d="M94.9,300.9c.8,1.2,2.3,2.1,2.9,1.5s.3-1.8-.9-3.3-2.3-2.1-2.9-1.5S93.7,299.4,94.9,300.9Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_12051"
              data-name="XMLID 12051"
              class="cls-4"
              d="M97.2,303a1.4,1.4,0,0,0,.9-.3c.9-.9.3-2.7-.6-4.2s-2.6-2.4-3.8-1.5-.3,2.7.6,4.2A3.8,3.8,0,0,0,97.2,303Zm-2.6-4.8c.3,0,1.1.3,2,1.5a3.6,3.6,0,0,1,.9,2.4,3.2,3.2,0,0,1-2.1-1.5C94.3,299.1,94.3,298.2,94.6,298.2Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
      </g>
      <g id="Front_Girl" data-name="Front Girl">
        <g id="XMLID_9467" data-name="XMLID 9467">
          <path
            id="XMLID_9471"
            data-name="XMLID 9471"
            class="cls-3"
            d="M148.8,292.1s-3.9-.6-4.8,2.9a89.1,89.1,0,0,0-2,17.8,74.2,74.2,0,0,1-1.5,11.4l12-1.5,2.6-8.8Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_9468"
            data-name="XMLID 9468"
            class="cls-4"
            d="M139.6,324.6l13.1-1.7,2.8-9.2-6.5-22h-.2c-1.5-.2-4.6,0-5.2,3.3a84.4,84.4,0,0,0-2,18.1,70.4,70.4,0,0,1-1.5,11.1Zm12.5-2.4-11.2,1.6a48.6,48.6,0,0,0,1.6-10.7,119.4,119.4,0,0,1,1.9-17.9,3.6,3.6,0,0,1,3.9-2.6l6.2,21.1Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9441" data-name="XMLID 9441">
          <path
            id="XMLID_9445"
            data-name="XMLID 9445"
            class="cls-4"
            d="M133.5,341.2c-4.3-2.4-6.3-3.9-5.4-7l2.6-2.2,9.1-1.3,5.7,5.3.9,3.7-5.5,3.2C140.9,343.2,137,343.2,133.5,341.2Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_9442"
            data-name="XMLID 9442"
            class="cls-4"
            d="M140.7,343.6h.5l5.6-3.5-.9-4.1-5.8-5.5-9.4,1.3-2.9,2.4v.2c-1,3.7,1.6,5.5,5.7,7.7A22,22,0,0,0,140.7,343.6Zm0-1.1a15.7,15.7,0,0,1-7-1.7c-4.3-2.4-5.9-3.7-5.2-6.4l2.4-1.9,8.7-1.1,5.5,5,.6,3.3Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="front-leg-l">
          <g id="XMLID_9462" data-name="XMLID 9462">
            <path
              id="XMLID_9466"
              data-name="XMLID 9466"
              class="cls-4"
              d="M124.6,376.8a9,9,0,0,1,2.8-4.8,52.7,52.7,0,0,0,5.7-6.8l.9-.9.8.2a57.5,57.5,0,0,0,0,8.3l-1.7,1.1-.2-.6a16.5,16.5,0,0,1-4.6,3.2C125.9,377.4,124.6,376.8,124.6,376.8Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_9463"
              data-name="XMLID 9463"
              class="cls-4"
              d="M125.9,377.4a6.7,6.7,0,0,0,2.4-.4,14.6,14.6,0,0,0,4.1-2.9l.2.5,2.7-1.5v-.3c-.5-2.4,0-8,0-8.3v-.4l-1.6-.4-1.1,1.3a44,44,0,0,1-5.4,6.7,8.4,8.4,0,0,0-2.8,5.1v.4l.2.2C124.4,377.2,125,377.4,125.9,377.4Zm6.7-5-.4.7a14.3,14.3,0,0,1-4.4,3.2,7.5,7.5,0,0,1-2.6.5,8.1,8.1,0,0,1,2.6-4.2,74.5,74.5,0,0,0,5.7-6.7l.7-.7h.2c0,1.3-.2,5.5,0,7.6l-1.1.7Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9456" data-name="XMLID 9456">
            <path
              id="XMLID_9460"
              data-name="XMLID 9460"
              class="cls-5"
              d="M130,364.8s-.4,4.5-2.6,7.2c0,0,.9,1.9,3.7,0s2.6-8.5,2.6-8.5Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_9457"
              data-name="XMLID 9457"
              class="cls-4"
              d="M128.9,373.3a3.6,3.6,0,0,0,2.4-.9c2.9-2,3.1-8.5,3.1-8.9v-.7l-4.8,1.7v.3s-.4,4.3-2.4,6.9l-.2.3.2.2a2.4,2.4,0,0,0,1.3,1.1Zm4.4-9.2c-.2,1.8-.7,5.9-2.6,7.4s-1.5.9-2.2.7-.4-.2-.7-.5a13.6,13.6,0,0,0,2.4-6.7Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9436" data-name="XMLID 9436">
            <path
              id="XMLID_9440"
              data-name="XMLID 9440"
              class="cls-3"
              d="M132.2,332.9s-4.1-.4-4.1,7.6,1.3,18.6,1.3,25.4a4,4,0,0,0,4.6-1.6,66.3,66.3,0,0,1,.4-10.9,43.7,43.7,0,0,0,0-13.5s6.5.2,11.1-4.2-7-7.4-7-7.4Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_9437"
              data-name="XMLID 9437"
              class="cls-4"
              d="M130.7,366.5a4.3,4.3,0,0,0,3.7-2v-.4a76.6,76.6,0,0,1,.4-10.7,57.3,57.3,0,0,0,.2-13.1,17.5,17.5,0,0,0,10.9-4.1,2.9,2.9,0,0,0,1.1-3.1c-.8-3-7.6-5-8.2-5.2h-.3l-6.1,4.6a6.8,6.8,0,0,0-2.4.8c-1.5,1.4-2.2,3.8-2.2,7s.5,8.8.7,13.3.7,8.8.7,12v.5l.2.2Zm2.6-2.4a3.4,3.4,0,0,1-3.5,1.3c0-3.3-.2-7.4-.6-11.8a118.5,118.5,0,0,1-.7-13.3c0-3.9,1.1-5.6,1.7-6.3a2.5,2.5,0,0,1,2-.7h.4l5.9-4.3c2.2.6,7,2.4,7.4,4.6.3.6-.2,1.3-.8,1.9-4.4,4.2-10.7,4-10.7,4h-.7l.3.6c.4,1.3.6,7.2,0,13.3A54.5,54.5,0,0,0,133.3,364.1Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9376" data-name="XMLID 9376">
            <path
              id="XMLID_9377"
              data-name="XMLID 9377"
              class="cls-5"
              d="M126.8,376.3a3,3,0,0,0,1.3-.2l-.5-.9a1.7,1.7,0,0,1-1.7,0l-.7.9C125.4,375.9,126.1,376.3,126.8,376.3Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9343" data-name="XMLID 9343">
            <path
              id="XMLID_9344"
              data-name="XMLID 9344"
              class="cls-4"
              d="M129.4,339.7h.8c0-2.6,1.1-3.5,1.1-3.5l-.6-.9A5.8,5.8,0,0,0,129.4,339.7Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
        <g id="front-leg-r">
          <g id="XMLID_9451" data-name="XMLID 9451">
            <path
              id="XMLID_9455"
              data-name="XMLID 9455"
              class="cls-4"
              d="M129.6,378.9a9,9,0,0,1,2.8-4.8,51.8,51.8,0,0,0,5.7-6.7l.9-.9s.4,6.1.8,8.5l-1.7,1.1-.2-.6a16.5,16.5,0,0,1-4.6,3.2C130.9,379.6,129.6,378.9,129.6,378.9Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_9452"
              data-name="XMLID 9452"
              class="cls-4"
              d="M130.9,379.6a6.7,6.7,0,0,0,2.4-.4,14.6,14.6,0,0,0,4.1-2.9l.3.5,2.6-1.6V375c-.5-2.6-.9-8.5-.9-8.5v-1.1l-1.7,1.8a50.2,50.2,0,0,1-5.5,6.7,8.1,8.1,0,0,0-2.8,5v.5l.2.2C129.6,379.4,130,379.6,130.9,379.6Zm6.8-5-.5.6a15.4,15.4,0,0,1-4.3,3.3,8.4,8.4,0,0,1-2.7.4,8.7,8.7,0,0,1,2.7-4.1,51.9,51.9,0,0,0,5.6-6.8l.3-.2c.2,1.8.4,5.3.6,7.2l-1.1.7Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9446" data-name="XMLID 9446">
            <path
              id="XMLID_9450"
              data-name="XMLID 9450"
              class="cls-5"
              d="M135,366.9s-.4,4.6-2.6,7.2c0,0,.9,2,3.7,0s2.9-8.5,2.9-8.5Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_9447"
              data-name="XMLID 9447"
              class="cls-4"
              d="M134,375.5a5,5,0,0,0,2.4-.9c2.8-2,3-8.5,3-9V365l-4.8,1.7v.2s-.4,4.4-2.4,7l-.2.2.2.3a2.4,2.4,0,0,0,1.3,1.1Zm4.3-9.2c-.2,1.7-.6,5.9-2.6,7.4s-1.5.9-2.2.7-.4-.3-.6-.5a13.6,13.6,0,0,0,2.4-6.7Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9431" data-name="XMLID 9431">
            <path
              id="XMLID_9435"
              data-name="XMLID 9435"
              class="cls-3"
              d="M138.5,334.4s-5.4,0-5.4,7.9,1.5,18.3,1.5,24.9c0,0,3.1,1.5,4.8-.9a79.5,79.5,0,0,1,.4-10.9,69.5,69.5,0,0,0,.3-12.9c0-.2.2-.6.4-.6a16.3,16.3,0,0,0,10.5-4.2c4.5-4.4-7-7.4-7-7.4Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_9432"
              data-name="XMLID 9432"
              class="cls-4"
              d="M136.8,368.3a3.5,3.5,0,0,0,3-1.6v-.4a76.7,76.7,0,0,1,.5-10.7,71.7,71.7,0,0,0,.2-13.1,16.4,16.4,0,0,0,10.7-4.1,2.9,2.9,0,0,0,1.1-3.1c-.9-3-7.7-5-8.3-5.2h-.2l-5.5,4.1a5.8,5.8,0,0,0-3.5,1.5c-1.5,1.6-2.2,3.8-2.2,6.8s.5,8.7.9,13.3a93.4,93.4,0,0,1,.7,11.8v.2l.2.2C135,368,135.9,368.3,136.8,368.3Zm2.4-2a3.7,3.7,0,0,1-3.9.9c0-3.3-.5-7.2-.7-11.6s-.9-9.2-.9-13.1.7-4.8,2-6.1a4.1,4.1,0,0,1,2.8-1.3h.3l5.4-3.9c2.2.6,7,2.4,7.4,4.5a2,2,0,0,1-.9,2c-3.4,3.3-8.2,3.9-10.2,3.9-.2,0-.7.3-.7.5s-.2.4-.2.8c.5,2,.5,7.2-.2,12.9A61.4,61.4,0,0,0,139.2,366.3Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9382" data-name="XMLID 9382">
            <path
              id="XMLID_9383"
              data-name="XMLID 9383"
              class="cls-5"
              d="M138.1,375.7a9.2,9.2,0,0,0-.4-2.9l-.7.7.4-.2-.4.2a5.5,5.5,0,0,1,.2,2.2Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9378" data-name="XMLID 9378">
            <path
              id="XMLID_9379"
              data-name="XMLID 9379"
              class="cls-5"
              d="M131.8,378.5a3,3,0,0,0,1.3-.2l-.5-.9a1.7,1.7,0,0,1-1.7,0l-.7.9C130.5,378.1,130.9,378.5,131.8,378.5Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9345" data-name="XMLID 9345">
            <path
              id="XMLID_9346"
              data-name="XMLID 9346"
              class="cls-4"
              d="M134.6,342.3h.9c0-2.6,1.1-3.5,1.1-3.5l-.7-.9A6.4,6.4,0,0,0,134.6,342.3Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
        <g id="XMLID_9426" data-name="XMLID 9426">
          <path
            id="XMLID_9430"
            data-name="XMLID 9430"
            class="cls-5"
            d="M145.9,319a46.8,46.8,0,0,0-11.7,8.5c-2.1,2.1-4.2,4.4-6.1,6.7,0,0,1.9-2.8,7.8-.6s6.3,4.8,6.6,7.2a2.8,2.8,0,0,1-1.3,2.1c1-.2,6.7-1,14.3-6.3s6.4-11.5,4-15.7S145.9,319,145.9,319Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_9427"
            data-name="XMLID 9427"
            class="cls-4"
            d="M140.9,343.6c1.1-.2,7-1.1,14.6-6.5s6.6-12.3,4.2-16.4-13.3-2.2-13.8-2h-.2a51.5,51.5,0,0,0-12,8.8c-3.9,4.1-5.4,5.8-5.9,6.5l-.2.2.9.7.2-.2c.5-.7,2.4-2,7-.3s6.1,4.8,6.1,6.8a1.9,1.9,0,0,1-.9,1.5l-.2.2h0l-.2.3.2.4C140.5,343.4,140.7,343.6,140.9,343.6Zm10.9-24.4c3.1,0,6.4.4,7.2,1.9,2.7,4.4,4.2,9.6-3.7,15.1a37.8,37.8,0,0,1-12.8,6.1,2.8,2.8,0,0,0,.4-1.5c-.2-2.7-.9-5.5-6.8-7.7-2.6-.8-4.3-1.1-5.6-.6.8-1.1,2.1-2.4,4.1-4.6a48.8,48.8,0,0,1,11.6-8.5Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9421" data-name="XMLID 9421">
          <path
            id="XMLID_9425"
            data-name="XMLID 9425"
            class="cls-4"
            d="M149.9,291.9s-4.6-1.1-5,2a92.9,92.9,0,0,1-2.2,10.2c-1.1,3.7,3.2,5.3,3.2,5.3a36.7,36.7,0,0,1-1.9,10.9s7.2,8,16.6,4.1l-.5-2.2s-1.7-9.6-.6-13.7,3.7-5.9,2.2-10.1-7.7-5.8-7.7-5.8Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_9422"
            data-name="XMLID 9422"
            class="cls-4"
            d="M155.1,325.9a15,15,0,0,0,5.5-1.1l.4-.2-.4-2.4s-1.8-9.6-.7-13.7c.4-1.3.8-2.5,1.3-3.7s1.8-3.7.9-6.6-7.6-6.1-7.9-6.1l-4.1-.6c-.2,0-2.8-.7-4.6.4a2.3,2.3,0,0,0-1.1,2,68.5,68.5,0,0,1-2.2,10.2c-.8,3.1,1.6,5,3.3,5.7a29.2,29.2,0,0,1-2,10.5l-.2.2.2.2A16.5,16.5,0,0,0,155.1,325.9Zm4.8-1.9c-8.1,3.2-14.4-2.6-15.5-4a31.4,31.4,0,0,0,2-10.9v-.4l-.2-.2c-.3,0-4-1.5-2.9-4.6a72.6,72.6,0,0,0,2.2-10.3c0-.6.4-.8.7-1.3s3.7-.2,3.7-.2l4.1.7s5.9,1.7,7.2,5.4.2,4-.6,5.9-1.1,2.6-1.6,3.9c-.8,4.2.7,13.8.7,14Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9416" data-name="XMLID 9416">
          <path
            id="XMLID_9420"
            data-name="XMLID 9420"
            class="cls-3"
            d="M148.3,292.3s-1-.8-1,.7-.3,3.7-.3,7,4.2,5,7-.7,5-3.9,5-3.9l-1.7-3.5-4.8-2.6Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_9417"
            data-name="XMLID 9417"
            class="cls-4"
            d="M149.9,303.7c1.7,0,3.5-1.3,4.8-3.9s2.8-3.8,3.5-4,.8,0,.8.2l1.8,1.4-2.9-5.5-5.2-2.8-4.1,3a.8.8,0,0,0-.9,0c-.7.2-.7,1.1-.7,1.3v7.2a3.2,3.2,0,0,0,2.4,3.3C149.4,303.5,149.7,303.7,149.9,303.7Zm8.5-8.7h-.5c-1.3.2-2.8,1.7-4.1,4.3s-2.8,3.7-4.4,3.3a2.3,2.3,0,0,1-1.7-2.4v-7.6a.2.2,0,0,1,.2.2h0l.2.2.2-.2,4-2.9,4.6,2.4Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9414" data-name="XMLID 9414">
          <path
            id="XMLID_9415"
            data-name="XMLID 9415"
            class="cls-5"
            d="M152.7,312.2a6.8,6.8,0,0,0,3.9-1.3l-.6-.7a6,6,0,0,1-7.2,0l-.7.7C148.6,310.7,150.3,312.2,152.7,312.2Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9412" data-name="XMLID 9412">
          <path
            id="XMLID_9413"
            data-name="XMLID 9413"
            class="cls-4"
            d="M140.7,336.6c.5-.2,11.4-3.5,13.5-8.5l-.8-.4c-2,4.6-12.9,7.8-13.1,7.8Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9410" data-name="XMLID 9410">
          <path
            id="XMLID_9411"
            data-name="XMLID 9411"
            class="cls-4"
            d="M155.3,327.2a2.9,2.9,0,0,0-.6-3.2l-.7.6.2-.4-.4.4a1.9,1.9,0,0,1,.4,2.2Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9408" data-name="XMLID 9408">
          <path
            id="XMLID_9409"
            data-name="XMLID 9409"
            class="cls-4"
            d="M150.5,300.8h.7c1.9-.6,4.1-5,4.6-6.1l-.9-.2c-.4,1.3-2.4,5-3.9,5.7h-.5c-1.1-.7-.8-3.7-.6-5.5l-.9-.2c0,.5-.9,5.5,1.1,6.6C149.9,300.8,150.1,300.8,150.5,300.8Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9389" data-name="XMLID 9389">
          <g id="XMLID_9403" data-name="XMLID 9403">
            <path
              id="XMLID_9407"
              data-name="XMLID 9407"
              class="cls-3"
              d="M147.5,283.4s-2.6,8.7,1.5,11.3h.2c.7,0,3.5,0,6.1-3.5l.2-.2c.7-.2,2.4-.6,2.4-2.4s-.6-1.5-1-1.5-.5-.4-.5-.7l1.3-3V283l-2.8-3.1-.4-.2-5.9,1.3c-.3,0-.3.2-.5.4Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_9404"
              data-name="XMLID 9404"
              class="cls-4"
              d="M149.4,295.4a7.5,7.5,0,0,0,6.1-3.7c.7-.2,2.7-.9,2.9-2.9a2,2,0,0,0-1.5-2.1l1.3-3.1a.9.9,0,0,0-.3-1.1l-2.8-3a.8.8,0,0,0-.9-.3l-5.9,1.4c-.3-.1-.5.1-.6.4v.2l-.9,2.4c-.2.4-2.6,9.2,1.8,11.8.2,0,.2.2.4.2Zm5.1-15.5,2.8,3.3-1.3,3a.7.7,0,0,0,0,.9c.2.2.4.4.6.4a.8.8,0,0,1,.7,1.1,2.8,2.8,0,0,1-2.2,2,.4.4,0,0,0-.4.4c-2.4,3.5-5,3.5-5.7,3.3-3.7-2.4-1.5-10.5-1.3-10.7l.9-2.4Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9398" data-name="XMLID 9398">
            <path
              id="XMLID_9402"
              data-name="XMLID 9402"
              class="cls-15"
              d="M158.9,288.2V288l.2-.2v-.2h0a.9.9,0,0,1,.3-.6,4.5,4.5,0,0,0,.7-3.9c-.4-1.5-1.5-3.2-4.1-4.6h0a5.4,5.4,0,0,0-2.8-.8h0a7.9,7.9,0,0,0-8.3,7.4,5.6,5.6,0,0,0,0,1.3h0a6.6,6.6,0,0,0,.6,2.7h.1c0,.1,0-.1.1-.2s0-.1.1-.2l.3-.5a6.9,6.9,0,0,1,4.4-3.6h.3l.2.3.2.5,1.9-1.3h.8a3.3,3.3,0,0,1,1.4,1,1.7,1.7,0,0,1,.5,1.2,3.1,3.1,0,0,1-.3,1.3l.8.5a2,2,0,0,1,.4.8,1.7,1.7,0,0,1-.3,1,3.3,3.3,0,0,1-1.1,1.5l-.4.3h-.3l-.4.6a5.2,5.2,0,0,0,2.7-.7A3.8,3.8,0,0,0,158.9,288.2Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_2-2"
              data-name="Vector 2-2"
              class="cls-16"
              d="M155.1,282.6l-1.3,2.2a.5.5,0,0,0,.2.8.7.7,0,0,0,1-.2h0l1.1-2.3c.1-.4-.1-.8-.5-.8A.5.5,0,0,0,155.1,282.6Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9396" data-name="XMLID 9396">
            <path
              id="XMLID_9397"
              data-name="XMLID 9397"
              class="cls-4"
              d="M154.7,289.9a1.5,1.5,0,0,0,1.1-.8l-.7-.7a.7.7,0,0,1-.6.4Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9394" data-name="XMLID 9394">
            <path
              id="XMLID_9395"
              data-name="XMLID 9395"
              class="cls-4"
              d="M145.7,289c0-.2,1.1-9.3,7.7-8.9v-.9c-7.7-.4-8.3,8.1-8.5,8.1Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="XMLID_9392" data-name="XMLID 9392">
            <path
              id="XMLID_9393"
              data-name="XMLID 9393"
              class="cls-4"
              d="M159.4,287.8c.5-4.6-1.8-6.2-1.8-6.4l-.5.7s1.9,1.6,1.4,5.7Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
        <g id="XMLID_9384" data-name="XMLID 9384">
          <path
            id="XMLID_9388"
            data-name="XMLID 9388"
            class="cls-3"
            d="M159.9,298.4c1.5-.8,3.1,2.4,3.9,8.8s0,7,.3,13.5v11.1a5.7,5.7,0,0,0,1,3.1l2.4,2.8c.7.9.7,2-.4,2.4a3.1,3.1,0,0,1-3.3-.9l-2.4-2.6-.4.5a2.2,2.2,0,0,0,.7,1.7c0,1.5-1.1.7-2.2-1.3a2.8,2.8,0,0,1,0-1.8l.4-1a8,8,0,0,0,.7-4.6c-.3-2.9-.5-7.7-.9-12C159.3,311.5,156.6,300.2,159.9,298.4Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_9385"
            data-name="XMLID 9385"
            class="cls-4"
            d="M166.2,340.8c.5,0,.9,0,1.1-.3s1.1-.6,1.1-1a2.4,2.4,0,0,0-.4-2l-2.4-2.8a4.9,4.9,0,0,1-1.1-2.9V320.9a32.5,32.5,0,0,1,.2-5.4,36.6,36.6,0,0,0-.2-8.1c-.7-5-2-8.5-3.3-9.2a1.5,1.5,0,0,0-1.3,0c-2.8,1.6-1.7,8.5-.9,15.3.3,1.7.5,3.5.7,5,.4,4.2.6,8.7.9,12a16.2,16.2,0,0,1-.7,4.4l-.4,1.1a3.8,3.8,0,0,0,0,2.1c.4.9,1.5,2.4,2.4,2.2s.6-.4.6-1.3v-.4a1.5,1.5,0,0,1-.4-1.1l2,2.2A2.6,2.6,0,0,0,166.2,340.8Zm-5.9-41.9h0c1.1.4,2.4,3.3,3.1,8.5a33.9,33.9,0,0,1,.2,7.8c0,1.6-.2,3.1-.2,5.7V332a5.6,5.6,0,0,0,1.3,3.5l2.4,2.9c.2.4.4.8.2,1.1a.4.4,0,0,1-.4.4,2.2,2.2,0,0,1-2.6-.7l-2.6-2.8-1.1.9v.2a3.6,3.6,0,0,0,.6,2l-1.3-1.6a2,2,0,0,1,0-1.5l.4-1.1a8.8,8.8,0,0,0,.7-4.8c-.2-3-.4-7.6-.9-12-.2-1.5-.4-3.3-.6-5-.9-5.9-1.8-13.1.4-14.4Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9374" data-name="XMLID 9374">
          <path
            id="XMLID_9375"
            data-name="XMLID 9375"
            class="cls-5"
            d="M146.4,308.7l1.4.6-.3.8-1.4-.6Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9372" data-name="XMLID 9372">
          <path
            id="XMLID_9373"
            data-name="XMLID 9373"
            class="cls-5"
            d="M154.2,309.8a4,4,0,0,0,3.1-2.8l-.9-.3a3.2,3.2,0,0,1-2.4,2.2Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9370" data-name="XMLID 9370">
          <path
            id="XMLID_9371"
            data-name="XMLID 9371"
            class="cls-5"
            d="M155.5,324.4a20.9,20.9,0,0,0,0-5h-.8a38.4,38.4,0,0,1,0,4.8Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9368" data-name="XMLID 9368">
          <path
            id="XMLID_9369"
            data-name="XMLID 9369"
            class="cls-5"
            d="M155.4,316.7l.2,1.8h-.9v-1.8Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9352" data-name="XMLID 9352">
          <path
            id="XMLID_9356"
            data-name="XMLID 9356"
            class="cls-5"
            d="M144,304.8c0,1.1.6,2.2,1.5,2.2s1.5-.9,1.5-2.2-.6-2.2-1.5-2.2S144,303.7,144,304.8Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_9353"
            data-name="XMLID 9353"
            class="cls-4"
            d="M145.5,307.4c1.1,0,2-1.1,2-2.6s-.9-2.6-2-2.6-1.9,1-1.9,2.6S144.4,307.4,145.5,307.4Zm0-4.2c.4,0,.9.7.9,1.6s-.5,1.5-.9,1.5-.9-.7-.9-1.5S144.9,303.2,145.5,303.2Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9347" data-name="XMLID 9347">
          <path
            id="XMLID_9351"
            data-name="XMLID 9351"
            class="cls-3"
            d="M143.5,302.8c0,.9.5,1.8,1.4,1.8s1.3-.9,1.3-1.8-.5-1.7-1.3-1.7S143.5,301.7,143.5,302.8Z"
            transform="translate(3.3)"
          />
          <path
            id="XMLID_9348"
            data-name="XMLID 9348"
            class="cls-4"
            d="M144.6,305a2,2,0,0,0,1.8-2.2h0c0-1.3-.7-2.2-1.8-2.2a2,2,0,0,0-1.7,2.2C143.1,303.9,143.8,305,144.6,305Zm0-3.5c.5,0,.7.4.7,1.3s-.4,1.3-.7,1.3-.6-.4-.6-1.3S144.4,301.5,144.6,301.5Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9324" data-name="XMLID 9324">
          <g id="XMLID_9330" data-name="XMLID 9330">
            <g id="XMLID_9338" data-name="XMLID 9338">
              <path
                id="XMLID_9342"
                data-name="XMLID 9342"
                class="cls-3"
                d="M128.3,325.1l17.2,10h.2l11.8-7v-.2l-17.2-10.3h-.2l-11.8,7.5C128.1,324.8,128.1,325.1,128.3,325.1Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_9339"
                data-name="XMLID 9339"
                class="cls-4"
                d="M145.5,335.5h.2l11.8-7c.2,0,.2-.2.2-.4a.5.5,0,0,0-.2-.4l-17.2-10.1a.5.5,0,0,0-.7,0l-12,7.2c-.2,0-.2.3-.2.5a.5.5,0,0,0,.2.4l17.3,10Zm11.1-7.6-11.1,6.5-16.6-9.6,11.4-6.7Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_9333" data-name="XMLID 9333">
              <path
                id="XMLID_9337"
                data-name="XMLID 9337"
                class="cls-5"
                d="M145.5,334.9l-5.9-13.3L122,311.1l6.3,14Z"
                transform="translate(3.3)"
              />
              <path
                id="XMLID_9334"
                data-name="XMLID 9334"
                class="cls-4"
                d="M145.5,335.5l.2-.2a.7.7,0,0,0,.3-.6l-5.9-13.6h-.3l-18.1-10.7-.2.3a.7.7,0,0,0-.2.6l6.3,14h.2Zm-6.3-13.7,5.2,12-16.1-9.4-5.7-12.6Z"
                transform="translate(3.3)"
              />
            </g>
            <g id="XMLID_9331" data-name="XMLID 9331">
              <path
                id="XMLID_9332"
                data-name="XMLID 9332"
                class="cls-4"
                d="M146.8,332l6.1-3.7c.2-.2.2-.2.2-.6s-.2-.5-.2-.7l-3.9-2.4-.4.9,3.5,2.2-5.7,3.5Z"
                transform="translate(3.3)"
              />
            </g>
          </g>
          <g id="XMLID_9325" data-name="XMLID 9325">
            <path
              id="XMLID_9329"
              data-name="XMLID 9329"
              class="cls-3"
              d="M132.6,324c.7.8,1.8,1.5,2.2,1.1s.2-1.3-.6-2.4-1.8-1.6-2.2-1.1S132,322.9,132.6,324Z"
              transform="translate(3.3)"
            />
            <path
              id="XMLID_9326"
              data-name="XMLID 9326"
              class="cls-4"
              d="M134.4,325.5a.7.7,0,0,0,.6-.2c.3-.2.5-.7.3-1.5l-.9-1.6c-.9-1.1-2-1.7-2.8-1.1s-.3,2,.4,3.1A3.8,3.8,0,0,0,134.4,325.5Zm-2-3.5a1.6,1.6,0,0,1,1.3,1.1,2.8,2.8,0,0,1,.7,1.7,2.3,2.3,0,0,1-1.5-1C132.4,322.9,132.2,322,132.4,322Z"
              transform="translate(3.3)"
            />
          </g>
        </g>
        <g id="XMLID_9322" data-name="XMLID 9322">
          <path
            id="XMLID_9323"
            data-name="XMLID 9323"
            class="cls-4"
            d="M149.9,291h.4l-.2-.6h-.4l.6-1.8-.6-.2-1.1,2.4.2.2C148.8,290.8,149.2,291,149.9,291Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9320" data-name="XMLID 9320">
          <path
            id="XMLID_9321"
            data-name="XMLID 9321"
            class="cls-4"
            d="M149.7,293a1.1,1.1,0,0,0,.8-.2l-.4-.7h-.9l-.2.7Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9318" data-name="XMLID 9318">
          <path
            id="XMLID_9319"
            data-name="XMLID 9319"
            class="cls-4"
            d="M152.9,288.6l.2-.6a3.1,3.1,0,0,0-1.9-.2l.2.6Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9316_2" data-name="XMLID 9316 2">
          <path
            id="XMLID_9317"
            data-name="XMLID 9317"
            class="cls-4"
            d="M148.3,288l.5-.7a2.8,2.8,0,0,0-1.3-.4l-.2.6Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9314" data-name="XMLID 9314">
          <path
            id="XMLID_9315_2"
            data-name="XMLID 9315 2"
            class="cls-4"
            d="M151,288.6c0,.5.2.9.4.9a.7.7,0,0,0,.7-.7h0c0-.4-.3-.8-.5-.8S151,288,151,288.6Z"
            transform="translate(3.3)"
          />
        </g>
        <g id="XMLID_9312" data-name="XMLID 9312">
          <path
            id="XMLID_9313"
            data-name="XMLID 9313"
            class="cls-4"
            d="M147.9,288c0,.4,0,.8.4.8s.5-.2.7-.6,0-.9-.4-.9A.6.6,0,0,0,147.9,288Z"
            transform="translate(3.3)"
          />
        </g>
      </g>
    </g>
    <g id="codeelements">
      <g class="melements" id="Code_1" data-name="Code 1">
        <g id="Group_67" data-name="Group 67">
          <path
            id="Vector_59"
            data-name="Vector 59"
            class="cls-3"
            d="M304.7,101v1.5l6.3,3.7v-1.6Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_60"
            data-name="Vector 60"
            class="cls-3"
            d="M304.7,103.8v1.4l6.3,3.6v-1.4Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_61"
            data-name="Vector 61"
            class="cls-3"
            d="M304.7,106.4V108l6.3,3.6v-1.5Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_62"
            data-name="Vector 62"
            class="cls-3"
            d="M352.5,138.1v-1.4l-39.1-22.5v1.5Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_63"
            data-name="Vector 63"
            class="cls-3"
            d="M304.7,109.2v1.6l6.3,3.5v-1.4Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_64"
            data-name="Vector 64"
            class="cls-3"
            d="M304.7,111.9v1.6l6.3,3.6v-1.5Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_65"
            data-name="Vector 65"
            class="cls-3"
            d="M352.5,140.9v-1.5L313.4,117v1.5Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_66"
            data-name="Vector 66"
            class="cls-3"
            d="M304.7,120.2v1.5l6.3,3.7v-1.6Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_67"
            data-name="Vector 67"
            class="cls-3"
            d="M304.7,123v1.4L311,128v-1.4Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_68"
            data-name="Vector 68"
            class="cls-3"
            d="M304.7,133.9v1.6L311,139v-1.4Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_69"
            data-name="Vector 69"
            class="cls-3"
            d="M304.7,136.6v1.5l6.3,3.7v-1.6Z"
            transform="translate(3.3)"
          />
          <g id="Group_68" data-name="Group 68">
            <path
              id="Vector_70"
              data-name="Vector 70"
              class="cls-3"
              d="M338,155.8l-24.6-14.2v1.6L338,157.3Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_71"
              data-name="Vector 71"
              class="cls-3"
              d="M339.3,156.5V158l13.2,7.6v-1.5Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="Group_69" data-name="Group 69">
            <path
              id="Vector_72"
              data-name="Vector 72"
              class="cls-3"
              d="M325.8,146l-12.4-7.2v1.6l12.4,7.1Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_73"
              data-name="Vector 73"
              class="cls-3"
              d="M327,146.8v1.4l25.5,14.6v-1.4Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_74"
            data-name="Vector 74"
            class="cls-3"
            d="M349.1,151.2v1.5l3.4,2v-1.6Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_75"
            data-name="Vector 75"
            class="cls-3"
            d="M331,138l-17.6-10.1v1.5L331,139.5Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_76"
            data-name="Vector 76"
            class="cls-3"
            d="M323.8,111.9,313.4,106v1.6l10.4,5.9Z"
            transform="translate(3.3)"
          />
          <g id="Group_70" data-name="Group 70">
            <path
              id="Vector_77"
              data-name="Vector 77"
              class="cls-3"
              d="M340.7,121.7l-15.6-9v1.5l15.6,9.1Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_78"
            data-name="Vector 78"
            class="cls-3"
            d="M331.5,119.2l-10.9-6.3v1.4l10.9,6.4Z"
            transform="translate(3.3)"
          />
          <g id="Group_71" data-name="Group 71">
            <path
              id="Vector_79"
              data-name="Vector 79"
              class="cls-3"
              d="M343.2,125.8l-10.3-5.9v1.5l10.3,5.9Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_80"
              data-name="Vector 80"
              class="cls-3"
              d="M344.5,126.6V128l8,4.7v-1.6Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_81"
            data-name="Vector 81"
            class="cls-3"
            d="M315.5,112.6v1.6l8.3,4.7v-1.5Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_82"
            data-name="Vector 82"
            class="cls-3"
            d="M349.2,132.1l-24.1-13.9v1.4l24.1,13.9Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_83"
            data-name="Vector 83"
            class="cls-3"
            d="M335.3,132.4l-15.7-9.1v1.5l15.7,9Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_84"
            data-name="Vector 84"
            class="cls-3"
            d="M349.2,140.2l-12.5-7.1v1.5l12.5,7.2Z"
            transform="translate(3.3)"
          />
          <g id="Group_72" data-name="Group 72">
            <path
              id="Vector_85"
              data-name="Vector 85"
              class="cls-3"
              d="M347.8,147.7l-15.6-8.9v1.4l15.6,9Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_86"
            data-name="Vector 86"
            class="cls-3"
            d="M339.3,145.6v1.5l8.5,4.9v-1.5Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_87"
            data-name="Vector 87"
            class="cls-3"
            d="M316.5,132.4l-3.1-1.7v1.5l3.1,1.7Z"
            transform="translate(3.3)"
          />
          <g id="Group_73" data-name="Group 73">
            <path
              id="Vector_88"
              data-name="Vector 88"
              class="cls-3"
              d="M322.1,135.7v1.4l15.9,9.3v-1.5Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_89"
              data-name="Vector 89"
              class="cls-3"
              d="M320.8,134.9l-3-1.7v1.4l3,1.8Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_90"
            data-name="Vector 90"
            class="cls-3"
            d="M335,145.8l-17.2-9.9v1.5l17.2,10Z"
            transform="translate(3.3)"
          />
        </g>
      </g>
      <g class="melements" id="Code_2" data-name="Code 2">
        <g id="Group_75" data-name="Group 75">
          <path
            id="Vector_91"
            data-name="Vector 91"
            class="cls-3"
            d="M197.8,60.4V62l6.4,3.6V64.1Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_92"
            data-name="Vector 92"
            class="cls-3"
            d="M197.8,63.2v1.4l6.4,3.7V66.9Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_93"
            data-name="Vector 93"
            class="cls-3"
            d="M197.8,65.9v1.6l6.4,3.6V69.6Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_94"
            data-name="Vector 94"
            class="cls-3"
            d="M245.6,97.6V96.2l-39-22.6v1.6Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_95"
            data-name="Vector 95"
            class="cls-3"
            d="M197.8,68.7v1.4l6.4,3.7V72.4Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_96"
            data-name="Vector 96"
            class="cls-3"
            d="M197.8,71.4v1.5l6.4,3.7V75Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_97"
            data-name="Vector 97"
            class="cls-3"
            d="M245.6,100.4V98.9l-39-22.5V78Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_98"
            data-name="Vector 98"
            class="cls-3"
            d="M197.8,79.7v1.5l6.4,3.6V83.3Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_99"
            data-name="Vector 99"
            class="cls-3"
            d="M197.8,82.5v1.4l6.4,3.6V86Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_100"
            data-name="Vector 100"
            class="cls-3"
            d="M197.8,93.4v1.4l6.4,3.6V97Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_101"
            data-name="Vector 101"
            class="cls-3"
            d="M197.8,96.1v1.5l6.4,3.6V99.7Z"
            transform="translate(3.3)"
          />
          <g id="Group_76" data-name="Group 76">
            <path
              id="Vector_102"
              data-name="Vector 102"
              class="cls-3"
              d="M231.1,115.3l-24.5-14.2v1.5l24.5,14.2Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_103"
              data-name="Vector 103"
              class="cls-3"
              d="M232.4,116v1.5l13.2,7.6v-1.6Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="Group_77" data-name="Group 77">
            <path
              id="Vector_104"
              data-name="Vector 104"
              class="cls-3"
              d="M218.9,105.5l-12.3-7.2v1.5l12.3,7.2Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_105"
              data-name="Vector 105"
              class="cls-3"
              d="M220.2,106.2v1.5l25.4,14.6v-1.4Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_106"
            data-name="Vector 106"
            class="cls-3"
            d="M242.2,110.6v1.6l3.4,1.9v-1.5Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_107"
            data-name="Vector 107"
            class="cls-3"
            d="M224.1,97.5,206.6,87.4v1.5L224.1,99Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_108"
            data-name="Vector 108"
            class="cls-3"
            d="M216.9,71.4l-10.3-5.9v1.4l10.3,6Z"
            transform="translate(3.3)"
          />
          <g id="Group_78" data-name="Group 78">
            <path
              id="Vector_109"
              data-name="Vector 109"
              class="cls-3"
              d="M233.8,81.2l-15.6-9v1.4l15.6,9.1Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_110"
            data-name="Vector 110"
            class="cls-3"
            d="M224.7,78.7l-11-6.3v1.4l11,6.4Z"
            transform="translate(3.3)"
          />
          <g id="Group_79" data-name="Group 79">
            <path
              id="Vector_111"
              data-name="Vector 111"
              class="cls-3"
              d="M236.3,85.3l-10.2-5.9v1.5l10.2,5.9Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_112"
              data-name="Vector 112"
              class="cls-3"
              d="M237.6,86.1v1.4l8,4.6V90.6Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_113"
            data-name="Vector 113"
            class="cls-3"
            d="M208.7,72.1v1.5l8.2,4.8V76.8Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_114"
            data-name="Vector 114"
            class="cls-3"
            d="M242.2,91.6l-24-13.9v1.4l24,13.9Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_115"
            data-name="Vector 115"
            class="cls-3"
            d="M228.5,91.9l-15.8-9.2v1.6l15.8,9Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_116"
            data-name="Vector 116"
            class="cls-3"
            d="M242.2,99.7l-12.5-7.1v1.5l12.5,7.1Z"
            transform="translate(3.3)"
          />
          <g id="Group_80" data-name="Group 80">
            <path
              id="Vector_117"
              data-name="Vector 117"
              class="cls-3"
              d="M241,107.1l-15.6-8.9v1.5l15.6,9Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_118"
            data-name="Vector 118"
            class="cls-3"
            d="M232.4,105v1.6l8.6,4.9v-1.6Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_119"
            data-name="Vector 119"
            class="cls-3"
            d="M209.6,91.9l-3-1.7v1.4l3,1.8Z"
            transform="translate(3.3)"
          />
          <g id="Group_81" data-name="Group 81">
            <path
              id="Vector_120"
              data-name="Vector 120"
              class="cls-3"
              d="M215.3,95.2v1.4l15.8,9.1v-1.4Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_121"
              data-name="Vector 121"
              class="cls-3"
              d="M214,94.4l-3.1-1.7v1.4l3.1,1.8Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_122"
            data-name="Vector 122"
            class="cls-3"
            d="M228.2,105.3l-17.3-9.9v1.5l17.3,10Z"
            transform="translate(3.3)"
          />
        </g>
      </g>
      <g class="melements" id="Code_3" data-name="Code 3">
        <path
          id="Vector_123"
          data-name="Vector 123"
          class="cls-3"
          d="M250.5,15.2,224.2,0V1.3l26.3,15.1Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_124"
          data-name="Vector 124"
          class="cls-3"
          d="M224.2,4l40.3,23.2V25.8L224.2,2.7Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_125"
          data-name="Vector 125"
          class="cls-3"
          d="M252.2,16.2v1.2l12.3,7.2V23.2Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_126"
          data-name="Vector 126"
          class="cls-3"
          d="M250.5,20.2,224.2,5.1V6.5l26.3,15.1Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_127"
          data-name="Vector 127"
          class="cls-3"
          d="M224.2,9l40.3,23.3V30.9L224.2,7.8Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_128"
          data-name="Vector 128"
          class="cls-3"
          d="M252.2,22.6l12.3,7V28.4l-12.3-7.2Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_129"
          data-name="Vector 129"
          class="cls-3"
          d="M250.5,28.6,224.2,13.5v1.4L250.5,30Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_130"
          data-name="Vector 130"
          class="cls-3"
          d="M224.2,17.4l40.3,23.3V39.3L224.2,16.2Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_131"
          data-name="Vector 131"
          class="cls-3"
          d="M252.2,31l12.3,7V36.8l-12.3-7.2Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_132"
          data-name="Vector 132"
          class="cls-3"
          d="M250.5,33.8,224.2,18.7V20l26.3,15.1Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_133"
          data-name="Vector 133"
          class="cls-3"
          d="M224.2,22.6l40.3,23.2V44.5L224.2,21.2Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_134"
          data-name="Vector 134"
          class="cls-3"
          d="M252.2,36.1l12.3,7.1V41.8l-12.3-7Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_135"
          data-name="Vector 135"
          class="cls-3"
          d="M250.5,42.2,224.2,27.1v1.3l26.3,15.1Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_136"
          data-name="Vector 136"
          class="cls-3"
          d="M224.2,31l40.3,23.2V52.9L224.2,29.6Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_137"
          data-name="Vector 137"
          class="cls-3"
          d="M252.2,44.5l12.3,7.1V50.2l-12.3-7Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_138"
          data-name="Vector 138"
          class="cls-3"
          d="M250.5,47.3,224.2,32.2v1.4l26.3,15Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_139"
          data-name="Vector 139"
          class="cls-3"
          d="M224.2,36.1l40.3,23.3V58L224.2,34.8Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_140"
          data-name="Vector 140"
          class="cls-3"
          d="M252.2,49.7l12.3,7V55.3l-12.3-7Z"
          transform="translate(3.3)"
        />
      </g>
      <path
        id="Screen1"
        class="melements cls-17"
        d="M179.8,34.3,160.3,23a1.3,1.3,0,0,0-1.9.5,1.1,1.1,0,0,0-.2.8V47.7a3,3,0,0,0,1.5,2.8l19.5,11.4a1.5,1.5,0,0,0,2.1-.7,1.4,1.4,0,0,0,.2-.6V37.3A3.4,3.4,0,0,0,179.8,34.3Z"
        transform="translate(3.3)"
      />
      <g class="melements" id="Box_CSS" data-name="Box CSS">
        <path
          class="cls-4"
          d="M139.4,42.2l25.8,15a3.9,3.9,0,0,1,2,2l5.3-3.1a3.7,3.7,0,0,0-1.6-1.7h0L145.2,39.5a2,2,0,0,0-2.1.1L138.9,42Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-5"
          d="M138.7,78.5l26,15a1.2,1.2,0,0,0,1.4,0h.2a2.3,2.3,0,0,0,.6-1.2v-31a5,5,0,0,0-.2-1.2v-.4a3.3,3.3,0,0,0-1.7-1.8h-.2L139,42.9a1.1,1.1,0,0,0-.8-.2.8.8,0,0,0-.7.2,1.2,1.2,0,0,0-.7,1.3v31A3.6,3.6,0,0,0,138.7,78.5Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-4"
          d="M167.5,60a5.9,5.9,0,0,1,.2,1.3V92.2a.6.6,0,0,1-.1.4l4.5-2.7a1.6,1.6,0,0,0,.8-1.4V57.7a2.2,2.2,0,0,0-.1-.8Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-3"
          d="M173.7,57.7a4.5,4.5,0,0,0-.3-1.6v-.4h-.1a5.2,5.2,0,0,0-1.9-2L145.5,38.8a2.8,2.8,0,0,0-2.9.2l-6,3.4h.1a2.8,2.8,0,0,0-.7,1.7V75.2a4.7,4.7,0,0,0,2.3,4l26,15a2.7,2.7,0,0,0,1.2.3h.6l.5-.3h.2l5.6-3.3a3.4,3.4,0,0,0,1.3-2.3ZM136.8,44.2a1.2,1.2,0,0,1,.7-1.3.8.8,0,0,1,.7-.2,1.1,1.1,0,0,1,.8.2l25.8,15h.1a3.3,3.3,0,0,1,1.7,1.8v.4a5,5,0,0,1,.2,1.2V92.2a2.3,2.3,0,0,1-.6,1.2H166a1.2,1.2,0,0,1-1.4,0l-26-15a3.8,3.8,0,0,1-1.8-3.2Zm8.4-4.7,25.7,14.9h0a3.7,3.7,0,0,1,1.6,1.7l-5.3,3.1a3.9,3.9,0,0,0-2-2l-25.8-15-.5-.2,4.2-2.4A2,2,0,0,1,145.2,39.5Zm27.7,49a1.6,1.6,0,0,1-.8,1.4l-4.5,2.7a.6.6,0,0,0,.1-.4V61.3a5.9,5.9,0,0,0-.2-1.3l5.3-3.1a2.2,2.2,0,0,1,.1.8Z"
          transform="translate(3.3)"
        />
      </g>
      <g class="melements" id="CSS">
        <path
          class="cls-4"
          d="M141.6,66.7a6.9,6.9,0,0,0,2.4,2.1,6.6,6.6,0,0,0,2,.6,3.3,3.3,0,0,0,1.7-.4l-1.3-2.4a2,2,0,0,1-1.1.2,2.7,2.7,0,0,1-1.2-.3,4.3,4.3,0,0,1-1.2-1.1,3.8,3.8,0,0,1-.9-1.5,4.7,4.7,0,0,1-.3-1.7,2.8,2.8,0,0,1,.3-1.3,1.1,1.1,0,0,1,.9-.5,1.3,1.3,0,0,1,1.2.3,2.9,2.9,0,0,1,1.2,1,9.1,9.1,0,0,1,1.1,1.6l1.3-1.1a8.9,8.9,0,0,0-1.6-2.2,10,10,0,0,0-2-1.6,5.5,5.5,0,0,0-2.5-.7h0a2,2,0,0,0-1.7.9,3.9,3.9,0,0,0-.7,2.3,7.8,7.8,0,0,0,.7,3A10,10,0,0,0,141.6,66.7Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-4"
          d="M153.1,71.4a.8.8,0,0,1-.8-.2l-1.7-1.4a15.6,15.6,0,0,1-1.6-2l-.9,1.5a10.6,10.6,0,0,0,1.9,2.3,12.4,12.4,0,0,0,2.3,1.7,5.6,5.6,0,0,0,1.8.7,1.5,1.5,0,0,0,1.3-.3,1.7,1.7,0,0,0,.5-1.5,3.9,3.9,0,0,0-.4-1.8,5.7,5.7,0,0,0-1.1-1.6l-1.5-1.4-1-.9a1.8,1.8,0,0,1-.5-.7.8.8,0,0,1-.2-.7.5.5,0,0,1,.2-.4l.7.3,1.4,1,1.5,1.7.9-1.6a13.7,13.7,0,0,0-1.6-1.8l-2-1.4a6.2,6.2,0,0,0-1.9-.7,1.6,1.6,0,0,0-1.3.4,2.3,2.3,0,0,0-.4,1.4,3.9,3.9,0,0,0,.4,1.8,5.6,5.6,0,0,0,1,1.5,10.7,10.7,0,0,0,1.6,1.4l.9.9a1.3,1.3,0,0,1,.6.7.8.8,0,0,1,.2.7C153.4,71.3,153.3,71.4,153.1,71.4Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-4"
          d="M159.8,69.4l.7.2,1.3,1.1,1.6,1.6.8-1.5h0a12.9,12.9,0,0,0-1.6-1.7,9,9,0,0,0-2-1.4,4.4,4.4,0,0,0-1.9-.7,1.7,1.7,0,0,0-1.2.4,1.9,1.9,0,0,0-.5,1.4,5.8,5.8,0,0,0,.4,1.8l1.1,1.5,1.5,1.4,1,.9.6.6a1.9,1.9,0,0,1,.2.7c0,.3-.1.5-.3.5l-.9-.3a5.1,5.1,0,0,1-1.6-1.3,15.6,15.6,0,0,1-1.6-2l-1,1.5a22,22,0,0,0,2,2.3,18.4,18.4,0,0,0,2.2,1.7,6.2,6.2,0,0,0,1.9.7,2,2,0,0,0,1.3-.4,1.5,1.5,0,0,0,.4-.9v-.9a4,4,0,0,0-.3-1.5,5.8,5.8,0,0,0-1.1-1.5l-1.6-1.5a3.8,3.8,0,0,1-.9-.9l-.6-.6a1.9,1.9,0,0,1-.2-.7C159.5,69.6,159.6,69.4,159.8,69.4Z"
          transform="translate(3.3)"
        />
      </g>
      <path
        id="Screen2"
        class="melements cls-17"
        d="M298.9,74.6,279.4,63.4a1.3,1.3,0,0,0-1.9.5,1.1,1.1,0,0,0-.2.8V88.1a3.5,3.5,0,0,0,1.5,2.8l19.6,11.4a1.5,1.5,0,0,0,2-.6,1.9,1.9,0,0,0,.2-.7V77.7A3.8,3.8,0,0,0,298.9,74.6Z"
        transform="translate(3.3)"
      />
      <g class="melements" id="Box_Code" data-name="Box Code">
        <path
          class="cls-4"
          d="M311.2,134.3l26,15a4.7,4.7,0,0,1,2,2.2l5.3-3.2a3.5,3.5,0,0,0-1.6-1.8l-25.8-14.7a1.8,1.8,0,0,0-2.1.1l-4,2.3Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-5"
          d="M310.5,170.6l26,15a1.5,1.5,0,0,0,1.6,0,1.6,1.6,0,0,0,.8-1.3V153.6a5,5,0,0,0-.2-1.2l-.2-.5a3.5,3.5,0,0,0-1.7-1.9l-26-15-.7-.2-.8.2a1.7,1.7,0,0,0-.7,1.3v31A3.7,3.7,0,0,0,310.5,170.6Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-4"
          d="M339.4,152.2l.3,1.4v30.7h0v.3l4.5-2.6a1.6,1.6,0,0,0,.8-1.3V149.9a2.2,2.2,0,0,0-.1-.8Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-3"
          d="M345.7,149.5a5.7,5.7,0,0,0-.4-1.4v-.2h0a5.1,5.1,0,0,0-1.9-2.2L317.6,131a2.8,2.8,0,0,0-2.9.1l-4.9,2.9-.8.2a2.3,2.3,0,0,0-1.1,2v31a4.7,4.7,0,0,0,2.3,4l26,15,1.2.3h.9l6.3-3.7a2.4,2.4,0,0,0,1.2-2h0V149.5Zm-28.6-17.7,25.8,14.7a3.5,3.5,0,0,1,1.6,1.8l-5.3,3.2a4.7,4.7,0,0,0-2-2.2l-26-15H311l4-2.3A1.8,1.8,0,0,1,317.1,131.8Zm27.8,18.1v30.9a1.6,1.6,0,0,1-.8,1.3l-4.5,2.6v-.3h0V153.6l-.3-1.4,5.4-3.1a2.2,2.2,0,0,1,.1.8Zm-36.3-13.6a1.7,1.7,0,0,1,.7-1.3l.8-.2.7.2,26,15a3.5,3.5,0,0,1,1.7,1.9l.2.5a5,5,0,0,1,.2,1.2v30.7a1.6,1.6,0,0,1-.8,1.3,1.5,1.5,0,0,1-1.6,0l-26-15a3.7,3.7,0,0,1-1.9-3.3Z"
          transform="translate(3.3)"
        />
      </g>
      <g class="melements" id="CodeText">
        <path
          id="Vector_166"
          data-name="Vector 166"
          class="cls-4"
          d="M311.6,154.7l8,8.7v-2.1l-5.5-5.9,5.5.3v-2.3h-8Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_167"
          data-name="Vector 167"
          class="cls-4"
          d="M320.4,165.8l2.3,1.4,4.5-11.1-2.3-1.4Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_168"
          data-name="Vector 168"
          class="cls-4"
          d="M327.9,158.2v2.2l5.6,6.2-5.6-.5v2.2l8.1.6v-1.4Z"
          transform="translate(3.3)"
        />
      </g>
      <g class="melements" id="Box_Paragraph" data-name="Box Paragraph">
        <path
          class="cls-4"
          d="M340.7,72.7l25.9,14.9a4.7,4.7,0,0,1,2,2.2l5.3-3.1a3.5,3.5,0,0,0-1.7-1.9L346.5,70.1a1.8,1.8,0,0,0-2.1.1l-4.1,2.4Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-5"
          d="M340,109.1l26,15a2,2,0,0,0,1.5,0v-.2h.2a1.1,1.1,0,0,0,.6-1.1V91.9a5,5,0,0,0-.2-1.2v-.6h0a4.9,4.9,0,0,0-1.7-1.8L340.3,73.4l-.7-.2-.8.2a1.7,1.7,0,0,0-.7,1.4v31A4.4,4.4,0,0,0,340,109.1Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-4"
          d="M368.8,90.5a6.8,6.8,0,0,1,.2,1.4V123l4.5-2.6a1.6,1.6,0,0,0,.8-1.3V88.2a2.4,2.4,0,0,0-.2-.8Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-3"
          d="M375,87.8a3.5,3.5,0,0,0-.3-1.4h-.1a4.7,4.7,0,0,0-2-2.2L346.9,69.4a2.8,2.8,0,0,0-2.9.1L338,73h0a2.8,2.8,0,0,0-.7,1.7v31a4.5,4.5,0,0,0,2.3,3.9l26,15.1a2.7,2.7,0,0,0,1.2.3l.7-.2h.1l.4-.2.4-.3,5.5-3.1a2.4,2.4,0,0,0,1.2-2.1h0V88.2C375.1,88.1,375,87.9,375,87.8Zm-36.9-13a1.7,1.7,0,0,1,.7-1.4l.8-.2.7.2,25.9,14.9a4.9,4.9,0,0,1,1.7,1.8h0v.6a5,5,0,0,1,.2,1.2v30.8a1.1,1.1,0,0,1-.6,1.1h-.2v.2a2,2,0,0,1-1.5,0l-26-15a4.4,4.4,0,0,1-1.9-3.3Zm8.4-4.7,25.7,14.7a3.5,3.5,0,0,1,1.7,1.9l-5.3,3.1a4.7,4.7,0,0,0-2-2.2L340.7,72.7h-.4l4.1-2.4A1.8,1.8,0,0,1,346.5,70.1Zm27.8,18.1v30.9a1.6,1.6,0,0,1-.8,1.3L369,123V91.9a6.8,6.8,0,0,0-.2-1.4l5.3-3.1A2.4,2.4,0,0,1,374.3,88.2Z"
          transform="translate(3.3)"
        />
      </g>
      <g class="melements" id="Paragraph">
        <path
          id="Vector_164"
          data-name="Vector 164"
          class="cls-4"
          d="M346.1,86a3.3,3.3,0,0,0-.4,1.7v3.8c0,.7-.3,1.1-.7,1.1a4.4,4.4,0,0,1-1.9-.7v2.5a7,7,0,0,1,1.9,1.5,3.7,3.7,0,0,1,.7,2v3.7a8.5,8.5,0,0,0,.4,2.2,4.6,4.6,0,0,0,1.3,1.8,14.4,14.4,0,0,0,2.5,1.8v-2.3a8.6,8.6,0,0,1-1.4-1.3,2.3,2.3,0,0,1-.4-1.4V98.9h0c0-1.5-.7-2.7-2.4-3.8v-.2c1.6.6,2.3.2,2.4-1.2V90.2c0-.6.2-.9.4-1s.7,0,1.4.4V87.2a8,8,0,0,0-2.5-1.1C346.8,85.7,346.4,85.7,346.1,86Z"
          transform="translate(3.3)"
        />
        <path
          id="Vector_165"
          data-name="Vector 165"
          class="cls-4"
          d="M360.6,101.7a3.7,3.7,0,0,1-.7-2h0V96a4.5,4.5,0,0,0-1-3,12.2,12.2,0,0,0-3.3-2.7v2.4a5.3,5.3,0,0,1,1.4,1.2,3.3,3.3,0,0,1,.4,1.4v3.6a4.9,4.9,0,0,0,2.4,3.9h0c-.7-.3-1.4-.4-1.7-.1a1.8,1.8,0,0,0-.6,1.4h0v3.5c0,.6-.1,1-.4,1a2.5,2.5,0,0,1-1.4-.4v2.4a6.8,6.8,0,0,0,3.4,1.1c.7-.1,1-.9,1-2v-3.5c0-.7.2-1.1.7-1.3a4.4,4.4,0,0,1,1.9.7v-2.5A3.8,3.8,0,0,1,360.6,101.7Z"
          transform="translate(3.3)"
        />
      </g>
      <g class="melements" id="Box_Magnifying" data-name="Box Magnifying">
        <path
          class="cls-4"
          d="M254.9,73.2l26,15a3.5,3.5,0,0,1,1.8,2l5.4-3.1a3.5,3.5,0,0,0-1.7-1.7h0L260.8,70.5a2,2,0,0,0-2.1.1L254.5,73Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-3"
          d="M289.4,88.8a5,5,0,0,0-2.6-4.1L261.2,69.8a2.8,2.8,0,0,0-2.9.1l-5.5,3.2h-.5a2.5,2.5,0,0,0-.8,1.8v31a4.7,4.7,0,0,0,2.3,4l25.8,15,1.2.3,1-.2h0l6.4-3.6a2.4,2.4,0,0,0,1.2-2.1ZM252.3,75.2a1.2,1.2,0,0,1,.7-1.3.8.8,0,0,1,.7-.2,1.1,1.1,0,0,1,.8.2l26,15h0a3.5,3.5,0,0,1,1.6,1.8v.4a5,5,0,0,1,.2,1.2h0v30.8c0,.2,0,.3-.1.4s-.2.5-.5.7l-.2.2h0a1.5,1.5,0,0,1-1.6,0l-25.8-15a3.7,3.7,0,0,1-1.9-3.3Zm8.5-4.7,25.6,14.9h0a3.5,3.5,0,0,1,1.7,1.7l-5.4,3.1a3.5,3.5,0,0,0-1.8-2l-26-15-.4-.2,4.2-2.4A2,2,0,0,1,260.8,70.5Zm27.5,17.3a2.8,2.8,0,0,1,.1.9v30.8a1.3,1.3,0,0,1-.8,1.3l-4.4,2.6V92.3h0a6.8,6.8,0,0,0-.2-1.4Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-5"
          d="M254.2,109.5l25.8,15a1.5,1.5,0,0,0,1.6,0h0l.2-.2c.3-.2.5-.4.5-.7s.1-.2.1-.4V92.3h0a5,5,0,0,0-.2-1.2v-.4a3.5,3.5,0,0,0-1.6-1.8h0l-26-15a1.1,1.1,0,0,0-.8-.2.8.8,0,0,0-.7.2,1.2,1.2,0,0,0-.7,1.3v31A4,4,0,0,0,254.2,109.5Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-4"
          d="M283.2,92.3h0v31.1l4.4-2.6a1.3,1.3,0,0,0,.8-1.3V88.7a2.8,2.8,0,0,0-.1-.9L283,90.9A6.8,6.8,0,0,1,283.2,92.3Z"
          transform="translate(3.3)"
        />
      </g>
      <path
        class="melements cls-4"
        id="Magnifyng"
        d="M275.5,94.5a18.5,18.5,0,0,0-5.8-6c-2.1-1.2-4.1-1.5-5.7-.5s-3.1,6.4-1,11.2l-7.1,4,2.2,3.5,7-4a17.1,17.1,0,0,0,4.6,4.3c2.1,1.1,4.1,1.6,5.8.6C278.7,105.9,278.7,100,275.5,94.5Zm-2.1,9.6a3.8,3.8,0,0,1-3.7-.4,9.4,9.4,0,0,1-3.6-3.8c-2-3.5-2-7.3,0-8.4a3.4,3.4,0,0,1,3.6.4,10.4,10.4,0,0,1,3.7,3.8C275.5,99.2,275.5,103,273.4,104.1Z"
        transform="translate(3.3)"
      />
      <g class="melements" id="Box_JS" data-name="Box JS">
        <path
          class="cls-4"
          d="M198.3,13.2h.4l26,15a4.9,4.9,0,0,1,1.8,2l5.4-3.1a4.6,4.6,0,0,0-1.7-1.7h0L204.6,10.8a1.8,1.8,0,0,0-2.1-.1Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-3"
          d="M233.2,28.9a6.6,6.6,0,0,0-.6-2h-.1a4.1,4.1,0,0,0-1.9-2L205,10.1a2.3,2.3,0,0,0-2.9,0l-5.5,3.1h-.5a2.1,2.1,0,0,0-.8,1.7v31a4.7,4.7,0,0,0,2.3,4l26,15h.2l-.8.5,1.3-.4h.4l.9-.2h0l6.4-3.7a2.4,2.4,0,0,0,1.2-2ZM224,64.6l-26-15a3.6,3.6,0,0,1-1.9-3.3v-31a1.5,1.5,0,0,1,.7-1.3l.7-.2.8.2,26,15a4.9,4.9,0,0,1,1.6,1.9v.4a4.3,4.3,0,0,1,.2,1.1V63.3a1.4,1.4,0,0,1-.3.9l-1.1.6ZM204.6,10.8l25.6,14.7h0a4.6,4.6,0,0,1,1.7,1.7l-5.4,3.1a4.9,4.9,0,0,0-1.8-2l-26-15h-.4l4.2-2.5A1.7,1.7,0,0,1,204.6,10.8Zm27.6,18V59.6a1.6,1.6,0,0,1-.8,1.4L227,63.6V32.4a5.9,5.9,0,0,0-.2-1.3l5.3-3.1a2.2,2.2,0,0,1,.1.8Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-5"
          d="M225.9,64.2a1.4,1.4,0,0,0,.3-.9V32.4a4.3,4.3,0,0,0-.2-1.1v-.4a4.9,4.9,0,0,0-1.6-1.9l-26-15-.8-.2-.7.2a1.5,1.5,0,0,0-.7,1.3v31a3.6,3.6,0,0,0,1.9,3.3l26,15a1.1,1.1,0,0,0,.8.2Z"
          transform="translate(3.3)"
        />
        <path
          class="cls-4"
          d="M226.8,31.1a5.9,5.9,0,0,1,.2,1.3V63.6l4.4-2.6a1.6,1.6,0,0,0,.8-1.4V28.8a2.2,2.2,0,0,0-.1-.8Z"
          transform="translate(3.3)"
        />
      </g>
      <g class="melements" id="JS">
        <g id="Group_107" data-name="Group 107">
          <g id="Group_108" data-name="Group 108">
            <g id="Group_109" data-name="Group 109">
              <g id="Group_110" data-name="Group 110">
                <path
                  id="Vector_162"
                  data-name="Vector 162"
                  d="M209.6,31.1l-7.7-4.3v3.1l4.4,2.4v6.5a1.1,1.1,0,0,1-.3,1.1,1.2,1.2,0,0,1-1-.2,6.9,6.9,0,0,1-1.3-1.1,13.7,13.7,0,0,1-1.3-2l-1.6,1.7a10.5,10.5,0,0,0,4.3,4.8q2.1,1.2,3.3.6c.8-.4,1.2-1.3,1.2-2.9Z"
                  transform="translate(3.3)"
                />
                <path
                  id="Vector_163"
                  data-name="Vector 163"
                  d="M216.7,34.9a6.2,6.2,0,0,0-2.6-.9,2.4,2.4,0,0,0-1.8.5,2.9,2.9,0,0,0-.7,2,5.8,5.8,0,0,0,.6,2.6,8,8,0,0,0,1.5,2.1,13.4,13.4,0,0,0,2.1,2l1.4,1.3a3.6,3.6,0,0,1,.7,1,1.7,1.7,0,0,1,.3,1c0,.4-.1.6-.4.6l-1.2-.3-2.3-2a19.3,19.3,0,0,1-2.2-2.8l-1.3,2.1a14,14,0,0,0,2.7,3.3,18.3,18.3,0,0,0,3.1,2.4,6.2,6.2,0,0,0,2.6.9,2,2,0,0,0,1.8-.4,2.7,2.7,0,0,0,.7-2.1,6.3,6.3,0,0,0-.6-2.7,8,8,0,0,0-1.5-2.1c-.5-.6-1.3-1.3-2.1-2.1L216.1,40l-.7-.9a1.7,1.7,0,0,1-.3-1,.7.7,0,0,1,.3-.6l1,.3a7.4,7.4,0,0,1,1.9,1.6,23.9,23.9,0,0,1,2.2,2.3l1.2-2.3a13.7,13.7,0,0,0-2.3-2.5A13.5,13.5,0,0,0,216.7,34.9Z"
                  transform="translate(3.3)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g class="melements" id="Code_4" data-name="Code 4">
        <g id="Group_114" data-name="Group 114">
          <path
            id="Vector_169"
            data-name="Vector 169"
            class="cls-3"
            d="M282.8,13.4V15l6.3,3.6V17.1Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_170"
            data-name="Vector 170"
            class="cls-3"
            d="M282.8,16.2v1.6l6.3,3.6V19.9Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_171"
            data-name="Vector 171"
            class="cls-3"
            d="M282.8,18.9v1.5l6.3,3.7V22.5Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_172"
            data-name="Vector 172"
            class="cls-3"
            d="M330.5,50.6V49.2l-39-22.4v1.4Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_173"
            data-name="Vector 173"
            class="cls-3"
            d="M282.8,21.7v1.5l6.3,3.7V25.4Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_174"
            data-name="Vector 174"
            class="cls-3"
            d="M282.8,24.5v1.4l6.3,3.7V28.2Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_175"
            data-name="Vector 175"
            class="cls-3"
            d="M330.5,53.4V51.9l-39-22.5V31Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_176"
            data-name="Vector 176"
            class="cls-3"
            d="M282.8,32.6v1.6l6.3,3.6V36.3Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_177"
            data-name="Vector 177"
            class="cls-3"
            d="M282.8,35.4V37l6.3,3.5V39.1Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_178"
            data-name="Vector 178"
            class="cls-3"
            d="M282.8,46.4v1.5l6.3,3.7V50Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_179"
            data-name="Vector 179"
            class="cls-3"
            d="M282.8,49.2v1.4l6.3,3.6V52.8Z"
            transform="translate(3.3)"
          />
          <g id="Group_115" data-name="Group 115">
            <path
              id="Vector_180"
              data-name="Vector 180"
              class="cls-3"
              d="M316.1,68.3,291.5,54.1v1.5l24.6,14.2Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_181"
              data-name="Vector 181"
              class="cls-3"
              d="M317.3,69.1v1.4l13.2,7.6V76.5Z"
              transform="translate(3.3)"
            />
          </g>
          <g id="Group_116" data-name="Group 116">
            <path
              id="Vector_182"
              data-name="Vector 182"
              class="cls-3"
              d="M303.9,58.4l-12.4-7v1.4L303.9,60Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_183"
              data-name="Vector 183"
              class="cls-3"
              d="M305.1,59.3v1.4l25.4,14.6V73.9Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_184"
            data-name="Vector 184"
            class="cls-3"
            d="M327.2,63.6v1.6l3.3,1.9V65.6Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_185"
            data-name="Vector 185"
            class="cls-3"
            d="M309.1,50.4l-17.6-10v1.5L309.1,52Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_186"
            data-name="Vector 186"
            class="cls-3"
            d="M301.9,24.4l-10.4-5.9V20l10.4,5.9Z"
            transform="translate(3.3)"
          />
          <g id="Group_117" data-name="Group 117">
            <path
              id="Vector_187"
              data-name="Vector 187"
              class="cls-3"
              d="M318.7,34.2l-15.5-9v1.6l15.5,8.9Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_188"
            data-name="Vector 188"
            class="cls-3"
            d="M309.6,31.7l-10.9-6.3v1.5l10.9,6.3Z"
            transform="translate(3.3)"
          />
          <g id="Group_118" data-name="Group 118">
            <path
              id="Vector_189"
              data-name="Vector 189"
              class="cls-3"
              d="M321.3,38.4,311,32.5v1.4l10.3,5.9Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_190"
              data-name="Vector 190"
              class="cls-3"
              d="M322.5,39.1v1.5l8,4.5V43.7Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_191"
            data-name="Vector 191"
            class="cls-3"
            d="M293.6,25.2v1.4l8.3,4.8V30Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_192"
            data-name="Vector 192"
            class="cls-3"
            d="M327.3,44.6,303.2,30.7v1.5l24.1,13.9Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_193"
            data-name="Vector 193"
            class="cls-3"
            d="M313.4,44.8l-15.7-9.1v1.6l15.7,9.1Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_194"
            data-name="Vector 194"
            class="cls-3"
            d="M327.3,52.8l-12.5-7.3v1.6l12.5,7.1Z"
            transform="translate(3.3)"
          />
          <g id="Group_119" data-name="Group 119">
            <path
              id="Vector_195"
              data-name="Vector 195"
              class="cls-3"
              d="M325.9,60.3l-15.6-9v1.4l15.6,9Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_196"
            data-name="Vector 196"
            class="cls-3"
            d="M317.3,58v1.6l8.6,4.9V62.9Z"
            transform="translate(3.3)"
          />
          <path
            id="Vector_197"
            data-name="Vector 197"
            class="cls-3"
            d="M294.6,45l-3.1-1.8v1.5l3.1,1.7Z"
            transform="translate(3.3)"
          />
          <g id="Group_120" data-name="Group 120">
            <path
              id="Vector_198"
              data-name="Vector 198"
              class="cls-3"
              d="M300.3,48.2v1.5l15.8,9.2V57.3Z"
              transform="translate(3.3)"
            />
            <path
              id="Vector_199"
              data-name="Vector 199"
              class="cls-3"
              d="M298.9,47.5l-3.1-1.8v1.5l3.1,1.7Z"
              transform="translate(3.3)"
            />
          </g>
          <path
            id="Vector_200"
            data-name="Vector 200"
            class="cls-3"
            d="M313.1,58.4,295.8,48.3v1.6l17.3,9.9Z"
            transform="translate(3.3)"
          />
        </g>
      </g>
      <path
        class="melements cls-17"
        id="Screen_4"
        d="M372.7,37.1,353.2,25.9a1.3,1.3,0,0,0-1.9.5,1.1,1.1,0,0,0-.2.8V50.6a3.2,3.2,0,0,0,1.5,2.8l19.5,11.4a1.5,1.5,0,0,0,2.1-.7,1.4,1.4,0,0,0,.2-.6V40.2A3.6,3.6,0,0,0,372.7,37.1Z"
        transform="translate(3.3)"
      />
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState([
      "toggleConfig",
      "startConfig",
      "isAnimationDisabled",
      "viewportSize",
    ]),
  },
  mixins: [coords],
  props: {
    num: {
      type: [Number, String],
      default: 1,
    },
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    millionAnim() {
      let vm = this;
      let tl;
      const isScrollElConfig = {
        scrollTrigger: {
          trigger: `.million${vm.num}`,
          toggleActions: this.toggleConfig,
          start: this.startConfig,
        },
        defaults: {
          duration: 1.5,
          ease: "sine",
        },
      };

      if (vm.num === 1) {
        tl = gsap.timeline({
          defaults: {
            duration: 1.5,
            ease: "sine",
          },
        });
      } else {
        tl = gsap.timeline(isScrollElConfig);
      }

      tl.add(`million${vm.num}`)
        .from(
          ".whitebloop",
          {
            duration: 2,
            scale: 0,
            transformOrigin: "50% 50%",
            ease: "elastic.out(1.5, 0.3)",
          },
          `million${vm.num}`
        )
        .from(
          "#Base",
          {
            duration: 1,
            scale: 0.5,
            transformOrigin: "50% 50%",
            ease: "back",
          },
          `million${vm.num}`
        )
        .from(
          "#back-circle",
          {
            fill: "orange",
            duration: 2,
            ease: "sine",
          },
          `million${vm.num}`
        )
        .to(
          "#logo-clip, #one-clip, #dev-clip",
          {
            duration: 1,
            x: 22,
            y: -15,
            ease: "back",
          },
          `million${vm.num}+=1`
        )
        .from(
          ".melements",
          {
            duration: 0.5,
            opacity: 0,
            stagger: 0.05,
            scale: 0,
            ease: "back",
            transformOrigin: "50% 50%",
          },
          `million${vm.num}+=1`
        )
        .from(
          "#Right_Bolt",
          {
            duration: 1,
            rotation: 360,
            opacity: 0,
            scale: 0,
            ease: "back",
            transformOrigin: "50% 50%",
          },
          `million${vm.num}+=0.25`
        )
        .from(
          "#Left_Bolt",
          {
            duration: 1,
            rotation: -360,
            opacity: 0,
            scale: 0,
            ease: "back",
            transformOrigin: "50% 50%",
          },
          `million${vm.num}+=0.25`
        )
        .from(
          "#colorboc",
          {
            fill: "hsl(-200%, 0, 0)",
          },
          `million${vm.num}`
        )
        .from(
          "#side-arm-r",
          {
            duration: 0.5,
            rotation: -8,
            transformOrigin: "100% 50%",
            repeat: 5,
            yoyo: true,
            ease: "circ.in",
          },
          `million${vm.num}`
        )
        .from(
          "#side-arm-l",
          {
            duration: 0.5,
            rotation: -8,
            transformOrigin: "100% 50%",
            repeat: 5,
            yoyo: true,
            ease: "circ.in",
          },
          `million${vm.num}+=0.25`
        )
        .from(
          "#front-leg-r",
          {
            duration: 0.5,
            rotation: 10,
            transformOrigin: "50% 0%",
            repeat: 6,
            yoyo: true,
            ease: "sine.inOut",
          },
          `million${vm.num}`
        )
        .from(
          "#front-leg-l",
          {
            duration: 0.5,
            rotation: 10,
            transformOrigin: "50% 0%",
            repeat: 6,
            yoyo: true,
            ease: "sine.inOut",
          },
          `million${vm.num}+=0.25`
        )
        .from(
          "#side-bubbles g",
          {
            duration: 0.5,
            opacity: 0,
            scale: 0,
            stagger: 0.2,
            transformOrigin: "50% 50%",
            ease: "back",
          },
          `million${vm.num}+=2`
        );
    },
  },
  mounted() {
    this.millionAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1,
.cls-12 {
  fill: none;
}

.cls-2 {
  clip-path: url(#clip-path);
}

.cls-13,
.cls-16,
.cls-17,
.cls-3 {
  fill: #fff;
}

.cls-4 {
  fill: #0e1e25;
}

.cls-10,
.cls-15,
.cls-5 {
  fill: #ffad43;
}

.cls-6 {
  clip-path: url(#clip-path-2);
}

.cls-7 {
  fill: #00dc9f;
}

.cls-8 {
  clip-path: url(#clip-path-3);
}

.cls-9 {
  clip-path: url(#clip-path-4);
}

.cls-10 {
  stroke: #fff;
}

.cls-11 {
  fill: #caa677;
}

.cls-12,
.cls-13,
.cls-14,
.cls-15,
.cls-16,
.cls-17 {
  stroke: #0e1e25;
}

.cls-13,
.cls-15 {
  stroke-width: 0.91px;
}

.cls-14 {
  fill: #8e6f46;
}

.cls-16 {
  stroke-width: 0.6px;
}

.cls-17 {
  stroke-miterlimit: 10;
  stroke-width: 0.79px;
  opacity: 0.2;
  isolation: isolate;
}
</style>
